import { loadBriefingFlights, relevantBriefingFlights } from "../../briefing-flow/briefing-flow.loader";
import { seedUserRead } from "../../services/database/user-read-cache";
import { liveCalc } from "./calc-result-read";
import type { briefgFlowFlightStruct } from "../../briefing-flow/briefing-flow.model";
export * from "../../briefing-flow/briefing-flow.model";
import { evaluateAeoHoge } from "./hoge-aeo";
import { selectInstalledEquipment } from "./optional-equipment";
import { performanceStatus } from "./performance-status";
import * as paramCache from "./param-cache";
/* eslint-disable no-inner-declarations */
/* eslint-disable guard-for-in */
/* eslint-disable prefer-const */
/* eslint-disable new-cap */
/* eslint-disable camelcase */

import { fuelCalcReport, StartedFuelReads } from "./class/fuelCalcReport";
import { loadAndBalanceReport } from "./class/loadAndBalanceReport";
import { metarReport } from "./class/metarReport";
import { getDistance, navLegStruct, navLogReport, round } from "./class/navLogReport";
import { notamReport } from "./class/notamReport";
import { performanceReport } from "./class/performanceReport";
import { flightcrewRowId, rowIdFor } from "../../db/rowid";
import {
  CompanyCrewListStruct,
  CrewCargokeyValueStruct,
  FlightCrewStruct,
  PayLoadStruct,
  fccProvider,
  isMissingDutyId,
  payloadUnitEnum,
} from "./class/providers/fccProvider";
import {
  aircraftStruct,
  crusingSpeedRefStruct,
  fppProvider,
  transpEnum,
  typeOfFlightStruct,
  vertLevelRefStruct,
  wTurbCatEnum,
} from "./class/providers/fppProvider";
import { opsAocRulesProvider } from "./class/providers/opsAocRulesProvider";
import { fplTemplStruct, opsTemplateProvider } from "./class/providers/opsTemplateProvider";
import { opsCntrolCom } from "./com";
import {
  LiveValue,
  airportHeliportStruct,
  airportHeliportSearchStruct,
  appearanceEnum,
  availFx,
  dutyAuthStruct,
  flightRulesEnum,
  flightlistStruct,
  focSettingsStruct,
  fplState,
  limitsStruct,
  loadingElementDuty,
  loadingStruct,
  msgCatStruct,
  noSolutionAvail,
  opsMissionTypeEnum,
  parameterStruct,
  payloadCodeTypeEnum,
  perfResultsEnum,
  processResultStateEnum,
  property,
  targetPlatformEnum,
} from "./dataStruct";
import {
  SQLifyString,
  addParameter,
  calcPressureAltitude,
  checkArgLength,
  checkFlightIdValid,
  checkFlightNumberExists,
  currentSignatureId,
  deleteAllParameters,
  drawConsoleTable,
  execAccuParameters,
  getLocalTime,
  getParameter,
  getParameterOfArray,
  getParameterValue,
  getParametersArray,
  getParametersArrayBulk,
  getSqlDateTime_yyyymmdd_hhmm,
  getSqlDate_yyyymmdd,
  getUtcTime,
  isBenignLwwReject,
  isToday,
  markDownProcessing,
  padLeft,
  parseCss,
  queueCommand,
  queueParameter,
  setCom,
  svgDiagramDataStruct,
  svgPointStruct,
  translateToFplCoordinates,
  getDistance as getDistanceNm,
} from "./functions";
import { loadingElementUid } from "./loading-element-key";
import { flightsToPurge } from "./flight-cleanup";
import { buildCalcResult, CalcElement, CalcFigures, valuesFromParams } from "./calc-result";

export let classCom: opsCntrolCom;

export let classNavProvider: navLogReport;

/** A Create for a mission whose flight exists is refused, on every device. */
export const MISSION_FLIGHT_EXISTS = "the flight for this mission already exists. Delete it to create it again.";

export class focMain {
  public frameworkVersion: string = "ops-control-framework: -FOC v0.5";

  public classSettings: focSettingsStruct;
  public targetPlatform: targetPlatformEnum;

  // this message might be displayed during progress is true
  public progressMessage: string = "";

  public dutyLimits_latch: any = [];
  public acftReg_latch: string = "";
  private dutyLimitsIdent = "";

  // register this constructor as an app module
  constructor(
    env: targetPlatformEnum,
    sourceManager: any,
    package_fs: any,
    package_open: any,
    package_md5: any,
    package_Showdown: any,
    package_sunriseSunset: any
  ) {
    classCom = new opsCntrolCom();

    // that is to be changed on the app to --> na
    this.targetPlatform = env;

    classCom.init(
      this.targetPlatform,
      sourceManager,
      appearanceEnum.dark,
      package_fs,
      package_open,
      package_md5,
      package_Showdown,
      package_sunriseSunset
    );

    //set the classCom

    this.classSettings = new focSettingsStruct();
    classNavProvider = new navLogReport(classCom);
    setCom(classCom);
  }

  public setAircraftReg(reg: string) {
    classCom.aircraftRegistration = reg.toUpperCase();
    console.log("FOC: set aircraft reg to: " + reg.toUpperCase());
  }

  public setAppearance(appAppearance: appearanceEnum) {
    classCom.appearance = appAppearance;
  }

  // this makes the console input to work
  async functionProcessor(argIn: string): Promise<boolean> {
    // otherwise its anoyying to reset the messages in the console :)
    if (classCom.targetPlatform == targetPlatformEnum.server) {
      classCom.clearMessage();
    }

    const fxName: string = argIn.split(" ")[0];
    let fxFound: boolean = false;
    availFx.forEach(function (value) {
      if (value.startsWith(fxName + "(", 0)) {
        fxFound = true;
      }
    });

    if (fxFound == false) {
      console.log("function not found! " + fxName + "!");
      return false;
    }

    const codeWithoutFxName: string = argIn.replace(fxName, "");
    const paraSplit: string[] = codeWithoutFxName.split(" -").filter((word) => word !== "");

    // make sure initialization was done before.
    if (
      classCom.aircraftRegistration == "" &&
      !fxName.includes("init") &&
      !fxName.includes("setAircraftReg") &&
      !fxName.includes("ac")
    ) {
      console.warn("Aircraft registration not set! Please use setAircraftReg -XXXXX or initFlight() first.");
      return false;
    }

    try {
      switch (fxName) {
        case "setAircraftReg":
        case "ac": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;
          this.setAircraftReg(paraSplit[0].trim());
          break;
        }

        case "getHoistRatingLoadOfAllActiveMissionTypes_ofDuty": {
          if (!checkArgLength(fxName, paraSplit.length, 5)) return false;

          const dutyId = paraSplit[0].trim();
          const fuelLoading = Number(paraSplit[1].trim());
          const extraweight = Number(paraSplit[2].trim());
          const personsAboard = Number(paraSplit[3].trim());
          const opsMissionTypesSelected = paraSplit[4].trim();
          const osmSel = opsMissionTypesSelected.split(",").map((s) => s.trim());
          const mappedValues = osmSel
            .map((key) => opsMissionTypeEnum[key as keyof typeof opsMissionTypeEnum])
            .filter((v): v is opsMissionTypeEnum => v !== undefined); // removes undefined

          const mandb = new mAndBandPerformance();
          const hoistRating = await mandb.getHoistRatingLoadOfAllActiveMissionTypes_ofDuty(
            dutyId,
            fuelLoading,
            extraweight,
            personsAboard,
            mappedValues
          );
          console.log("- Hoist Rating:", hoistRating);

          return hoistRating !== null && hoistRating !== undefined;
          break;
        }

        case "getHoistRatingLoadOfOpsMissionTypeAndLmc": {
          if (!checkArgLength(fxName, paraSplit.length, 5)) return false;

          const dutyId = paraSplit[0].trim();
          const opsMissionTypeStr = paraSplit[1].trim().toLowerCase();
          const fuelLoading = Number(paraSplit[2].trim());
          const extraweight = Number(paraSplit[3].trim());
          const personsAboard = Number(paraSplit[4].trim());

          // Convert string to enum
          const opsMissionTypeIndex = Object.keys(opsMissionTypeEnum)
            .filter((k) => isNaN(Number(k))) // remove numeric keys
            .find((k) => k.toLowerCase() === opsMissionTypeStr);

          if (!opsMissionTypeIndex) {
            console.log("Invalid opsMissionTypeEnum value: " + opsMissionTypeStr);
            return false;
          }

          const opsMissionTypeEnumValue = opsMissionTypeEnum[opsMissionTypeIndex as keyof typeof opsMissionTypeEnum];
          const mandb = new mAndBandPerformance();
          const hoistRating = await mandb.getHoistRatingLoadOfOpsMissionTypeAndLmc(
            dutyId,
            opsMissionTypeEnumValue,
            fuelLoading,
            extraweight,
            personsAboard
          );
          console.log("- Hoist Rating:", hoistRating);

          return hoistRating !== null && hoistRating !== undefined;
          break;
        }

        case "getHoistRatingLoadOfAllActiveMissionTypes_forFlight": {
          if (!checkArgLength(fxName, paraSplit.length, 5)) return false;

          const flightId = paraSplit[0].trim();
          const fuelLoading = Number(paraSplit[1].trim());
          const extraweight = Number(paraSplit[2].trim());
          const personsAboard = Number(paraSplit[3].trim());
          const opsMissionTypesSelected = paraSplit[4].trim();
          const osmSel = opsMissionTypesSelected.split(",").map((s) => s.trim());
          const mappedValues = osmSel
            .map((key) => opsMissionTypeEnum[key as keyof typeof opsMissionTypeEnum])
            .filter((v): v is opsMissionTypeEnum => v !== undefined); // removes undefined

          const mandb = new mAndBandPerformance();
          const hoistRating = await mandb.getHoistRatingLoadOfAllActiveMissionTypes_forFlight(
            flightId,
            extraweight,
            personsAboard,
            mappedValues
          );
          console.log("- Hoist Rating:", hoistRating);

          return hoistRating !== null && hoistRating !== undefined;
          break;
        }

        case "estimateMassAndBalance": {
          if (!checkArgLength(fxName, paraSplit.length, 6)) return false;

          // Extract and parse the arguments
          const missionTypeStr = paraSplit[1].trim().toLowerCase();
          const extraWeight = Number(paraSplit[2].trim());
          const personsOnBoard = Number(paraSplit[3].trim());
          const fuelOnBoard = Number(paraSplit[4].trim());
          const aircraftRegistration = paraSplit[5].trim();
          const flightCrewId = paraSplit[0].trim();
          console.log("- Flight Crew ID:", flightCrewId);
          console.log("- Mission Type:", missionTypeStr);
          console.log("- Extra Weight:", extraWeight);
          console.log("- Persons On Board:", personsOnBoard);
          console.log("- Fuel On Board:", fuelOnBoard);
          console.log("- Aircraft Registration:", aircraftRegistration);

          // Convert string to enum
          const missionTypeIndex = Object.keys(opsMissionTypeEnum)
            .filter((k) => isNaN(Number(k))) // remove numeric keys
            .find((k) => k.toLowerCase() === missionTypeStr);

          if (!missionTypeIndex) {
            console.log("Invalid opsMissionTypeEnum value: " + missionTypeStr);
            return false;
          }

          const missionTypeEnumValue = opsMissionTypeEnum[missionTypeIndex as keyof typeof opsMissionTypeEnum];

          const mandb = new mAndBandPerformance();
          const qqq = await mandb.estimateMassAndBalance(
            flightCrewId,
            missionTypeEnumValue,
            extraWeight,
            classCom,
            personsOnBoard,
            fuelOnBoard,
            aircraftRegistration
          );

          console.log("results: " + JSON.stringify(qqq));

          return qqq !== null && qqq !== undefined;
          break;
        }
        case "authorizeDutyLimits": {
          if (!checkArgLength(fxName, paraSplit.length, 7)) return false;

          const dutyFrom = getSqlDateTime_yyyymmdd_hhmm(paraSplit[4].trim());
          const dutyTo = getSqlDateTime_yyyymmdd_hhmm(paraSplit[5].trim());
          const pin = paraSplit[6].trim();
          const parameters = paraSplit[3].trim();
          const missionLimitJsonFilename = paraSplit[2].trim();
          let rawJson: string;
          try {
            const fs = classCom.package_fs;
            rawJson = fs.readFileSync(missionLimitJsonFilename, "utf8");
            console.log(rawJson);
          } catch (err) {
            console.error("err #1fse32 " + err);
          }

          const missionLimitJson = await JSON.parse(rawJson);
          const pic = paraSplit[1].trim();
          const crewDesig = paraSplit[0].trim();

          if ((dutyFrom == null || dutyTo == null) && dutyTo < dutyFrom) {
            return false;
          } else {
            // this needs to be updated
            const q = await this.authorizeDutyLimits(
              crewDesig,
              pic,
              missionLimitJson,
              parameters,
              dutyFrom,
              dutyTo,
              pin
            );
            return q != "";
          }
          break;
        }
        case "getDutyLimits": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const pin: string = paraSplit[0];

          if (pin == null || pin == "") {
            console.log("getDutyLimits: check your arguments!");
            return false;
          } else {
            // this needs to be updated
            const q = await this.getDutyLimits(pin);
            console.log(JSON.stringify(q));
            return q != null;

            break;
          }
        }
        case "initFlightShort": {
          if (!checkArgLength(fxName, paraSplit.length, 10)) return false;

          const depTime = getSqlDateTime_yyyymmdd_hhmm(paraSplit[5]);
          if (depTime == null) {
            return false;
          } else {
            // added this as was never set, 2015-04-18
            this.setAircraftReg(paraSplit[1].trim());

            const q = await this.initFlightShort(
              paraSplit[0].trim(),
              paraSplit[1].trim(),
              paraSplit[2].trim(),
              paraSplit[3].trim(),
              paraSplit[4].trim(),
              depTime,
              (<any>flightRulesEnum)[paraSplit[6].trim().toLocaleUpperCase()],
              paraSplit[7].trim(),
              paraSplit[8].trim(),
              paraSplit[9].trim()
            );
            return q == "";

            break;
          }
        }
        case "initFlightOfDuty": {
          if (paraSplit.length > 7 || paraSplit.length < 5) {
            console.log("initFlightOfDuty: check your arguments!");
            return false;
          }
          const depTime = getSqlDateTime_yyyymmdd_hhmm(paraSplit[4]);
          let selDutyDesig: string;
          try {
            selDutyDesig = paraSplit[6];
          } catch (err) {
            /* empty */
          }

          if (depTime == null) {
            return false;
          } else {
            // added this as was never set, 2015-04-18
            this.setAircraftReg(paraSplit[0].trim());

            const q = await this.initFlightOfDuty(
              paraSplit[0].trim(),
              paraSplit[1].trim(),
              paraSplit[2].trim(),
              paraSplit[3].trim(),
              depTime,
              paraSplit[5].trim(),
              selDutyDesig
            );

            return q !== "";

            break;
          }
        }
        case "initFlight": {
          if (!checkArgLength(fxName, paraSplit.length, 16)) return false;

          const depTime = getSqlDateTime_yyyymmdd_hhmm(paraSplit[5]);
          if (depTime == null) {
            return false;
          } else {
            // added this as was never set, 2015-04-18
            this.setAircraftReg(paraSplit[1].trim());

            const q = await this.initFlight(
              paraSplit[0].trim(),
              paraSplit[1].trim(),
              paraSplit[2].trim(),
              paraSplit[3].trim(),
              paraSplit[4].trim(),
              depTime,
              (<any>flightRulesEnum)[paraSplit[6].trim().toLocaleUpperCase()],
              paraSplit[7].trim(),
              paraSplit[8].trim(),
              paraSplit[9].trim(),
              (<any>typeOfFlightStruct)[paraSplit[10].trim().toLocaleUpperCase()],
              paraSplit[11].trim(),
              (<any>typeOfFlightStruct)[paraSplit[12].trim().toLocaleUpperCase()],
              paraSplit[13].trim(),
              paraSplit[14].trim(),
              paraSplit[15].trim(),
              parseInt(paraSplit[16].trim())
            );
            return q != "";

            break;
          }
        }
        case "listAllFlights": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          const dDate = getSqlDate_yyyymmdd(paraSplit[0]);
          if (dDate == null) {
            return false;
          } else {
            this.listAllFlights(dDate, paraSplit[1]).catch((err) => console.error("listAllFlights: ", err));

            break;
          }
        }
        case "deleteFlight": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.deleteFlight(paraSplit[0]);

          if (!success) {
            console.log("no flight matched your query!");
          }
          return success !== null && success !== undefined;
          break;
        }
        case "delayFlight": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          try {
            const delayMin = parseInt(paraSplit[2]);
            const success = await this.delayFlight(paraSplit[0], paraSplit[1], delayMin);
            if (!success) {
              console.log("no flight matched your query!");
            }
          } catch (err) {
            console.log("error during delayFlight() " + err);
          }

          break;
        }
        case "bringFlightForward": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;
          const delayMin = parseInt(paraSplit[2]);
          const success = await this.bringFlightForward(paraSplit[0], paraSplit[1], delayMin);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeOrigin": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          const success = await this.changeOrigin(paraSplit[0], paraSplit[1], paraSplit[2]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeDestination": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          const success = await this.changeDestination(paraSplit[0], paraSplit[1], paraSplit[2]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeAlternate": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          const success = await this.changeAlternate(paraSplit[0], paraSplit[1], paraSplit[2]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeFlightRules": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          const flightRulesNew: flightRulesEnum = flightRulesEnum[paraSplit[2]];
          const success = await this.changeFlightRules(paraSplit[0], paraSplit[1], flightRulesNew);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "addRevertFlight": {
          if (!checkArgLength(fxName, paraSplit.length, 5)) return false;

          const newDepTime: Date = getSqlDateTime_yyyymmdd_hhmm(paraSplit[2]);
          const success = await this.addRevertFlight(
            paraSplit[0],
            paraSplit[1],
            newDepTime,
            paraSplit[3],
            paraSplit[4]
          );
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeAircraft": {
          if (!checkArgLength(fxName, paraSplit.length, 4)) return false;

          const success = await this.changeAircraft(paraSplit[0], paraSplit[1], paraSplit[2], paraSplit[3]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "changeFlightNumber": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          const success = await this.changeFlightNumber(paraSplit[0], paraSplit[1], paraSplit[2]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "setActualBlocksOffTime": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.setActualBlocksOffTime(paraSplit[0]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "setActualDepartureTime": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.setActualDepartureTime(paraSplit[0]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "setActualArrivalTime": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.setActualArrivalTime(paraSplit[0]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "setActualBlocksOnTime": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.setActualBlocksOnTime(paraSplit[0]);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "findAirport": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.findAirport(paraSplit[0], [0, 0], undefined);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "nearestAirportHeliport": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          let cSplit: number[] = [];
          cSplit = paraSplit[0].split[","];
          const coords: number[] = [];
          coords[0] = cSplit[0];
          coords[1] = cSplit[1];
          const success = await this.nearestAirportHeliport(coords, undefined);
          if (!success) {
            console.log("no flight matched your query!");
          }
          break;
        }
        case "getAircraftRegistrations": {
          if (!checkArgLength(fxName, paraSplit.length, 0)) return false;

          const success = await this.getAircraftRegistrations();
          if (!success) {
            console.log("warn: no results returned!");
          }
          break;
        }
        case "getAircraftData": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          const success = await this.getAircraftData(paraSplit[0]);
          if (!success) {
            console.log("warn: no results returned!");
          }

          return success !== null && success !== undefined;
          break;
        }
        case "getCurrentFlightCrew": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const newDepTime: Date = getSqlDateTime_yyyymmdd_hhmm(paraSplit[0].trim());
            const aircraftRegistration: string = paraSplit[1].trim();
            const success = await this.getCurrentFlightCrew(newDepTime.getTime(), aircraftRegistration);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("cant parse time of argument! " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getCompanyCrewList": {
          if (!checkArgLength(fxName, paraSplit.length, 0)) return false;

          try {
            const success = await this.getCompanyCrewList();
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("cant parse time of argument! " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getCrewAndCargo": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();
            const success = await this.getCrewAndCargo(dutyId);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getListCargoConfigs": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();
            const parameter: string = paraSplit[1].trim();
            const success = await this.getListCargoConfigs(dutyId, parameter);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getBookedCargo": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();
            let paraFilter: string = undefined;
            try {
              paraFilter = paraSplit[1].trim();
            } catch (err) {
              /* empty */
            }

            const success = await this.getBookedCargo(dutyId, paraFilter);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getBookedPassengers": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();

            const success = await this.getBookedPassengers(dutyId);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getLoadsheetPassengers": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getLoadSheetPassengers(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getLoadsheetCargo": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getLoadedCargo(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getAircraftCrew": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getAircraftCrew(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getemptySeats": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getEmptySeats(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getNbrOfSeats": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getNbrOfSeats(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success > 0;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getMaxUsableFuelCapacityOfAircraft": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getMaxUsableFuelCapacityOfAircraft(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getCurrentBlockFuelOfAircraft": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const reg: string = paraSplit[0].trim();

            const success = await this.getCurrentBlockFuelOfAircraft(reg);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getBookedPassengersNotOnAircraft": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();

            const success = await this.getBookedPassengersNotOnAircraft(dutyId);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getBookedCargoNotOnAircraft": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();

            const success = await this.getBookedCargoNotOnAircraft(dutyId);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "pushCrewAndCargoToAcft": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();
            const crewCargo: CrewCargokeyValueStruct[] = [];
            const success = await this.pushCrewAndCargoToAcft(dutyId, crewCargo);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }

          break;
        }
        case "getFplTemplates": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const dutyId: string = paraSplit[0].trim();

            const success = await this.getFplTemplates(dutyId);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "initMassAndBalance": {
          if (!checkArgLength(fxName, paraSplit.length, 4)) return false;

          try {
            const flightId: string = paraSplit[0].trim();
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];
            const parameters: string = paraSplit[2].trim();
            const personsAboard: number = parseInt(paraSplit[3].trim());

            const checksum = await this.getConditionHashOfFlight(flightId);

            const wbaperf = new mAndBandPerformance();
            const success = await wbaperf.initMassAndBalance(
              flightId,
              opsMissionType,
              parameters,
              0,
              personsAboard,
              0,
              checksum
            );
            if (!success) {
              console.log("warn: no results returned! " + wbaperf.lastError);
            }
            // `success !== null && success !== undefined` is true for a genuine
            // `false`, so this reported an aborted, rolled-back W&B as a
            // completed one — the same masking the rest of this series removes.
            return success === true;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getLoadAndBalanceHtmlReport": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const flightId: string = paraSplit[0].trim();
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];

            const success = await this.getLoadAndBalanceHtmlReport(flightId, opsMissionType);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "initPerformance": {
          if (!checkArgLength(fxName, paraSplit.length, 8)) return false;

          try {
            const perf = new performance();
            const flightId: string = paraSplit[0].trim();
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];
            const checksum = await this.getConditionHashOfFlight(flightId);
            const origin_oat: number = Number(paraSplit[2].trim().replace("M", "-")) + 273.15; // convert to kelvin
            const dest_oat: number = Number(paraSplit[3].trim().replace("M", "-")) + 273.15; // convert to kelvin
            const origin_qnh: number = Number(paraSplit[4].trim()) * 100; // convert to pascal
            const dest_qnh: number = Number(paraSplit[5].trim()) * 100; // convert to pascal
            const origin_elev: number = Number(paraSplit[6].trim()) * 0.3048; // convert to meters
            const dest_elev: number = Number(paraSplit[7].trim()) * 0.3048; // convert to meter

            const success = await perf.initPerformance(
              flightId,
              opsMissionType,
              classCom,
              checksum,
              origin_elev,
              dest_elev,
              origin_oat,
              dest_oat,
              origin_qnh,
              dest_qnh
            );
            if (!success) {
              console.log("warn: no results returned! " + perf.lastError);
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getPerformanceHtml": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const flightId: string = paraSplit[0].trim();
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];
            const success = await this.getPerformanceHtml(flightId, opsMissionType);
            if (!success) {
              console.log("warn: no results returned!");
            }
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "initNav": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const flightId: string = paraSplit[0].trim();
            const terrDataUrl: string = paraSplit[1].trim();

            const nav = new navigationalFeatures();

            console.log("xxxx err:  " + flightId + " " + terrDataUrl);
            const success = await nav.initNav(flightId, classCom, terrDataUrl);
            if (!success) {
              console.log("warn: no results returned!");
            }

            return true;
          } catch (err) {
            console.log("xxxx err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "initFuel": {
          if (!checkArgLength(fxName, paraSplit.length, 3)) return false;

          try {
            const flightId: string = paraSplit[0].trim();
            const fuelOnBoard: number = parseInt(paraSplit[2]);
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];

            const fuel = new fuelFeatures();
            const checksum = await this.getConditionHashOfFlight(flightId);
            const success = await fuel.initFuel(flightId, classCom, checksum, opsMissionType, fuelOnBoard);

            if (!success) {
              console.log("warn: no results returned! " + fuel.lastError);
            }

            // Same fix as the initMassAndBalance case: the old expression was
            // true for a genuine `false`, which initFuel can now actually return.
            return success === true;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getAircraftDataHtml": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const registration: string = paraSplit[0].trim();
            const success = await this.getAircraftDataHtml(registration);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "initNotam": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const notam = new notamFeatures();
            const checksum = await this.getConditionHashOfFlight(flightId);
            const success = await notam.initUpdateNotam(flightId, classCom, checksum);
            if (!success) {
              console.log("no results!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("cant parse argument! " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getNotamHtml": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const success = await this.getNotamHtml(flightId);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "initMet": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const notam = new metFeatures();
            const checksum = await this.getConditionHashOfFlight(flightId);
            const success = await notam.initUpdateMet(flightId, classCom, checksum);
            if (!success) {
              console.log("no results!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("cant parse argument! " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getMetHtml": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const success = await this.getMetHtml(flightId);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getCrewHtml": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const newDepTime: Date = getSqlDateTime_yyyymmdd_hhmm(paraSplit[0].trim());
            const aircraftRegistration: string = paraSplit[1].trim();

            const success = await this.getCrewHtml(newDepTime, aircraftRegistration);
            if (!success) {
              console.log("warn: no results returned!");
            }

            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getNavHtmlReport": {
          if (!checkArgLength(fxName, paraSplit.length, 1)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const nav = new navLogReport(classCom);
            const success = await nav.getNavHtmlReport(flightId);
            if (!success) {
              console.log("warn: no results returned!");
            }
            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }
        case "getFuelHtmlReport": {
          if (!checkArgLength(fxName, paraSplit.length, 2)) return false;

          try {
            const flightId: string = paraSplit[0].trim();

            const fuel = new fuelCalcReport();
            const opsMissionType: opsMissionTypeEnum = opsMissionTypeEnum[paraSplit[1].trim()];
            const success = await fuel.getFuelReport(flightId, opsMissionType, classCom, false);
            if (!success) {
              console.log("warn: no results returned!");
            }

            return success !== null && success !== undefined;
          } catch (err) {
            console.log("err:  " + paraSplit[0] + " " + err);
          }
          break;
        }

        case "getBriefgFlowOfFlight":
          {
            if (paraSplit.length != 4 && paraSplit.length != 1) {
              console.log("getBriefgFlowOfFlight: check your arguments!");
              return false;
            }

            if (paraSplit.length == 1) {
              console.log("info: no tool ids provided, continue without, results degraded.");
            }

            let webcamToolId: number = 0;
            let weatherToolId: number = 0;
            let webcamLiveBaseUrl: string = "";

            const author: string = paraSplit[0].trim();
            if (paraSplit.length == 4) {
              webcamToolId = parseInt(paraSplit[1].trim());
              weatherToolId = parseInt(paraSplit[2].trim());
              webcamLiveBaseUrl = paraSplit[3].trim();
            }

            const allFlightsByThisAuthor = await this.listAllFlights(new Date(), author);
            const brfflg = new briefingFlowFeatures();
            await brfflg.getBriefgFlowOfFlight(
              allFlightsByThisAuthor,
              classCom,
              webcamLiveBaseUrl,
              webcamToolId,
              weatherToolId
            );
            console.log("info: briefing flow function worked.");
          }

          return true;
      }
    } catch (error) {
      console.log("error running function: " + fxName + " " + error);
      return false;
    }
  }

  // general Flightops functions
  // ----------------------------------------------------- //
  async authorizeDutyLimits(
    crewDesig: string,
    picName: string,
    missionLimits: limitsStruct,
    parameters: string,
    dutyFrom: Date,
    dutyTo: Date,
    pin: string
  ): Promise<string> {
    const ident = pin + "-" + classCom.aircraftRegistration;
    const creationDate = getUtcTime(new Date()).getTime();
    const flightCrewId = classCom.package_md5(crewDesig + "|" + creationDate).substring(0, 20);

    // Repeatable-signing sync rowId: `created` is in the key, so every sign of
    // this Dienstplan mints a FRESH rowId and lands as a NEW signature record
    // instead of colliding with the last one. Composed via flightcrewRowId
    // rather than a hand-rolled rowIdFor([...]) so this site cannot drift from
    // ROWID_KEY_SPEC ["ident", "dutyFrom", "created"] — it did exactly that
    // once, silently, and rowid.spec.ts now pins the helper against the spec.
    //
    // Under the previous key ["ident", "dutyFrom"] a re-sign recomputed the SAME
    // rowId. That was survivable only while the server rejected the collision
    // (`flightcrewSignatureCheck`, first-writer-wins), and that gate was removed
    // on 2026-08-13. The server REJECTS such a write again since 2026-08-14, on
    // different grounds: `pilotInCommand`, `signature`, `created`, `ident` and
    // `dutyFrom` are immutableOnConflict, and an upsert offering a DIFFERENT
    // value for any of them is refused outright (`immutable`) rather than
    // half-applied and ACKed (efb-app-server sync/ops.ts). Repeatability costs
    // nothing — `created` is in the key, so a genuine re-sign lands on a fresh
    // row and never meets the clause. LOCALLY there is no such protection:
    // flightcrewCreate's ON CONFLICT(rowId) DO UPDATE still overwrites those
    // columns in place, so a colliding write diverges the device from the
    // server. `isImmutableReject` in the sign path is what keeps that visible.
    //
    // flightCrewId stays the flightlist join key and is NOT part of the rowId.
    const dutyFromMs = dutyFrom.getTime();
    const rowId = flightcrewRowId(ident, dutyFromMs, creationDate);

    const missionLimitsJson = JSON.stringify(missionLimits);

    const sHash = "13030d3b776ba930c1fcf399fb809a6dc2e2b7b6";
    const signature = classCom.package_md5(pin + "|" + sHash + "|" + missionLimitsJson);

    await classCom.namedCommand("flightcrewCreate", {
      rowId,
      flightCrewId,
      crewDesignator: crewDesig,
      pilotInCommand: picName,
      missionLimits: missionLimitsJson,
      parameters,
      ident,
      dutyFrom: dutyFromMs,
      dutyTo: dutyTo.getTime(),
      created: creationDate,
      signature,
      updatedAt: Date.now(),
    });

    // A fresh signature must be visible at once. getDutyLimitsIfAlreadySignedAndStillvalid
    // caches the previous read, so without this a re-sign is invisible until the latch
    // expires on its own.
    this.dutyLimits_latch = [];

    return;
  }

  SQLifyString(value: string): string {
    return String(value).replace(/'/g, "''");
  }

  sqliteString(value: string | null | undefined): string {
    if (value === null || value === undefined) return "NULL";
    return "'" + String(value).replace(/'/g, "''") + "'";
  }

  sqliteNumber(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) return "NULL";
    return String(value);
  }

  async getDutyLimits(pin: string): Promise<dutyAuthStruct> {
    try {
      const ident: string = pin + "-" + classCom.aircraftRegistration;
      const [rows, windows] = await Promise.all([
        classCom.namedQuery("flightcrewByIdentLatest", { ident }),
        classCom.namedQuery("flightcrewDutyByIdent", { ident }),
      ]);

      // No signed flightcrew row for this ident (common on web — the duty may be
      // unsigned, or no crew seeded). Return cleanly instead of dereferencing
      // rows[0] and throwing into the catch (which then logged a scary error).
      if (!rows?.[0]) return undefined;

      const jsonStr: string = rows[0].missionLimits.replace(/�/g, '"');
      const jsonObj = JSON.parse(jsonStr);

      const retStructure: dutyAuthStruct = new dutyAuthStruct();

      retStructure.signature = rows[0].signature;
      retStructure.dutyFrom = Number(windows?.[0]?.dutyFrom);
      retStructure.dutyTo = Number(windows?.[0]?.dutyTo);
      retStructure.pilotInCommand = rows[0].pilotInCommand;
      retStructure.flightCrewId = rows[0].flightCrewId;
      retStructure.crewDesignator = rows[0].crewDesignator;
      retStructure.crewDesignator = rows[0].crewDesignator;
      retStructure.parameters = rows[0].parameters;

      retStructure.missionLimits = new limitsStruct();
      retStructure.missionLimits.extraWeight = parseInt(jsonObj.extraWeight);
      retStructure.missionLimits.extraFuel = parseInt(jsonObj.extraFuel);
      retStructure.missionLimits.standardFuel = parseInt(jsonObj.standardFuel);
      retStructure.missionLimits.qnh = parseInt(jsonObj.qnh);
      retStructure.missionLimits.oat = parseInt(jsonObj.oat);
      return retStructure;
    } catch (err) {
      console.log("*** getDutyLimits..ERR " + err);
    }
  }

  // control briefing update (depending on flightstate and time to EOBT)
  private async getLastBriefingCreationDate(flightId: string): Promise<Date> {
    const lastUpdate = await getParameter(
      flightId,
      "flightlist",
      property.lastBriefingCreation,
      opsMissionTypeEnum.all
    );

    // the notSetCase
    if (lastUpdate == undefined) {
      return new Date(0);
    }

    try {
      let date: Date = new Date(parseInt(lastUpdate[0].value));
      return date;
    } catch (err) {
      console.log("warn: could not fetch lastBriefingDate()");
    }
  }

  async setLastBriefingCreationDate(flightId: string, date: Date): Promise<boolean> {
    try {
      await addParameter(
        flightId,
        "flightlist",
        property.lastBriefingCreation,
        opsMissionTypeEnum.all,
        date.getTime().toString(),
        "",
        "",
        "",
        "",
        false
      );
      return true;
    } catch (err) {
      console.log("could not set lastBriefingCreationDate " + err);
      return false;
    }
  }

  /**
   * Takes the flight from `listAllFlights`, not its id: the landing time is
   * already on it. Run it inside `withParamCache` after `listAllFlights`, and the
   * two param reads below are served from that one bulk read.
   */
  async checkNewBriefingCreationRequired(flight: flightlistStruct): Promise<boolean> {
    const flightId = flight.flightId;
    const flightlistParams = await getParametersArray(flightId, "flightlist", opsMissionTypeEnum.all);

    // if landed dont do anything
    try {
      if (flight.actArrTime !== undefined) {
        return;
      }

      const estArrTime = getParameterOfArray(flightId, "flightlist", property.estTimeArr, flightlistParams)[0].value;
      const diffTicks_arrTime = new Date().getTime() - parseInt(estArrTime);
      const min2Arr = Math.floor(diffTicks_arrTime / 1000 / 60);
      if (min2Arr > 60) {
        return;
      }

      // fetch last briefing first
      let lastBriefing: Date = await this.getLastBriefingCreationDate(flightId);

      // if eobt is more than two hours ahead, trigger only hourly
      const estDep = getParameterOfArray(flightId, "flightlist", property.estTimeDep, flightlistParams)[0].value;

      const diffTicks = new Date().getTime() - parseInt(estDep);
      const min2Eobt = Math.floor(diffTicks / 1000 / 60);

      // trigger only after at 52/07/22/37/  in a 5 min time window
      let d = new Date();
      let withinRange: boolean = false;
      if (d.getMinutes() >= 52 && d.getMinutes() < 55) {
        withinRange = true;
      }
      if (d.getMinutes() >= 7 && d.getMinutes() < 12) {
        withinRange = true;
      }
      if (d.getMinutes() >= 22 && d.getMinutes() < 27) {
        withinRange = true;
      }
      if (d.getMinutes() >= 37 && d.getMinutes() < 42) {
        withinRange = true;
      }
      // for the case < 120 min
      // last briefing min hour min old
      if (lastBriefing == undefined) {
        return true;
      }
      const diffTicks_lastBriefing = new Date().getTime() - lastBriefing.getTime();
      const minSinceLastBriefing = Math.floor(diffTicks_lastBriefing / 1000 / 60);
      if (withinRange) {
        if (min2Eobt < 120) {
          if (minSinceLastBriefing > 10) {
            return true;
          }
          return false;
        }
      } else {
        if (minSinceLastBriefing > 50) {
          return true;
        }
      }
    } catch (err) {
      console.log("warn: 302890");
    }
    return false;
  }

  async updateBriefingDocuments(flightId: string) {
    try {
      const notam = new notamFeatures();
      const wx = new metFeatures();

      // The NOTAM half and the MET half read the same flight and route.
      await paramCache.withParamCache(async () => {
        await notam.initUpdateNotam(flightId, classCom, "");
        await wx.initUpdateMet(flightId, classCom, "");
      });

      await this.setLastBriefingCreationDate(flightId, new Date());
    } catch (err) {
      console.log("warn: couldnt update briefing docs!");
    }
  }

  /**
   * Retract the reports that a stopped calculation chain has left stale, for one
   * flight+mission. Both are soft-obsoleted, so the previous version survives as
   * history and the next successful pass appends a fresh one.
   *
   * Deliberately typed as a list of catalog command names rather than two hand-
   * written blocks: each command must run even if an earlier one throws, and a
   * throw here must not replace the caller's real failure.
   */
  private async retractDownstreamCalculations(flightId: string, opsMissionType: opsMissionTypeEnum): Promise<void> {
    for (const name of ["loadingObsoleteByFlightMission", "perfObsoleteByFlightMission"] as const) {
      try {
        await classCom.namedCommand(name, { flightId, opsMissionType });
      } catch (e: unknown) {
        console.error("namedCommand " + name + ": ", e);
      }
    }
  }

  /**
   * The chain reads the same parameter scopes over and over — each step asks
   * for one parameter at a time, and on the web every read is an HTTP round
   * trip. Running it inside `withParamCache` serves the repeats from memory;
   * `addParameter` writes through, so a step still reads what the step before
   * it wrote. The cache dies with this call, so nothing it held can go stale
   * against a later peer write.
   */
  async updateOfpCalculations(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    extraWeight: number,
    origin_elevation: number,
    dest_elevation: number,
    origin_oat: number,
    dest_oat,
    origin_qnh: number,
    dest_qnh: number,
    checksum: string
  ): Promise<boolean> {
    return paramCache.withParamCache(() =>
      this.updateOfpCalculationsInner(
        flightId,
        opsMissionType,
        extraWeight,
        origin_elevation,
        dest_elevation,
        origin_oat,
        dest_oat,
        origin_qnh,
        dest_qnh,
        checksum
      )
    );
  }

  private async updateOfpCalculationsInner(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    extraWeight: number,
    origin_elevation: number,
    dest_elevation: number,
    origin_oat: number,
    dest_oat,
    origin_qnh: number,
    dest_qnh: number,
    checksum: string
  ): Promise<boolean> {
    // The three steps are a CHAIN, not three independent jobs: mass and balance
    // reads the fuel figures, and performance reads the mass figures. Each one
    // already returns a boolean; this method used to `await` all three and drop
    // every result, so a failed fuel run fed its rolled-back state straight into
    // mass and balance, and a failed mass and balance into performance — which
    // then published a HOGE margin computed from numbers no step vouched for.
    //
    // Stopping here is the general fix. `initPerformance`'s liveness guard is
    // the specific one and stays: it catches a stale live row arriving by any
    // other route. Neither replaces the other.
    const fuel = new fuelFeatures();
    const mab = new mAndBandPerformance();
    const perf = new performance();

    // Stopping is not enough on its own: `loading` and `perf` are read
    // INDEPENDENTLY, so a skipped step leaves the PREVIOUS pass's W&B and HOGE
    // margins live and current — a flight reading as fully calculated from
    // figures this pass did not produce. So the downstream reports are retracted
    // on BOTH failure branches.
    //
    // THIS is the right place for it, and the catches inside the steps are not.
    // A step cannot know whether its caller has downstream steps at all:
    // `initFuel` is reached from this chain, from the ahead-flight recycle
    // (`ops-control.service.ts`) and from create-flight, but ALSO on its own via
    // the `case "initFuel"` dispatch above, where `loading`/`perf` are an
    // earlier pass's good results and retracting them destroys work nothing is
    // about to recompute. Retracting from inside `initFuel` was tried on
    // 2026-08-14 and reverted the same day for exactly that.
    //
    // The recycle is the other chain owner. It gates on each step the same way,
    // but deliberately does NOT retract: it obsoletes all three tables before it
    // starts, so a step that never runs leaves its rows already obsolete. This
    // chain has no such sweep, which is why the retraction lives here.
    // (The recycle ran fuel LAST until 2026-08-14 — an order that could not work
    // once every live row is obsoleted up front, since mass and balance reads
    // the fuel row. Reordered there; the rule here never depended on it.)
    //
    // Retracting on ANY `false`, including a validation stop that wrote no
    // report row, is deliberate. The earlier reading — "a validation stop leaves
    // the previous pass intact, so retracting destroys good data" — is wrong
    // twice over on this path. `updateFuel` has already committed a FRESH fuel
    // version by the time either branch is reached, so the surviving pass-N-1
    // `loading`/`perf` are stale against it, not consistent with it. And
    // `initMassAndBalance` writes the rejected persons-aboard value via
    // `addParameter` BEFORE its gate, so that stop is not write-free either.
    // The cost of retracting is a reversible `obsolete = 1` and a recalculation;
    // the cost of not retracting is an OFP presenting last pass's W&B and HOGE
    // margins as current. Absent beats wrong on a flight document.
    if (!(await fuel.updateFuel(flightId, classCom, "", opsMissionType))) {
      console.log("updateOfpCalculations: fuel failed, skipping mass and balance + performance " + flightId);
      await this.retractDownstreamCalculations(flightId, opsMissionType);
      return false;
    }
    if (!(await mab.updateMassAndBalance(flightId, opsMissionType, extraWeight, checksum))) {
      console.log("updateOfpCalculations: mass and balance failed, skipping performance " + flightId);
      await this.retractDownstreamCalculations(flightId, opsMissionType);
      return false;
    }
    return await perf.updatePerformance(
      flightId,
      opsMissionType,
      classCom,
      "",
      origin_elevation,
      dest_elevation,
      origin_oat,
      dest_oat,
      origin_qnh,
      dest_qnh
    );
  }

  async getDutyLimitsIfAlreadySignedAndStillvalid(pin: string): Promise<boolean> {
    try {
      const ident: string = pin + "-" + classCom.aircraftRegistration;

      let rows: any;
      // The latch is keyed by ident as well as registration. The PIN is part of the ident,
      // so a second pilot signing on the same aircraft used to read the first pilot's
      // cached row.
      if (
        !this.dutyLimits_latch?.length ||
        this.dutyLimitsIdent !== ident ||
        this.acftReg_latch != classCom.aircraftRegistration
      ) {
        rows = await classCom.namedQuery("flightcrewDutyByIdent", { ident });
        this.dutyLimits_latch = rows;
        this.dutyLimitsIdent = ident;
        this.acftReg_latch = classCom.aircraftRegistration;
      }

      if (this.dutyLimits_latch.length == 0) return false;
      const time = new Date();

      if (this.dutyLimits_latch[0].dutyFrom < time && this.dutyLimits_latch[0].dutyTo > time) {
        return true;
      } else {
        this.dutyLimits_latch = [];
        return false;
      }
    } catch (err) {
      console.log("**** getDutyLimitsIfAlreadySignedAndStillvalid..ERR " + err);
    }
    return false;
  }
  async initFlightShort(
    flightCrewId: string,
    aircraftReg: string,
    origin: string,
    dest: string,
    alternate: string,
    estDepTime: Date,
    flightrules: flightRulesEnum,
    pilotInCommand: string,
    flightNumber: string,
    author: string
  ): Promise<string> {
    let typeOfFlight: typeOfFlightStruct;
    let crusingLevel: string;
    let crusingLevelRef: vertLevelRefStruct;
    let route: string;
    let estTimeEnr: string;
    let fplRemarks: string;
    let estRouteDst: number;

    // fill default values if the short version is called
    typeOfFlight = typeOfFlightStruct.G;
    crusingLevel = "VFR";
    crusingLevelRef = vertLevelRefStruct.VFR;
    route = "";
    estTimeEnr = "-1";
    fplRemarks = "-1";
    estRouteDst = -1;

    this.initFlight(
      flightCrewId,
      aircraftReg,
      origin,
      dest,
      alternate,
      estDepTime,
      flightrules,
      pilotInCommand,
      flightNumber,
      author,
      typeOfFlight,
      crusingLevel,
      crusingLevelRef,
      route,
      estTimeEnr,
      fplRemarks,
      estRouteDst
    ).catch((err) => console.error("initFlight: ", err));
    return "";
  }
  async initFlightOfDuty(
    aircraftReg: string,
    origin: string,
    dest: string,
    alternate: string,
    estDepTime: Date,
    author: string,
    dutyDesig: string
  ): Promise<string> {
    let typeOfFlight: typeOfFlightStruct;
    let crusingLevel: string;
    let crusingLevelRef: vertLevelRefStruct;
    let route: string;
    let estTimeEnr: string;
    let fplRemarks: string;
    let fplEndurance: string;
    let estRouteDst: number;
    let flightrules: flightRulesEnum = flightRulesEnum.V;
    let pilotInCommand = "";

    const flightNumber = "";

    const opsTemplate = new opsTemplateProvider();
    const fcc = new fccProvider();

    const currentDuty: FlightCrewStruct[] = await fcc.getCurrentFlightCrew(estDepTime.getTime(), aircraftReg, classCom);

    if (currentDuty.length == 0) {
      classCom.promptMessage("no crew on duty during given dep time!", msgCatStruct.warn);
      return "";
    }

    // overlapping shifts
    let useDutyIdx: number = 0;
    if (currentDuty.length > 1) {
      if (dutyDesig == undefined) {
        classCom.promptMessage(
          "overlapping duties: " +
            currentDuty[0].dutyDesig +
            " and " +
            currentDuty[1].dutyDesig +
            " please select the appropriate crew!",
          msgCatStruct.warn
        );
        return "";
      } else {
        useDutyIdx = -1;
        if (dutyDesig == currentDuty[0].dutyDesig) {
          useDutyIdx = 0;
        }
        if (dutyDesig == currentDuty[1].dutyDesig) {
          useDutyIdx = 1;
        }
      }
    }

    if (useDutyIdx == -1) {
      classCom.promptMessage("duty designator not found! " + dutyDesig, msgCatStruct.err);
      return "";
    }

    const templ: fplTemplStruct[] = await opsTemplate.getFplTemplates(
      currentDuty[useDutyIdx].dutyId.toString(),
      classCom
    );

    // fill default values if the short version is called of 0-indexed
    typeOfFlight = templ[0].TypeOfFlight;
    flightrules = templ[0].flightRules;
    pilotInCommand = templ[0].PilotIncommand;

    if (flightrules == flightRulesEnum.V) {
      crusingLevelRef = vertLevelRefStruct.VFR;
      route = "";
      estTimeEnr = "-1";
      fplRemarks = templ[0].Remarks;
      estRouteDst = undefined;
      fplEndurance = undefined;
    }

    this.initFlight(
      currentDuty[0].dutyId,
      aircraftReg,
      origin,
      dest,
      alternate,
      estDepTime,
      flightrules,
      pilotInCommand,
      flightNumber,
      author,
      typeOfFlight,
      crusingLevel,
      crusingLevelRef,
      route,
      estTimeEnr,
      fplRemarks,
      estRouteDst,
      "",
      fplEndurance
    ).catch((err) => console.error("initFlight: ", err));
    return "xxxx";
  }
  /**
   * The id of a mission's flight, the same on every device: the first id in the
   * sequence md5(reg|mission|id), md5(reg|mission|id|1), ... that no deleted
   * flight holds. A deleted flight keeps its id and its rows, so a create after
   * a delete takes the next id and starts clean. `live` is true when a flight
   * holds the id and is not deleted.
   */
  async missionFlightSlot(aircraftReg: string, missionId: number): Promise<{ flightId: string; live: boolean }> {
    for (let n = 0; ; n++) {
      const key = aircraftReg + "|mission|" + missionId + (n > 0 ? "|" + n : "");
      const flightId = classCom.package_md5(key).substring(0, 20);
      const rows = await classCom.namedQuery("flightlistByFlightId", { flightId });
      if (rows.length === 0) return { flightId, live: false };
      if (rows.some((r: { deleted?: number }) => Number(r.deleted ?? 0) !== 1)) return { flightId, live: true };
    }
  }

  /** True when a device already created this mission's flight. */
  async missionFlightExists(aircraftReg: string, missionId: number): Promise<boolean> {
    return (await this.missionFlightSlot(aircraftReg, missionId)).live;
  }

  async initFlight(
    flightCrewId: string,
    aircraftReg: string,
    origin: string,
    dest: string,
    alternate: string,
    estDepTime: Date,
    flightrules: flightRulesEnum,
    pilotInCommand: string,
    flightNumber: string,
    author: string,
    typeOfFlight: typeOfFlightStruct,
    crusingLevel: string,
    crusingLevelRef: vertLevelRefStruct,
    route: string,
    estTimeEnr: string,
    fplRemarks: string,
    estRouteDst: number,
    opsRemarks?: string,
    fplEndurance?: string,
    missionId?: number,
    coords?: { origin?: number[]; destination?: number[]; alternate?: number[] }
  ): Promise<string> {
    // progress remark
    this.progressMessage = "initialize flight.. " + aircraftReg + " - from " + origin + " to " + dest;

    let creationDate: number = getUtcTime(new Date()).getTime();

    let flightId: string = classCom.package_md5(aircraftReg + "|" + creationDate).substring(0, 20);

    // A mission's flight has one id on every device, so the auto-accept window
    // and a tap on another screen write the same flight, not two.
    if (missionId !== undefined) {
      const slot = await this.missionFlightSlot(aircraftReg, missionId);
      // The flight exists, maybe created after the caller checked. Refuse:
      // writing on would mix this form into that flight.
      if (slot.live) {
        classCom.promptMessage(MISSION_FLIGHT_EXISTS, msgCatStruct.err);
        return "";
      }
      flightId = slot.flightId;
    }

    if (author == "istestcase") {
      flightId = "0000001";
      console.log("test init recognized!");
    }

    // input checks:
    // ------------------------------------------------------------------------------------------------------------------------------------- //
    // flight crew id (a dutyId)
    //
    // Last line of defence: a flight written without one cannot be weighed. Every
    // later mass-and-balance read resolves the crew back through
    // getDutyIdOfFlight, and an empty id matches no row, so the aircraft reads as
    // empty. Refuse here so no such flight is ever persisted, whatever the caller
    // checked.
    //
    // `0` is legitimate (ad-hoc duty), so test the value, not truthiness.
    if (isMissingDutyId(flightCrewId)) {
      classCom.promptMessage("cannot create a flight without a duty", msgCatStruct.err);
    }

    // aircraft registration
    let regex = /^[A-Za-z]{4,7}/g;
    if (!regex.test(aircraftReg)) {
      classCom.promptMessage("incorrect format of aircraft registration: " + aircraftReg, msgCatStruct.err);
    }

    // icao codes
    regex = /^[0-9A-Za-z]{4}/g;
    if (!regex.test(origin)) {
      classCom.promptMessage("incorrect origin icao code " + origin, msgCatStruct.err);
    }
    regex = /^[0-9A-Za-z]{4}/g;
    if (!regex.test(dest)) {
      classCom.promptMessage("incorrect destination icao code " + dest, msgCatStruct.err);
    }
    regex = /^[0-9A-Za-z]{4}/g;
    if (!regex.test(alternate)) {
      classCom.promptMessage("incorrect airport code " + alternate, msgCatStruct.err);
    }

    // flightrules
    if (flightrules == undefined) {
      classCom.promptMessage("incorrect flightrules, can be I,V,Z,Y " + flightrules, msgCatStruct.err);
    }

    // check cat state, return false if any error occured!
    if (classCom.lastMsgCat == msgCatStruct.err) {
      return;
    }

    regex = /^[\u00C0-\u017FA-Za-z]{3,30}/g;
    if (!regex.test(pilotInCommand)) {
      classCom.promptMessage("incorrect format pilot in command: max 30 chars " + pilotInCommand, msgCatStruct.err);
    }

    regex = /^[\u00C0-\u017FA-Za-z]{3,30}/g;
    if (!regex.test(author)) {
      classCom.promptMessage("incorrect format pilot in command: max 30 chars " + author, msgCatStruct.err);
    }

    regex = /^[A-Za-z0-9]{3,10}/g;

    if (flightNumber == "") {
      flightNumber = aircraftReg;
    }

    if (flightNumber !== "") {
      if (!regex.test(flightNumber)) {
        classCom.promptMessage(
          "incorrect format flightnumber: min 3 - max 10 chars or numbers " + flightNumber,
          msgCatStruct.err
        );
      }
    }

    // get the aircraft Model
    const fpp = new fppProvider();
    const acft = await fpp.getAircraftData(aircraftReg, classCom);

    if (acft == null) {
      classCom.promptMessage("aircraft not found! " + aircraftReg, msgCatStruct.err);
    }

    const acftType = acft.model;

    // check whether airports exist
    // progress remark
    this.progressMessage = "check airports.. ";
    // The three checks need nothing from each other: they start together.
    const [originExists, destExists, altExists] = await Promise.all([
      classNavProvider.checkAirportExists(origin, classCom),
      classNavProvider.checkAirportExists(dest, classCom),
      alternate != "" ? classNavProvider.checkAirportExists(alternate, classCom) : true,
    ]);

    if (!originExists) {
      classCom.promptMessage("origin airport not found in database " + origin, msgCatStruct.err);
    }
    if (!destExists) {
      classCom.promptMessage("destination airport not found in database " + dest, msgCatStruct.err);
    }

    if (alternate != "") {
      if (!altExists) {
        classCom.promptMessage("alternate airport not found in database " + alternate, msgCatStruct.err);
      }
    }

    // calc dct distance if zero (thats the only one that is calculated, the rest ist done by another service)
    const nav = new navLogReport(classCom);
    let origin_name: string;
    let dest_name: string;
    let alt_name: string;

    // The three lookups need nothing from each other: they start together.
    const [origin_p, dest_p, alt_p] = await Promise.all([
      nav.findAirportHeliport(origin, undefined, acft),
      nav.findAirportHeliport(dest, undefined, acft),
      nav.findAirportHeliport(alternate, undefined, acft),
    ]);

    if (estRouteDst == undefined) {
      estRouteDst = getDistance(origin_p[0].geoPos, dest_p[0].geoPos);
    }

    // progress message
    this.progressMessage = round(estRouteDst * 0.000539957, 1).toString() + " enroute distance..";

    origin_name = origin_p[0].txtName + " " + origin_p[0].icaoCode;
    dest_name = dest_p[0].txtName + " " + dest_p[0].icaoCode;
    alt_name = alt_p[0].txtName + " " + alt_p[0].icaoCode;

    // trim those strings
    origin_name = origin_name.trim();
    dest_name = dest_name.trim();
    alt_name = alt_name.trim();

    // check the time isnt in the past
    if (new Date().getTime() > estDepTime.getTime()) {
      // but not if we have a testcase
      if (author !== "istestcase") {
        creationDate = new Date().getTime();
      } else {
        // lets set the creation date to dep date - otherwise the tests wont work
        creationDate = estDepTime.getTime();
      }
    }

    // if any error occured, exit
    if (classCom.msgErr == true) {
      console.log("err during initFlightOps Input checks!");
      return "";
    }

    // ------------------------------------------------------------------------------------------------------------------------------------- //

    try {
      // sql inserts for parametertable (opsctrl_flightopscontroller_param)
      // ========================================================================
      await addParameter(
        flightId,
        "flightlist",
        property.acftReg,
        opsMissionTypeEnum.all,
        aircraftReg,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.acftType,
        opsMissionTypeEnum.all,
        acftType,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.icaoOrigin,
        opsMissionTypeEnum.all,
        origin,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(flightId, "flightlist", property.icaoDest, opsMissionTypeEnum.all, dest, "", "", "", "", true);
      await addParameter(
        flightId,
        "flightlist",
        property.icaoAlternate,
        opsMissionTypeEnum.all,
        alternate,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.alternateName,
        opsMissionTypeEnum.all,
        alt_name,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.destName,
        opsMissionTypeEnum.all,
        dest_name,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.originName,
        opsMissionTypeEnum.all,
        origin_name,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.estTimeDep,
        opsMissionTypeEnum.all,
        estDepTime.getTime().toString(),
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.pilotInCommand,
        opsMissionTypeEnum.all,
        pilotInCommand,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.flightrules,
        opsMissionTypeEnum.all,
        flightRulesEnum[flightrules],
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.estRouteDist,
        opsMissionTypeEnum.all,
        estRouteDst.toString(),
        "",
        "",
        "",
        "",
        true
      );

      // endurance (is not required)
      if (fplEndurance !== undefined) {
        await addParameter(
          flightId,
          "flightlist",
          property.fplEndurance,
          opsMissionTypeEnum.all,
          fplEndurance,
          "",
          "",
          "",
          "",
          true
        );
      }

      // other FPL vars
      await addParameter(
        flightId,
        "flightlist",
        property.fplTypeOfFlight,
        opsMissionTypeEnum.all,
        typeOfFlight.toString(),
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.fplCruisingLevel,
        opsMissionTypeEnum.all,
        crusingLevel,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.fplCruisingLevelRef,
        opsMissionTypeEnum.all,
        vertLevelRefStruct[crusingLevelRef],
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.fplRoute,
        opsMissionTypeEnum.all,
        route,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.fplEstTimeEnr,
        opsMissionTypeEnum.all,
        estTimeEnr,
        "",
        "",
        "",
        "",
        true
      );
      await addParameter(
        flightId,
        "flightlist",
        property.fplRemarks,
        opsMissionTypeEnum.all,
        fplRemarks,
        "",
        "",
        "",
        "",
        true
      );

      // ops-remarks
      if (opsRemarks != undefined) {
        if (opsRemarks != "")
          await addParameter(
            flightId,
            "flightlist",
            property.opsRemarks,
            opsMissionTypeEnum.all,
            opsRemarks.toString(),
            "",
            "",
            "",
            "",
            true
          );
      }

      const coordWrites = coords ? this.queueAirportCoordinates(flightId, coords) : [];

      // Phase C: dispatched via catalog → mobile runs the local INSERT;
      // server routes through applyOps (serverSeq + LWW + REMOTE broadcast).
      // The row joins the flush as its last op: one request for the whole create.
      const created = queueCommand({
        name: "flightlistCreate",
        params: {
          flightId,
          flightCrewId: flightCrewId.toString(),
          creationDate,
          flightNumber,
          author,
          updatedAt: Date.now(),
        },
      });
      created.catch(() => undefined);
      await execAccuParameters();
      await Promise.all(coordWrites);
      await created;

      return flightId;
    } catch (error) {
      // ponytail: every device shares a mission's id, so a rollback here could
      // delete another device's parameters, a create still in progress included.
      // Keep what this attempt wrote.
      if (missionId !== undefined) {
        console.error("initFlight failed for mission flight " + flightId + ", no rollback: ", error);
        classCom.promptMessage("could not create the flight for this mission", msgCatStruct.err);
        return;
      }

      // progress message
      this.progressMessage = "error occured, rollback..";

      // make rollback on error — mobile-only hard delete (initFlight's local row
      // is removed entirely; sync model never saw it)
      classCom
        .namedCommand("flightlistHardDelete", { flightId })
        .catch((err: unknown) => console.error("namedCommand flightlistHardDelete: ", err));
      console.error("initFlight failed, rolling back flightlist " + flightId + ": ", error);
      console.log("flightlist was rolled back " + flightId + "!");

      await deleteAllParameters(flightId, "flightlist");
      classCom.promptMessage("could not create the flight", msgCatStruct.err);
      return;
    }
  }

  /**
   * Queues the coordinate parameters of a create for the flush of `initFlight`.
   * A queued write is not in the flush rollback, so a rejected coordinate
   * removes no other input of the flight. It only logs.
   */
  private queueAirportCoordinates(
    flightId: string,
    coords: { origin?: number[]; destination?: number[]; alternate?: number[] }
  ): Promise<void>[] {
    const rows: [property, number[] | undefined][] = [
      [property.originCoords, coords.origin],
      [property.destinationCoords, coords.destination],
      [property.alternateCoords, coords.alternate],
    ];
    return rows
      .filter(([, p]) => p != undefined)
      .map(([type, p]) =>
        queueParameter(
          flightId,
          "flightlist",
          type,
          opsMissionTypeEnum.all,
          "[" + p[0] + "," + p[1] + "]",
          "",
          "",
          "",
          ""
        ).catch((err) => console.error("initFlight: coordinate write failed: ", err))
      );
  }

  async getDepartureLandingAndBlocktimes(flightId): Promise<flightlistStruct> {
    const rows = await classCom.namedQuery("flightlistByFlightId", { flightId });
    for (let index = 0; index < rows.length; index++) {
      const value = rows[index];
      const flight = new flightlistStruct();
      flight.flightId = value.flightId;
      flight.creationDate = value.creationDate;
      flight.flightNumber = value.flightNumber;
      flight.author = value.author;

      if (value.actBlocksOffTime > 0) flight.actBlocksOffTime = new Date(value.actBlocksOffTime);
      if (value.actDepTime > 0) flight.actDepTime = new Date(value.actDepTime);
      if (value.actArrTime > 0) flight.actArrTime = new Date(value.actArrTime);
      if (value.actBlocksOnTime > 0) flight.actBlocksOnTime = new Date(value.actBlocksOnTime);

      return flight;
    }
  }

  async clearOldFlights(keep?: { activeFlightId?: string; timerRunning?: boolean }) {
    const maxAgeNbrOfDaysBeforeRemoveal: number = 3;

    console.log("clearing old flights...");

    // at first query all with creation date near requested date (lets say a week)
    const msPerDay = 86400 * 1000;
    let refDate = new Date(new Date().getTime() - maxAgeNbrOfDaysBeforeRemoveal * msPerDay);
    const minTs = 0;
    const maxTs = refDate.getTime();

    // Creation, planned departure and actual departure all older than maxTs.
    const rows = await classCom.namedQuery("flightlistExpired", { minTs, maxTs });

    // Flights go FIRST, params after. The param sweep refuses to delete a row a
    // SURVIVING flight still refers to, and that guard reads the flightlist — so
    // running it first would let every flight that is about to be purged protect
    // its own params, and the sweep would collect nothing.
    const purge = flightsToPurge(rows, keep?.activeFlightId, !!keep?.timerRunning);
    for (let index = 0; index < purge.length; index++) {
      const cFlight = purge[index];
      await this.removeFlight(cFlight.flightId);
    }

    // Scoped deletes: registrationId is auto-bound by bindScopedParams, so cleanup
    // only touches the current session's rows. The previous raw timestamp-window
    // DELETEs would have wiped params/crew across every registration once
    // multi-tenant data coexists locally.
    await classCom.namedCommand("paramsDeleteInTimestampRange", { minTs, maxTs });
    // A timestamp window is not a scope the run cache can express, so forget
    // all of it rather than work out which rows this swept.
    paramCache.clear();
    await classCom.namedCommand("flightcrewDeleteInCreatedRange", { minTs, maxTs });
  }

  async listAllFlights(
    refDate: Date,
    author: string,
    maxResult: number = 100,
    flightId?: string
  ): Promise<flightlistStruct[]> {
    // No active PIC ⇒ no author to bind against. The catalog entry refuses
    // null params, and a "no author" query has no defined meaning anyway.
    if (flightId === undefined && (author === undefined || author === null || author === "")) {
      return [];
    }
    // handle UTC/LT
    // at first query all with creation date near requested date (lets say a week)
    const msPerDay = 86400 * 1000;
    const minTs = refDate.getTime() - 7 * msPerDay; // that equals 7 dadys

    const maxTs = refDate.getTime() + 7 * msPerDay;

    const rows =
      flightId !== undefined
        ? await classCom.namedQuery("flightlistByFlightId", { flightId })
        : await classCom.namedQuery("flightlistByAuthorInRange", { minTs, maxTs, author, maxResult });

    // One read for every flight's params, not one per flight.
    const paramsById = await getParametersArrayBulk(
      rows.map((r) => r.flightId),
      "flightlist",
      opsMissionTypeEnum.all
    );

    const flightsList: flightlistStruct[] = [];
    for (let index = 0; index < rows.length; index++) {
      const value = rows[index];
      const flight = new flightlistStruct();
      flight.flightId = value.flightId;
      flight.creationDate = value.creationDate;
      flight.flightNumber = value.flightNumber;
      flight.author = value.author;

      if (value.actBlocksOffTime > 0) flight.actBlocksOffTime = new Date(value.actBlocksOffTime);
      if (value.actDepTime > 0) flight.actDepTime = new Date(value.actDepTime);
      if (value.actArrTime > 0) flight.actArrTime = new Date(value.actArrTime);
      if (value.actBlocksOnTime > 0) flight.actBlocksOnTime = new Date(value.actBlocksOnTime);

      const flightlistParameters: parameterStruct[] = paramsById.get(value.flightId) ?? [];

      // parameters
      const icaoOrigin = getParameterOfArray(value.flightId, "flightlist", property.icaoOrigin, flightlistParameters);
      const icaoDest = getParameterOfArray(value.flightId, "flightlist", property.icaoDest, flightlistParameters);
      const icaoAlternate = getParameterOfArray(
        value.flightId,
        "flightlist",
        property.icaoAlternate,
        flightlistParameters
      );

      const acftReg = getParameterOfArray(value.flightId, "flightlist", property.acftReg, flightlistParameters);
      const flightrules = getParameterOfArray(value.flightId, "flightlist", property.flightrules, flightlistParameters);
      const codeDescription = getParameterOfArray(
        value.flightId,
        "flightlist",
        property.codeDescription,
        flightlistParameters
      );

      const acftType = getParameterOfArray(value.flightId, "flightlist", property.acftType, flightlistParameters);
      const opsType = getParameterOfArray(value.flightId, "flightlist", property.opsType, flightlistParameters);
      const opsMissionType = getParameterOfArray(
        value.flightId,
        "flightlist",
        property.opsMissionType,
        flightlistParameters
      );
      const estTimeDep = getParameterOfArray(value.flightId, "flightlist", property.estTimeDep, flightlistParameters);
      const estTimeArr = getParameterOfArray(value.flightId, "flightlist", property.estTimeArr, flightlistParameters);
      const identOrigin = getParameterOfArray(value.flightId, "flightlist", property.identOrigin, flightlistParameters);
      const identDest = getParameterOfArray(value.flightId, "flightlist", property.identDest, flightlistParameters);
      const identAlternate = getParameterOfArray(
        value.identAlternate,
        "flightlist",
        property.identAlternate,
        flightlistParameters
      );
      const pilotInCommand = getParameterOfArray(
        value.flightId,
        "flightlist",
        property.pilotInCommand,
        flightlistParameters
      );
      const routeDistance_gui = getParameterOfArray(
        value.flightId,
        "flightlist",
        property.estRouteDist,
        flightlistParameters
      );
      const fplStateF = getParameterOfArray(value.flightId, "flightlist", property.fplState, flightlistParameters);

      if (codeDescription[0] !== undefined) {
        flight.codeDescription = codeDescription[0].value;
      } else {
        flight.codeDescription = "NIL";
      }
      if (icaoOrigin[0] !== undefined) {
        flight.icaoOrigin = icaoOrigin[0].value;
      } else {
        flight.icaoOrigin = "NIL";
      }
      if (icaoDest[0] !== undefined) {
        flight.icaoDest = icaoDest[0].value;
      } else {
        flight.icaoDest = "NIL";
      }
      if (icaoAlternate[0] !== undefined) {
        flight.icaoAlternate = icaoAlternate[0].value;
      } else {
        flight.icaoAlternate = "NIL";
      }

      if (acftReg[0] !== undefined) {
        flight.acftReg = acftReg[0].value;
      } else {
        flight.acftReg = "NIL";
      }
      if (acftType[0] !== undefined) {
        flight.acftType = acftType[0].value;
      } else {
        flight.acftType = "NIL";
      }
      if (opsType[0] !== undefined) {
        flight.opsType = opsType[0].value;
      } else {
        flight.opsType = "NIL";
      }
      if (opsMissionType[0] !== undefined) {
        flight.opsMissionType = icaoDest[0].value;
      } else {
        flight.opsMissionType = "NIL";
      }
      if (estTimeDep[0] !== undefined) {
        flight.estTimeDep = new Date(parseInt(estTimeDep[0].value));
        if (flightrules[0] !== undefined) {
          flight.flightrules = flightRulesEnum[flightrules[0].value];
        }
        if (routeDistance_gui[0] !== undefined) {
          flight.routeDistance_gui =
            Math.round(parseFloat(routeDistance_gui[0].value) * classNavProvider.m_to_nm).toString() + " NM";
        }
        if (fplStateF[0] !== undefined) {
          flight.fplState = fplStateF[0].value;
        }

        flight.estTimeDep_gui =
          padLeft(flight.estTimeDep.getHours().toString(), "0", 2) +
          ":" +
          padLeft(flight.estTimeDep.getMinutes().toString(), "0", 2) +
          " LT";

        if (this.classSettings.useLocalTime == false) {
          flight.estTimeDep = getLocalTime(flight.estTimeDep);
          flight.estTimeDep_gui =
            padLeft(flight.estTimeDep.getHours().toString(), "0", 2) +
            ":" +
            padLeft(flight.estTimeDep.getMinutes().toString(), "0", 2) +
            " UTC";
        }

        // if dep day isnt the same day, add the day
        let prefix = "";
        if (!isToday(flight.estTimeDep)) {
          prefix = flight.estTimeDep.getDate().toString() + "." + (flight.estTimeDep.getMonth() + 1).toString() + ". ";
        }

        flight.estTimeDep_gui = prefix + flight.estTimeDep_gui;
      } else {
        flight.estTimeDep = new Date(0);
        flight.estTimeDep_gui = "NIL";
      }

      if (estTimeArr[0] !== undefined) {
        flight.estTimeArr = new Date(parseInt(estTimeArr[0].value));
        flight.estTimeArr_gui =
          padLeft(flight.estTimeArr.getHours().toString(), "0", 2) +
          ":" +
          padLeft(flight.estTimeArr.getMinutes().toString(), "0", 2) +
          " LT";

        if (this.classSettings.useLocalTime == false) {
          flight.estTimeArr = getLocalTime(flight.estTimeArr);
          flight.estTimeArr_gui =
            padLeft(flight.estTimeArr.getHours().toString(), "0", 2) +
            ":" +
            padLeft(flight.estTimeArr.getMinutes().toString(), "0", 2) +
            " UTC";
        }

        // if dep day isnt the same day, add the day
        let prefix = "";
        if (!isToday(flight.estTimeArr)) {
          prefix = flight.estTimeArr.getDate().toString() + "." + (flight.estTimeArr.getMonth() + 1).toString() + ". ";
        }

        flight.estTimeArr_gui = prefix + flight.estTimeArr_gui;
      } else {
        flight.estTimeArr = new Date(0);
        flight.estTimeArr_gui = "NIL";
      }

      if (identOrigin[0] !== undefined) {
        flight.identOrigin = identOrigin[0].value;
      } else {
        flight.identOrigin = "NIL";
      }
      if (identDest[0] !== undefined) {
        flight.identDest = identDest[0].value;
      } else {
        flight.identDest = "NIL";
      }
      if (identAlternate[0] !== undefined) {
        flight.identAlternate = identAlternate[0].value;
      } else {
        flight.identDest = "NIL";
      }

      if (pilotInCommand[0] !== undefined) {
        flight.pilotInCommand = pilotInCommand[0].value;
      } else {
        flight.pilotInCommand = "NIL";
      }

      // again check min max ts (from filter)
      if (minTs < flight.estTimeDep.getTime() && maxTs > flight.estTimeDep.getTime()) {
        flightsList.push(flight);
      }
    }

    if (classCom.targetPlatform == targetPlatformEnum.server) drawConsoleTable(flightsList, classCom.package_fs);

    return flightsList;
  }
  async findAirport(query: string, geoPos: number[], aircraft: aircraftStruct): Promise<airportHeliportStruct[]> {
    if (geoPos == undefined) {
      geoPos = [0, 0];
    }
    const searchResult = await classNavProvider.findAirportHeliport(query, geoPos, aircraft);

    return searchResult;
  }
  async nearestAirportHeliport(
    ppos: number[],
    aircraft: aircraftStruct,
    searchRadiusDegrees = 0.5
  ): Promise<airportHeliportStruct[]> {
    const searchResult = await classNavProvider.nearestAirportHeliport(ppos, aircraft, undefined, searchRadiusDegrees);
    return searchResult;
  }
  async deleteFlight(flightId: string): Promise<boolean> {
    if (classCom.msgErr == true) {
      console.log("err during deleteFlight Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistMarkDeleted", { flightId });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }

  async deleteAllFlightsExcept(flightId: string): Promise<boolean> {
    if (classCom.msgErr == true) {
      console.log("err during deleteFlight Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistMarkOthersDeleted", { keepFlightId: flightId });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }

  public async removeFlight(flightId: string): Promise<boolean> {
    console.log("removing flight " + flightId + "...");

    try {
      // Mobile-only purge across all per-flight tables. Each entry is a
      // mobile catalog write (no sync clause): server-side this path
      // would need to enumerate rowIds and broadcast per-row delete Ops.
      await classCom.namedCommand("flightlistDeleteByFlightId", { flightId });
      await classCom.namedCommand("fuelDeleteByFlightId", { flightId });
      await classCom.namedCommand("loadingDeleteByFlightId", { flightId });
      await classCom.namedCommand("loadingelementsDeleteByFlightId", { flightId });
      await classCom.namedCommand("navDeleteByFlightId", { flightId });
      await classCom.namedCommand("navsegDeleteByFlightId", { flightId });
      await classCom.namedCommand("notamDeleteByFlightId", { flightId });
      await classCom.namedCommand("metDeleteByFlightId", { flightId });
      await classCom.namedCommand("perfDeleteByFlightId", { flightId });

      console.log("flight was removed: " + flightId);
      return true;
    } catch (error) {
      console.log("error remove flight: " + flightId + " : " + error);
      return false;
    }
  }

  async delayFlight(flightNumber: string, flightId: string, minDelay: number): Promise<boolean> {
    const regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }

    // check that flightId is valid
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage(
        "given flightId not found: " + flightId + " - flightnumber: " + flightNumber,
        msgCatStruct.err
      );

      return false;
    }

    // get current departure time
    const retVal = await getParameter(flightId, "flightlist", property.estTimeDep, opsMissionTypeEnum.all);
    const currDepTimeUtc: Date = new Date(parseInt(retVal[0].value));
    const newDeptime = new Date(currDepTimeUtc.getTime() + minDelay * 60000);

    // check the time isnt in the past
    if (new Date().getTime() > newDeptime.getTime()) {
      classCom.promptMessage("cant shift departure time, new departure time would be in the past: ", msgCatStruct.err);
    }

    addParameter(
      flightId,
      "flightlist",
      property.estTimeDep,
      opsMissionTypeEnum.all,
      newDeptime.getTime().toString(),
      "",
      "",
      "",
      "",
      false
    ).catch((err) => console.error("addParameter: ", err));

    if (classCom.msgErr == true) {
      console.log("err during deleteFlight Input checks!");
      return false;
    } else {
      return true;
    }
  }
  async bringFlightForward(flightNumber: string, flightId: string, minDelay: number): Promise<boolean> {
    const delFlight: boolean = await this.delayFlight(flightNumber, flightId, minDelay * -1);
    return delFlight;
  }
  async changeOrigin(flightNumber: string, flightId: string, newCode: string): Promise<boolean> {
    return await this.changeOrigin_dest_alternate(flightNumber, flightId, newCode, 1);
  }
  async changeDestination(flightNumber: string, flightId: string, newCode: string): Promise<boolean> {
    return await this.changeOrigin_dest_alternate(flightNumber, flightId, newCode, 2);
  }
  async changeAlternate(flightNumber: string, flightId: string, newCode: string): Promise<boolean> {
    return await this.changeOrigin_dest_alternate(flightNumber, flightId, newCode, 3);
  }
  async changeOrigin_dest_alternate(
    flightNumber: string,
    flightId: string,
    newCode: string,
    origin1_Dest2_alternate3: number
  ): Promise<boolean> {
    const flightlistParams = await getParametersArray(flightId, "flightlist", opsMissionTypeEnum.all);

    const regex = /^[A-Za-z0-9]{5,10}/g;

    let airportTxtName: string = "";
    const currentAircraft = getParameterOfArray(flightId, "flightlist", property.acftReg, flightlistParams);
    let acft = await this.getAircraftData(currentAircraft[0].value);
    let apt = await this.findAirport(newCode, undefined, acft);
    if (apt.length > 0) {
      if (apt[0].icaoCode !== "ZZZZ") {
        airportTxtName = apt[0].txtName;
      }
    }

    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }

    // check that flightId is valid
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage(
        "given flightId not found: " + flightId + " - flightnumber: " + flightNumber,
        msgCatStruct.err
      );
      return false;
    }

    if (!(await checkFlightNumberExists(flightId, flightNumber))) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumber, msgCatStruct.err);
      return false;
    }

    // check the new origin exists
    const originExists = await classNavProvider.checkAirportExists(newCode, classCom);

    if (!originExists) {
      classCom.promptMessage("airport icao code invalid " + newCode, msgCatStruct.err);
      return false;
    }

    switch (origin1_Dest2_alternate3) {
      case 1: {
        // get current airport
        const currApt = getParameterOfArray(flightId, "flightlist", property.icaoOrigin, flightlistParams);

        if (newCode == currApt[0].value) {
          // classCom.promptMessage("requested and current origin are identical " + newCode, msgCatStruct.err)
          return false;
        } else {
          addParameter(
            flightId,
            "flightlist",
            property.icaoOrigin,
            opsMissionTypeEnum.all,
            newCode,
            "",
            "",
            "",
            "",
            false
          ).catch((err) => console.error("addParameter: ", err));
          addParameter(
            flightId,
            "flightlist",
            property.originName,
            opsMissionTypeEnum.all,
            airportTxtName,
            "",
            "",
            "",
            "",
            false
          ).catch((err) => console.error("addParameter: ", err));
        }
        break;
      }
      case 2: {
        // get current airport
        const currApt = getParameterOfArray(flightId, "flightlist", property.icaoDest, flightlistParams);

        if (newCode == currApt[0].value) {
          // classCom.promptMessage("requested and current origin are identical " + newCode, msgCatStruct.err)
          return false;
        } else {
          addParameter(
            flightId,
            "flightlist",
            property.icaoDest,
            opsMissionTypeEnum.all,
            newCode,
            "",
            "",
            "",
            "",
            false
          ).catch((err) => console.error("addParameter: ", err));
          addParameter(
            flightId,
            "flightlist",
            property.destName,
            opsMissionTypeEnum.all,
            airportTxtName,
            "",
            "",
            "",
            "",
            false
          ).catch((err) => console.error("addParameter: ", err));
        }
        break;
      }
      case 3: {
        // get current airport
        const currApt = getParameterOfArray(flightId, "flightlist", property.icaoAlternate, flightlistParams);

        if (newCode == currApt[0].value) {
          // classCom.promptMessage("requested and current alternate are identical " + newCode, msgCatStruct.err)
          return false;
        } else {
          await addParameter(
            flightId,
            "flightlist",
            property.icaoAlternate,
            opsMissionTypeEnum.all,
            newCode,
            "",
            "",
            "",
            "",
            false
          );
          await addParameter(
            flightId,
            "flightlist",
            property.alternateName,
            opsMissionTypeEnum.all,
            airportTxtName,
            "",
            "",
            "",
            "",
            false
          );
        }
      }
    }

    if (classCom.msgErr == true) {
      console.log("err during changeOrigin_Destination_Alternate Input checks!");
      return false;
    } else {
      return true;
    }
  }
  async changeRouteEndpoints(
    flightNumber: string,
    flightId: string,
    originPoint: number[],
    destPoint: number[],
    acft: aircraftStruct,
    routeChanged: (origin: airportHeliportSearchStruct, dest: airportHeliportSearchStruct) => boolean | Promise<boolean>
  ): Promise<{ origin: airportHeliportSearchStruct; dest: airportHeliportSearchStruct; writes: Promise<void>[] }> {
    const [flightlistParams, idValid, numberExists, nearOrigin, nearDest] = await Promise.all([
      getParametersArray(flightId, "flightlist", opsMissionTypeEnum.all),
      checkFlightIdValid(flightId),
      checkFlightNumberExists(flightId, flightNumber),
      this.nearestAirportHeliport(originPoint, acft),
      this.nearestAirportHeliport(destPoint, acft),
    ]);

    /** The endpoints that are a bare position, not an airfield. */
    const bare = new Set<airportHeliportSearchStruct>();
    const siteOf = (results: airportHeliportStruct[], point: number[]): airportHeliportSearchStruct => {
      const near: airportHeliportSearchStruct[] = [];
      for (const value of results) {
        const distNm = getDistanceNm(value.geoPos, point);
        if (distNm >= 0 && distNm < 1) {
          const entry = new airportHeliportSearchStruct();
          entry.icaoCode = value.icaoCode;
          entry.type = value.codeType;
          entry.name = value.txtName;
          entry.key = value.id;
          entry.geoPos = value.geoPos;
          entry.distSortNumber = distNm;
          near.push(entry);
        }
      }
      if (near.length > 0) {
        near.sort((a, b) => a.distSortNumber - b.distSortNumber);
        return near[0];
      }
      const pos = new airportHeliportSearchStruct();
      pos.type = "POS";
      pos.icaoCode = "ZZZZ";
      pos.name = "POS";
      pos.geoPos = point;
      bare.add(pos);
      return pos;
    };
    const origin = siteOf(nearOrigin, originPoint);
    const dest = siteOf(nearDest, destPoint);

    // The caller compares the route also when a flight check fails: the legs
    // are saved then too, as before, and only the endpoint inputs are not.
    const changed = await routeChanged(origin, dest);

    const regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }
    if (!idValid) {
      classCom.promptMessage(
        "given flightId not found: " + flightId + " - flightnumber: " + flightNumber,
        msgCatStruct.err
      );
      return { origin, dest, writes: [] };
    }
    if (!numberExists) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumber, msgCatStruct.err);
      return { origin, dest, writes: [] };
    }

    /** The writes whose failure stops the save: the alternate and the coordinates, as before. */
    const writes: Promise<void>[] = [];
    const queue = (type: property, value: string) =>
      queueParameter(flightId, "flightlist", type, opsMissionTypeEnum.all, value, "", "", "", "");
    // A failed origin or destination write is logged, as before.
    const write = (type: property, value: string) =>
      queue(type, value).catch((err) => console.error("queueParameter: ", err));
    const mustWrite = (type: property, value: string, tolerateNewer = false) => {
      let p = queue(type, value);
      // A coordinate row that a peer wrote later is no failed save, as before.
      if (tolerateNewer) {
        p = p.catch((err) => {
          if (!isBenignLwwReject(err)) throw err;
        });
      }
      // the caller awaits it after the flush; the guard handles an early rejection
      p.catch(() => undefined);
      writes.push(p);
    };
    const coordsText = (p: number[]) => "[" + p[0] + "," + p[1] + "]";
    const stored = (type: property) => getParameterOfArray(flightId, "flightlist", type, flightlistParams)[0]?.value;

    let alternate: airportHeliportStruct | undefined;
    if (changed) {
      let currDist = 0;
      for (let i = 0; i < nearDest.length - 1; i++) {
        const each = nearDest[i];
        if (each.icaoCode != "ZZZZ") {
          const dist = getDistanceNm(destPoint, each.geoPos);
          if (dist > 5 && (dist < currDist || currDist == 0)) {
            currDist = dist;
            alternate = each;
          }
        }
      }
    }

    const targets: { code: string; codeType: property; nameType: property }[] = [];
    if (origin.icaoCode != stored(property.icaoOrigin)) {
      targets.push({ code: origin.icaoCode, codeType: property.icaoOrigin, nameType: property.originName });
    }
    if (dest.icaoCode != stored(property.icaoDest)) {
      targets.push({ code: dest.icaoCode, codeType: property.icaoDest, nameType: property.destName });
    }
    if (alternate && alternate.icaoCode != stored(property.icaoAlternate)) {
      targets.push({ code: alternate.icaoCode, codeType: property.icaoAlternate, nameType: property.alternateName });
    }

    const lookups = await Promise.all(
      targets.map(async (t) => {
        const [apt, exists] = await Promise.all([
          this.findAirport(t.code, undefined, acft),
          classNavProvider.checkAirportExists(t.code, classCom),
        ]);
        return { apt, exists };
      })
    );
    targets.forEach((t, i) => {
      const { apt, exists } = lookups[i];
      if (!exists) {
        classCom.promptMessage("airport icao code invalid " + t.code, msgCatStruct.err);
        return;
      }
      // The route write that follows a changed route stores the destination code
      // and name itself. A second write of one row in the same flush can carry the
      // same millisecond stamp, and the server rejects that as a conflict.
      if (changed && t.codeType === property.icaoDest) return;
      const name = apt.length > 0 && apt[0].icaoCode !== "ZZZZ" ? apt[0].txtName : "";
      const put = t.codeType === property.icaoAlternate ? mustWrite : write;
      put(t.codeType, t.code);
      put(t.nameType, name);
    });

    // Coordinates only for a point that is no airfield. A site of the nav
    // data can carry the code ZZZZ too, and it gets none, as before.
    if (bare.has(origin)) mustWrite(property.originCoords, coordsText(originPoint), true);
    if (bare.has(dest)) mustWrite(property.destinationCoords, coordsText(destPoint), true);
    if (alternate) mustWrite(property.alternateCoords, coordsText(alternate.geoPos), true);

    return { origin, dest, writes };
  }
  async changeFlightRules(flightNumber: string, flightId: string, flightrules: flightRulesEnum): Promise<boolean> {
    const regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }

    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
      return false;
    }

    if (!(await checkFlightNumberExists(flightId, flightNumber))) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumber, msgCatStruct.err);
      return false;
    }

    // get current flightrules

    const currFlightrulesO = await getParameter(flightId, "flightlist", property.flightrules, opsMissionTypeEnum.all);

    if (currFlightrulesO[0] != undefined) {
      const currFlightrules: string = currFlightrulesO[0].value;

      if (currFlightrules != flightrules.toString()) {
        addParameter(
          flightId,
          "flightlist",
          property.flightrules,
          opsMissionTypeEnum.all,
          flightrules.toString(),
          "",
          "",
          "",
          "",
          false
        ).catch((err) => console.error("addParameter: ", err));
        return true;
      } else {
        classCom.promptMessage(
          "that where the same flightrules this flight had already: " + flightRulesEnum[currFlightrules],
          msgCatStruct.err
        );
        return false;
      }
    }

    if (classCom.msgErr == true) {
      console.log("err during changeFlightRules Input checks!");
      return false;
    }

    return true;
  }
  async addRevertFlight(
    flightNumberOld: string,
    flightId: string,
    newDepTime: Date,
    newFlightNumber: string,
    newAlternate: string
  ): Promise<boolean> {
    const flightlistParams = await getParametersArray(flightId, "flightlist", opsMissionTypeEnum.all);

    let regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumberOld)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumberOld, msgCatStruct.err);
    }

    regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(newFlightNumber)) {
      classCom.promptMessage("incorrect format of new FlightNumber: " + newFlightNumber, msgCatStruct.err);
    }

    regex = /^[A-Za-z]{4}/g;
    if (!regex.test(newAlternate)) {
      classCom.promptMessage("incorrect icao code " + newAlternate, msgCatStruct.err);
    }

    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
      return false;
    }

    if (!(await checkFlightNumberExists(flightId, flightNumberOld))) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumberOld, msgCatStruct.err);
      return false;
    }

    if (!(await classNavProvider.checkAirportExists(newAlternate, classCom))) {
      classCom.promptMessage("alternate airport invalid " + newAlternate, msgCatStruct.err);
      return false;
    }

    // getAircraftReg
    const acftReg = getParameterOfArray(flightId, "flightlist", property.acftReg, flightlistParams);
    const acftRegStr: string = acftReg[0].value;

    // get values from flightlist table first — original predicate filters by both flightId AND
    // flightNumber so we don't pick the wrong row when a flightNumber has been reused.
    const oldFlight = await classCom.namedQuery("flightlistByFlightIdAndNumber", {
      flightId,
      flightNumber: flightNumberOld,
    });
    if (oldFlight.length === 0) {
      classCom.promptMessage(
        "flight not found for flightId/flightNumber " + flightId + "/" + flightNumberOld,
        msgCatStruct.err
      );
      return false;
    }
    const oldFlightval = oldFlight[0];

    const creationDate: number = getUtcTime(new Date()).getTime();
    const newFlightId: string = classCom.package_md5(acftRegStr + "|" + creationDate).substring(0, 20);

    classCom
      .namedCommand("flightlistCreate", {
        flightId: newFlightId,
        flightCrewId: oldFlightval.flightCrewId,
        creationDate,
        flightNumber: newFlightNumber,
        author: oldFlightval.author,
        updatedAt: Date.now(),
      })
      .catch((err: unknown) => console.error("namedCommand flightlistCreate: ", err));

    // sql inserts for parametertable (opsctrl_flightopscontroller_param)
    // ========================================================================
    const codeDescriptionO = getParameterOfArray(flightId, "flightlist", property.codeDescription, flightlistParams);
    const opsTypeO = getParameterOfArray(flightId, "flightlist", property.opsType, flightlistParams);
    const opsMissionTypeO = getParameterOfArray(flightId, "flightlist", property.opsMissionType, flightlistParams);
    const icaoOriginO = getParameterOfArray(flightId, "flightlist", property.icaoOrigin, flightlistParams);
    const icaoDestO = getParameterOfArray(flightId, "flightlist", property.icaoDest, flightlistParams);
    const identOriginO = getParameterOfArray(flightId, "flightlist", property.identOrigin, flightlistParams);
    const identDestO = getParameterOfArray(flightId, "flightlist", property.identDest, flightlistParams);
    const pilotInCommandO = getParameterOfArray(flightId, "flightlist", property.pilotInCommand, flightlistParams);
    const flightrulesO = getParameterOfArray(flightId, "flightlist", property.flightrules, flightlistParams);

    if (codeDescriptionO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.codeDescription,
        opsMissionTypeEnum.all,
        codeDescriptionO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (opsTypeO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.opsType,
        opsMissionTypeEnum.all,
        opsTypeO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (opsMissionTypeO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.opsMissionType,
        opsMissionTypeEnum.all,
        opsMissionTypeO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (icaoOriginO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.icaoDest,
        opsMissionTypeEnum.all,
        icaoOriginO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (icaoDestO[0] != undefined) {
      addParameter(
        newFlightId,
        "flightlist",
        property.icaoOrigin,
        opsMissionTypeEnum.all,
        icaoDestO[0].value,
        "",
        "",
        "",
        "",
        true
      ).catch((err) => console.error("addParameter: ", err));
    }
    if (identDestO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.identOrigin,
        opsMissionTypeEnum.all,
        identDestO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (identOriginO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.identDest,
        opsMissionTypeEnum.all,
        identOriginO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (pilotInCommandO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.pilotInCommand,
        opsMissionTypeEnum.all,
        pilotInCommandO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }
    if (flightrulesO[0] != undefined) {
      await addParameter(
        newFlightId,
        "flightlist",
        property.flightrules,
        opsMissionTypeEnum.all,
        flightrulesO[0].value,
        "",
        "",
        "",
        "",
        true
      );
    }

    // convert est dep time ticks and utc
    let depTime: Date = newDepTime;
    if (this.classSettings.useLocalTime) {
      depTime = getUtcTime(depTime);
    }

    await addParameter(
      newFlightId,
      "flightlist",
      property.estTimeDep,
      opsMissionTypeEnum.all,
      depTime.getTime().toString(),
      "",
      "",
      "",
      "",
      true
    );
    await addParameter(
      newFlightId,
      "flightlist",
      property.icaoAlternate,
      opsMissionTypeEnum.all,
      newAlternate,
      "",
      "",
      "",
      "",
      true
    );
    await addParameter(
      newFlightId,
      "flightlist",
      property.acftReg,
      opsMissionTypeEnum.all,
      acftRegStr,
      "",
      "",
      "",
      "",
      true
    );
    await execAccuParameters();
    return true;
  }
  async changeAircraft(
    flightNumber: string,
    flightId: string,
    currRegistration: string,
    newRegistration: string
  ): Promise<boolean> {
    let regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }

    regex = /^[A-Za-z]{4,7}/g;
    if (!regex.test(newRegistration)) {
      classCom.promptMessage("incorrect format of aircraft registration: " + newRegistration, msgCatStruct.err);
    }

    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
      return false;
    }

    if (!(await checkFlightNumberExists(flightId, flightNumber))) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumber, msgCatStruct.err);
      return false;
    }

    // get current aicraft
    const currentAircraftO = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);

    if (currentAircraftO[0] != undefined) {
      const currAircraft: string = currentAircraftO[0].value;
      if (currRegistration != currAircraft) {
        classCom.promptMessage(
          "current aircraft is not " + currRegistration + " but " + currAircraft,
          msgCatStruct.err
        );
      } else {
        await addParameter(
          flightId,
          "flightlist",
          property.acftReg,
          opsMissionTypeEnum.all,
          newRegistration,
          "",
          "",
          "",
          "",
          false
        );
      }
    } else {
      classCom.promptMessage("aircraft not set " + currRegistration, msgCatStruct.err);
    }

    if (classCom.msgErr == true) {
      console.log("err during changeAircraft Input checks!");
      return false;
    }
  }
  async changeFlightNumber(flightNumber: string, flightId: string, newFlightNumber: string): Promise<boolean> {
    if (flightNumber == newFlightNumber) {
      classCom.promptMessage("new and current flightnumbers are identical: " + flightNumber, msgCatStruct.err);
      return false;
    }

    let regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(flightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + flightNumber, msgCatStruct.err);
    }

    regex = /^[A-Za-z0-9]{5,10}/g;
    if (!regex.test(newFlightNumber)) {
      classCom.promptMessage("incorrect format of flightNumber: " + newFlightNumber, msgCatStruct.err);
    }

    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
      return false;
    }

    if (!(await checkFlightNumberExists(flightId, flightNumber))) {
      classCom.promptMessage("incorrect no flightnumber/flightId " + flightNumber, msgCatStruct.err);
      return false;
    }

    if (classCom.msgErr == true) {
      console.log("err during changeFlightNumber Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistChangeFlightNumber", { flightId, flightNumber, newFlightNumber });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }
  async setActualBlocksOffTime(flightId: string, time = new Date().getTime()): Promise<boolean> {
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
    }

    if (classCom.msgErr == true) {
      console.log("err during setActualBlocksOffTime Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistSetActBlocksOffTime", { flightId, time });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }
  async setActualDepartureTime(flightId: string, time = new Date().getTime()): Promise<boolean> {
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
    }

    if (classCom.msgErr == true) {
      console.log("err during setActualDepartureTime Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistSetActDepTime", { flightId, time });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }
  async setActualArrivalTime(flightId: string, time = new Date().getTime()): Promise<boolean> {
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
    }

    if (classCom.msgErr == true) {
      console.log("err during setActualArrivalTime Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistSetActArrTime", { flightId, time });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }
  async setActualBlocksOnTime(flightId: string, time = new Date().getTime()): Promise<boolean> {
    if (!(await checkFlightIdValid(flightId))) {
      classCom.promptMessage("incorrect no flight found with this flightId: " + flightId, msgCatStruct.err);
    }

    if (classCom.msgErr == true) {
      console.log("err during setActualBlocksOnTime Input checks!");
      return false;
    }

    try {
      await classCom.namedCommand("flightlistSetActBlocksOnTime", { flightId, time });
      return true;
    } catch (error) {
      console.log("error delete flight: " + error);
      return false;
    }
  }

  // FPP / FCC
  // ----------------------------------------------------- //
  async getAircraftRegistrations(): Promise<string[]> {
    const acft = new fppProvider();

    const regList = await acft.getAircraftRegistrations(classCom);

    regList.forEach(function (value) {
      console.log(value);
    });

    return regList;
  }

  async getAircraftData(registration: string): Promise<aircraftStruct> {
    const acft = new fppProvider();
    const regList = await acft.getAircraftData(registration, classCom);
    console.log(regList);
    return regList;
  }
  async getCurrentFlightCrew(refTime: number, aircraftRegistration): Promise<FlightCrewStruct[]> {
    const fccClass = new fccProvider();
    const duties = await fccClass.getCurrentFlightCrew(refTime, aircraftRegistration, classCom);
    console.log(JSON.stringify(duties));
    return duties;
  }
  async getFplTemplates(dutyId: string): Promise<fplTemplStruct[]> {
    const opsTemplProvClass = new opsTemplateProvider();
    const template = await opsTemplProvClass.getFplTemplates(dutyId, classCom);
    console.log(template);
    return template;
  }
  async getCompanyCrewList(): Promise<CompanyCrewListStruct[]> {
    const fccClass = new fccProvider();
    const crew = await fccClass.getCompanyCrewList(classCom);
    console.log(JSON.stringify(crew));
    return crew;
  }

  async listAllHomebases(): Promise<string[]> {
    const fccClass = new fccProvider();
    const homebases = await fccClass.listAllHomebases(classCom);
    console.log(JSON.stringify(homebases));
    return homebases;
  }

  async listAllDutiesAtHomebase(homebaseIdent: string): Promise<string[]> {
    const fccClass = new fccProvider();
    const dutyIdents = await fccClass.listAllDutiesAtHomebase(homebaseIdent, classCom);
    return dutyIdents;
  }

  async getCrewAndCargo(dutyId: string): Promise<CrewCargokeyValueStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getCrewAndCargo(dutyId, classCom);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async getListCargoConfigs(dutyId: string, parameter: string): Promise<CrewCargokeyValueStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getListCargoConfigs(dutyId, parameter, classCom);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async getBookedCargo(dutyId: string, paraFilter: string): Promise<PayLoadStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getBookedCargo(dutyId, paraFilter, classCom);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async getBookedPassengers(dutyId: string): Promise<PayLoadStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getEntireLoading(dutyId, true, classCom, payloadCodeTypeEnum.pax);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async getBookedPassengersNotOnAircraft(dutyId: string): Promise<CrewCargokeyValueStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getPassengersNotOnAircraft(dutyId, classCom);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async getBookedCargoNotOnAircraft(dutyId: string): Promise<CrewCargokeyValueStruct[]> {
    const fccClass = new fccProvider();
    const crewCargo = await fccClass.getCargoNotOnAircraft(dutyId, classCom);
    console.log(JSON.stringify(crewCargo));
    return crewCargo;
  }
  async pushCrewAndCargoToAcft(dutyId: string, crewCargo: CrewCargokeyValueStruct[]): Promise<boolean> {
    const fppClass = new fppProvider();
    const c = await fppClass.pushCrewAndCargoToAcft(dutyId, crewCargo, classCom);
    console.log(c);
    return c;
  }
  async getLoadSheetPassengers(registration: string): Promise<PayLoadStruct[]> {
    const fppClass = new fppProvider();
    const c = await fppClass.getLoadingObjectsAircraftModel(registration, payloadCodeTypeEnum.pax, classCom);
    console.log(c);
    return c;
  }
  async getEmptySeats(reg: string): Promise<PayLoadStruct[]> {
    const fppClass = new fppProvider();
    const c = await fppClass.getEmptySeats(reg, classCom);
    console.log(c);
    return c;
  }
  async getNbrOfSeats(reg: string): Promise<number> {
    const fppClass = new fppProvider();
    const c = await fppClass.getNbrOfSeats(reg, classCom);
    return c;
  }
  async getMaxUsableFuelCapacityOfAircraft(reg: string): Promise<number> {
    const fppClass = new fppProvider();
    const c = await fppClass.getMaxUsableFuelCapacityOfAircraft(reg, classCom);
    console.log(c);
    return c;
  }
  async getCurrentBlockFuelOfAircraft(reg: string): Promise<number> {
    const fppClass = new fppProvider();
    const c = await fppClass.getCurrentBlockFuelOfAircraft(reg, classCom);
    console.log(c);
    return c;
  }
  async getLoadedCargo(reg: string): Promise<PayLoadStruct[]> {
    const fppClass = new fppProvider();
    const c = await fppClass.getLoadingObjectsAircraftModel(reg, payloadCodeTypeEnum.cargo, classCom);
    console.log(c);
    return c;
  }
  async getAircraftCrew(reg: string): Promise<PayLoadStruct[]> {
    const fppClass = new fppProvider();
    const c = await fppClass.getAircraftCrew(reg, classCom);
    console.log(c);
    return c;
  }
  async getConditionHashOfFlight(flightId: string) {
    // this hash is used to see if certain calculations have to be redone
    const fpp = new fppProvider();
    const wb = new mAndBandPerformance();
    const nav = new navLogReport(classCom);
    // The nav and loading parts need only the flight, so they start with the
    // registration read. All parts are awaited in the old order.
    const registrationRead = getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    registrationRead.catch(() => undefined);
    const registrationValue = registrationRead.then((rows) => rows[0].value as string);
    registrationValue.catch(() => undefined);
    const loadingRead = wb.getLoadingHash(flightId, registrationValue);
    const navRead = nav.getNavHash(flightId, classCom.package_md5);
    loadingRead.catch(() => undefined);
    navRead.catch(() => undefined);
    const currentAircraftO = await registrationRead;
    const acftRegistration: string = currentAircraftO[0].value;
    const aircraftRead = fpp.getAircraftData(acftRegistration, classCom);
    const HASH_aircraft = await JSON.stringify(await aircraftRead);
    const HASH_loading = await loadingRead;
    const HASH_nav = await navRead;
    return classCom.package_md5(HASH_aircraft + HASH_loading + HASH_nav);
  }
  async getLoadAndBalanceHtmlReport(flightId: string, opsMissionType: opsMissionTypeEnum): Promise<string> {
    const lab = new loadAndBalanceReport();

    return await lab.getLoadAndBalanceReport(flightId, opsMissionType, classCom, false);
  }
  async getAircraftDataHtml(registration: string): Promise<string> {
    const fpp = new fppProvider();
    const html = await fpp.getAircraftDataHtml(registration, classCom, null);
    return html;
  }
  async getCrewHtml(time: Date, registration: string): Promise<string> {
    const fcc = new fccProvider();

    const success = await fcc.getCrewHtml(time.getTime(), registration, classCom);
    return success;
  }
  async getNotamHtml(flightId: string): Promise<string> {
    const notam = new notamReport();

    const success = await notam.getNotamHtmlReport(flightId, classCom, false);
    return success;
  }
  async getMetHtml(flightId: string): Promise<string> {
    const met = new metarReport();

    const success = await met.getMetReport(flightId, classCom);
    return success;
  }

  async getPerformanceHtml(flightId: string, opsMissionType: opsMissionTypeEnum): Promise<string> {
    const perf = new performanceReport();

    const success = await perf.getPerformanceHtmlReport(flightId, opsMissionType, classCom);
    return success;
  }

  /**
   * The hoist live values. Reads only, so it runs inside one parameter run cache:
   * the two hoist ratings ask for the same flight, duty and parameter scopes.
   */
  async provideLiveValues(
    fuelOnB: number,
    pin: string,
    flightId_nextFlight: string,
    personsAboard: number
  ): Promise<LiveValue[]> {
    return paramCache.withParamCache(() =>
      this.provideLiveValuesInner(fuelOnB, pin, flightId_nextFlight, personsAboard)
    );
  }

  private async provideLiveValuesInner(
    fuelOnB: number,
    pin: string,
    flightId_nextFlight: string,
    personsAboard: number
  ): Promise<LiveValue[]> {
    const wbaperf = new mAndBandPerformance();

    const dutyLimits: dutyAuthStruct = await this.getDutyLimits(pin);
    if (!dutyLimits) {
      return;
    }

    const fcc = new fccProvider();

    const opsMissionTypesOfDuty = dutyLimits.parameters;
    const activeOpsMissionTypes: opsMissionTypeEnum[] = [];

    let activeDutyId = classCom.activeDutyId;

    if (isMissingDutyId(activeDutyId)) {
      // The fallback resolves the duty via `flightlistByFlightId` — that query
      // binds @flightId, and JSON.stringify drops undefined keys, so a missing
      // flightId surfaces server-side as "Missing named parameter flightId" on
      // the web build (cryptic 500). Bail early when there's no flight in
      // sight: no duty, no live values, no point calling deeper.
      if (!flightId_nextFlight) return;
      activeDutyId = await fcc.getDutyIdOfFlight(flightId_nextFlight, classCom);
    }

    if (isMissingDutyId(activeDutyId)) {
      return;
    }

    for (const key in opsMissionTypeEnum) {
      const parsedKey = parseInt(key);
      const enumValue = opsMissionTypeEnum[parsedKey];

      // needed that parsing and splitting as "ems" is always included :(.
      const parsedValues: string[] = parseCss(opsMissionTypesOfDuty, "opsMissionType")
        .replace("[", "")
        .replace("]", "")
        .split(",");

      if (parsedValues.includes(enumValue)) {
        activeOpsMissionTypes.push(parsedKey);
      }
    }

    // get persons aboard of upcoming flight. The booked crew and the actual
    // persons aboard depend on nothing from each other: start them together.
    const bookedCrewRead = fcc.getScheduledPaxAboard(activeDutyId, classCom);
    bookedCrewRead.catch(() => undefined);
    let actualOnBoardRead: Promise<string | undefined>;
    if (flightId_nextFlight !== undefined) {
      const uid = classCom.package_md5(flightId_nextFlight.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);
      actualOnBoardRead = getParameterValue(uid, "loading", property.actNbrpersonsAboard, opsMissionTypeEnum.all);
      actualOnBoardRead.catch(() => undefined);
    }

    const actualOnBoardStr = flightId_nextFlight !== undefined ? await actualOnBoardRead : undefined;
    if (flightId_nextFlight !== undefined && actualOnBoardStr !== undefined && personsAboard == undefined) {
      personsAboard = parseInt(actualOnBoardStr);
    }

    // The two hoist ratings start together, and while the booked crew is read.
    const ratingPposRead =
      flightId_nextFlight !== undefined
        ? wbaperf.getHoistRatingLoadOfAllActiveMissionTypes_forFlight(
            flightId_nextFlight,
            dutyLimits.missionLimits.extraWeight,
            personsAboard,
            activeOpsMissionTypes,
            fuelOnB
          )
        : wbaperf.getHoistRatingLoadOfAllActiveMissionTypes_ofDuty(
            activeDutyId,
            fuelOnB,
            dutyLimits.missionLimits.extraWeight,
            personsAboard,
            activeOpsMissionTypes
          );
    ratingPposRead.catch(() => undefined);
    const ratingDestRead =
      flightId_nextFlight !== undefined
        ? wbaperf.getHoistRatingLoadOfAllActiveMissionTypes_forFlight(
            flightId_nextFlight,
            dutyLimits.missionLimits.extraWeight,
            personsAboard,
            activeOpsMissionTypes
          )
        : undefined;
    ratingDestRead?.catch(() => undefined);

    const bookedCrew = await bookedCrewRead;

    // get actual persons aboard of focus flight
    let bookedCrewLiveValue: any;

    if (flightId_nextFlight !== undefined) {
      if (actualOnBoardStr === undefined) {
        // No actNbrpersonsAboard recorded — surface "--" rather than feed a silent
        // zero into the hoist/winch calculation. personsAboard stays as the caller
        // supplied it (which may itself be undefined; that propagates downstream
        // as NaN, failing loud rather than masking with a fake zero).
        bookedCrewLiveValue = {
          key: ["personsAboard"],
          value: [],
          md_report: "--",
          svg: "",
        };
      } else {
        const actualOnBoard = parseInt(actualOnBoardStr);

        let txt: string = actualOnBoard + " (" + bookedCrew + "+" + (actualOnBoard - bookedCrew) + ")";

        if (actualOnBoard - bookedCrew < 0) {
          txt = actualOnBoard + " (" + bookedCrew + "-" + Math.abs(actualOnBoard - bookedCrew) + ")";
        }

        bookedCrewLiveValue = {
          key: ["personsAboard"],
          value: [actualOnBoard],
          md_report: txt,
          svg: "",
        };
      }
    } else {
      bookedCrewLiveValue = {
        key: ["personsAboard"],
        value: [bookedCrew],
        md_report: bookedCrew,
        svg: "",
      };
    }

    const maxWinchMassLimit_ppos = await ratingPposRead;
    const maxWinchMassLimit_dest = ratingDestRead ? await ratingDestRead : undefined;

    return [maxWinchMassLimit_ppos, maxWinchMassLimit_dest, bookedCrewLiveValue];
  }
}
// MASS AND BALANCE AND PERFORMANCE //
// ----------------------------------------------------- //
export class mAndBandPerformance {
  /**
   * The error that aborted the last `initMassAndBalance` run, or `undefined` if
   * it succeeded. `initMassAndBalance` catches everything thrown inside its own
   * `try` and returns `false`, so without this the only trace of the real fault
   * is a `console.log` — which on iOS reaches nobody (the JS console bridge was
   * removed for perf). A
   * caller that reports failure to the operator MUST surface this instead of
   * dereferencing the report row the aborted run never wrote: that produced the
   * long-standing "could not create mass and balance calc3! TypeError: Cannot
   * read properties of undefined (reading 'processReport')", which names the
   * symptom and hides the cause.
   *
   * NOT a total catch: the opening parameter writes run before that `try`, so
   * the promise can still reject with `lastError` unset. Keep a `catch` around
   * the call as well as checking the boolean.
   */
  lastError: unknown = undefined;

  // Shared empty hoist-load result — used by the !acft guards so the shape can't
  // drift out of sync across call sites when the contract gains a field.
  private emptyHoistResult(): { key: string[]; value: number[]; md_report: string; svg: string; annunciators: string } {
    return { key: [], value: [], md_report: "", svg: "", annunciators: "" };
  }

  async updateMassAndBalance(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    extraWeight: number,
    checksum: string,
    pob: number = -1
  ): Promise<boolean> {
    try {
      const uid = classCom.package_md5(flightId.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);
      // Missing params throw [0].value → caught below → W&B skipped. Don't swap for getParameterNumber:
      // its 0 fallback would silently feed bogus crew/fuel into mass-and-balance.
      // The two parameter reads and the crew read of the step depend on
      // nothing from each other: start them together, await them in order.
      const fuelOnBoardRead = getParameter(uid, "fuel", property.actFuelOnBoard, opsMissionTypeEnum.all);
      fuelOnBoardRead.catch(() => undefined);
      const pobRead =
        pob == -1 ? getParameter(uid, "loading", property.actNbrpersonsAboard, opsMissionTypeEnum.all) : undefined;
      pobRead?.catch(() => undefined);
      const fccStarted = new fccProvider();
      const loadingRowsStarted = fccStarted
        .getDutyIdOfFlight(flightId, classCom)
        .then((dutyId) => fccStarted.readLoading(dutyId, classCom));
      loadingRowsStarted.catch(() => undefined);

      const fuelOnBoard = parseInt(await (await fuelOnBoardRead)[0].value);

      if (pob == -1) {
        pob = parseInt(await (await pobRead)[0].value);
      }

      if (!Number.isInteger(pob) || pob < 1) {
        throw new Error("Flight " + flightId + " has no usable stored persons-on-board count");
      }

      // Report what actually happened instead of a hardcoded `true`, and keep
      // `err` in `lastError` for a caller that wants to surface it.
      //
      // BOTH callers now ACT on this value: `updateOfpCalculations` stops the
      // chain and retracts downstream, and ops-control's ahead-flight recycle
      // stops before performance, alerts naming the step, and invalidates the
      // flights behind it. A caller reporting the failure to the operator also
      // surfaces `lastError` — do not stop setting it.
      return await this.initMassAndBalance(
        flightId,
        opsMissionType,
        "",
        extraWeight,
        pob,
        fuelOnBoard,
        checksum,
        loadingRowsStarted
      );
    } catch (err) {
      console.log("WARN: could not mass and balance calc! " + err);
      this.lastError = err;
      return false;
    }
  }
  async initMassAndBalance(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    parameters: string,
    extraWeight: number,
    personsAboard: number,
    fuelOnBoard: number,
    checksum: string,
    loadingRowsStarted?: Promise<any[]>
  ): Promise<boolean> {
    // first et fuel on board

    this.lastError = undefined;

    const uid = classCom.package_md5(flightId.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);
    await addParameter(
      uid,
      "loading",
      property.actNbrpersonsAboard,
      opsMissionTypeEnum.all,
      personsAboard.toString(),
      "",
      "",
      "",
      "",
      true
    );

    // a quick explaination to the optional parameters: 'extraWeight' and 'nbrOfPax'
    // those are both kinda "last minute changes"

    // - extra weight: this function will fill all seats with default weight, that is set in
    const cfvProvider = new opsAocRulesProvider();
    const paxDefaultWeight: number = cfvProvider.paxDefaultWeight;
    const extraWeightCargoPos: number = cfvProvider.getExtraWeightPos;

    const fcc = new fccProvider();
    const fpp = new fppProvider();

    // - extra weight will be put on a certain position (as kinda cargo)

    // get aircraft
    try {
      // The figures and the elements of this run stay in memory and go into
      // the calculation result. They are not written as parameter rows or as
      // loading element rows.
      const figures = new CalcFigures();
      // Reads that need nothing from each other start together and are
      // awaited where their value is used. The registration and the flight
      // are the roots: aircraft reads follow the registration, the crew read
      // follows the duty id.
      const startRead = <T>(read: Promise<T>): Promise<T> => {
        read.catch(() => undefined);
        return read;
      };
      const registrationRead = startRead(
        getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all)
      );
      const fuelP = new fuelCalcReport();
      const taxiFuelRead = startRead(fuelP.getTaxiFuel(classCom, opsMissionType, flightId));
      const currentAircraftO = await registrationRead;
      const acftRegistration: string = currentAircraftO[0].value;

      const emptySeatsRead = startRead(fpp.getEmptySeats(acftRegistration, classCom));
      const equipmentRead = startRead(
        fpp.getLoadingObjectsAircraftModel(acftRegistration, payloadCodeTypeEnum.equipment, classCom)
      );
      const optEquipmentRead = startRead(
        fpp.getLoadingObjectsAircraftModel(acftRegistration, payloadCodeTypeEnum.optionalEquipment, classCom)
      );
      const emptyWeightRead = startRead(
        fpp.getLoadingObjectsAircraftModel(acftRegistration, payloadCodeTypeEnum.emptyWeight, classCom)
      );
      const cargoSpaceRead = startRead(
        fpp.getLoadingObjectsAircraftModel(acftRegistration, payloadCodeTypeEnum.cargo, classCom)
      );
      const fuelTanksRead = startRead(
        fpp.getLoadingObjectsAircraftModel(acftRegistration, payloadCodeTypeEnum.fuel, classCom)
      );
      const aircraftDataRead = startRead(fpp.getAircraftData(acftRegistration, classCom));
      const loadingRowsRead = startRead(
        loadingRowsStarted ??
          fcc.getDutyIdOfFlight(flightId, classCom).then((dutyId) => fcc.readLoading(dutyId, classCom))
      );

      let aircraftAvailSeats: PayLoadStruct[] = await emptySeatsRead;
      let newTimestamp = new Date().getTime();

      // this function creates the data set on the loading table and puts all the loadingitems necessary (aircraft fpp and crew related fcc on board)
      // into the loadingElements table

      // Each element gets a uid from its content (loadingElementUid).
      const elementKeysSeen = new Map<string, number>();
      // Every element this rebuild keeps, for the calculation result.
      const resultElements: CalcElement[] = [];

      // these are all fcc loading elements
      // this flights flightcrewId

      let allLoading: PayLoadStruct[] = [];

      const loadingRows = await loadingRowsRead;
      // The reader retains inactive roster members with zero mass for display.
      // They must not consume seats or contribute to the persons-aboard count.
      const crew: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crew).filter((p) => p.active);
      const pic: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pic).filter((p) => p.active);
      const fo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.fo).filter((p) => p.active);
      const crewCargo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crewCargo);

      const pax_raw: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pax);

      let pax: PayLoadStruct[] = [];
      for (let p = 0; p < pax_raw.length; p++) {
        if (pax_raw[p].weightValue > 0) {
          pax.push(pax_raw[p]);
        }
      }

      // the duty OFP Extra Weight case !! IMPORTANT
      // add the duty OFP Extra weight,
      if (extraWeight > 0) {
        const extraWeight_item: PayLoadStruct = new PayLoadStruct();
        extraWeight_item.weightMax = extraWeight;
        extraWeight_item.weightMin = 0;
        extraWeight_item.weightValue = extraWeight;
        extraWeight_item.name = "last min change: extra weight";
        extraWeight_item.unitLoad = payloadUnitEnum.kg;
        extraWeight_item.codeType = payloadCodeTypeEnum.cargo;
        extraWeight_item.parameters = "position:" + extraWeightCargoPos.toString();
        allLoading.push(extraWeight_item);
      }

      // passenger aboard, apart from the crew
      if (personsAboard != undefined) {
        // get a flightCrewList:
        let flightCrew: PayLoadStruct[] = crew.filter((member) => member.active);

        flightCrew = flightCrew.concat(pic);

        if (fo.length !== 0) {
          flightCrew = flightCrew.concat(fo);
        }

        const minPersonAboardReq_flightcrew: number = 1;

        // check nbr is too little
        if (personsAboard < minPersonAboardReq_flightcrew) {
          const msg =
            "persons aboard cant be less then the minimum required flightcrew of " + minPersonAboardReq_flightcrew;
          classCom.promptMessage(msg, msgCatStruct.err);
          // The other `return false` (the catch) carries the thrown error; this
          // one is a validation stop, so give callers the same shape rather than
          // an undefined `lastError` they'd have to paper over.
          this.lastError = new Error(msg);
          return false;
        }

        let flightCrewAndBookedPax: PayLoadStruct[] = flightCrew;

        // cfv dependency
        pax = cfvProvider.changePaxLoadingDependingOnOpsMissionType(pax, opsMissionType);

        flightCrewAndBookedPax = flightCrewAndBookedPax.concat(pax);

        // those are the last min to add passengers - with standard weight
        let addPaxNbr: number = personsAboard - flightCrewAndBookedPax.length;

        if (addPaxNbr + flightCrewAndBookedPax.length > aircraftAvailSeats.length) {
          classCom.promptMessage(
            "not enough seats, set to pob to max nbr of :" + aircraftAvailSeats.length,
            msgCatStruct.warn
          );
          addPaxNbr = aircraftAvailSeats.length - flightCrewAndBookedPax.length;
        }

        // check if we have to add or unload passengers
        if (addPaxNbr < 0) {
          try {
            let unloadedPaxStrg: string = "";
            for (let rem = 0; rem < Math.abs(addPaxNbr); rem++) {
              const delIdx: number = pax.length - rem - 1;

              if (pax.length > 0) {
                pax.splice(delIdx, 1);
              } else {
                if (crew.length > 0) {
                  let delIdx2: number = crew.length - rem;

                  crew.splice(delIdx2, 1);
                }
              }
            }
          } catch (err) {
            console.log("warn: pax setting fault: #23422 " + err);
          }
        }

        // add passengers (default)

        if (addPaxNbr > 0) {
          for (let i = 0; i < addPaxNbr; i++) {
            const pax_Item: PayLoadStruct = new PayLoadStruct();
            pax_Item.weightMax = 120;
            pax_Item.weightMin = 0;
            pax_Item.weightValue = paxDefaultWeight;
            pax_Item.name = "Passenger " + (i + 1);
            pax_Item.unitLoad = payloadUnitEnum.kg;
            pax_Item.codeType = payloadCodeTypeEnum.pax;
            pax_Item.parameters = "opsMissionType:";
            pax.push(pax_Item);
          }
        }
      }

      const cargo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.cargo);
      const aircraftEquipment: PayLoadStruct[] = await equipmentRead;
      const aircraft_optEquipment: PayLoadStruct[] = await optEquipmentRead;
      allLoading = allLoading.concat(aircraftEquipment);
      const equipmentSelections = fcc.loadingOf(loadingRows, false, payloadCodeTypeEnum.optionalEquipment);
      allLoading = allLoading.concat(
        selectInstalledEquipment(aircraft_optEquipment, equipmentSelections, opsMissionTypeEnum[opsMissionType])
      );
      allLoading = allLoading.concat(pic);
      allLoading = allLoading.concat(fo);
      allLoading = allLoading.concat(crew);
      allLoading = allLoading.concat(crewCargo);
      allLoading = allLoading.concat(pax);
      allLoading = allLoading.concat(cargo);

      const acft: PayLoadStruct[] = await emptyWeightRead;
      const acftEmptyWeight = acft[0].weightValue;
      const acftEmptyMomentX = acft[0].loadArmX * acft[0].weightValue;
      const acftEmptyMomentY = acft[0].loadArmY * acft[0].weightValue;

      let aircraftCargoSpace: PayLoadStruct[] = await cargoSpaceRead;

      // to have to positions for crew cargo as well
      aircraftCargoSpace = aircraftCargoSpace.concat(aircraftAvailSeats);

      const cfgLoading: loadingStruct = new loadingStruct();
      cfgLoading.flightId = flightId;
      cfgLoading.opsMissionType = opsMissionType;

      let loadingElements: parameterStruct[] = [];

      // loading the aircraft with equipment and crew and pax
      for (let i = 0; i < allLoading.length; i++) {
        let opsMissionTypeOfEntry: opsMissionTypeEnum = undefined;

        try {
          if (allLoading[i].parameters != "")
            opsMissionTypeOfEntry = opsMissionTypeOfEntry =
              opsMissionTypeEnum[parseCss(allLoading[i].parameters, "opsMissionType")];
        } catch (err) {
          console.log("initMassAndBalance: opsMissionTypeOfEntry could not be read");
        }

        // filter only the requested opsMissiontype

        if (opsMissionTypeOfEntry == opsMissionType || opsMissionTypeOfEntry == undefined) {
          let lelm: parameterStruct;

          // duty assignment
          const duty: string = parseCss(allLoading[i].parameters, "duty");
          let dt: loadingElementDuty;

          switch (duty?.toUpperCase()) {
            case "3":
            case "TCHEMS":
            case "HEMS-TC": {
              dt = loadingElementDuty.hcm;
              break;
            }
            case "4":
            case "DOC":
            case "DOCTOR":
            case "MED":
            case "MEDIC": {
              dt = loadingElementDuty.med;
              break;
            }
          }

          if (allLoading[i].codeType == payloadCodeTypeEnum.pic) {
            dt = loadingElementDuty.pic;
          }
          if (allLoading[i].codeType == payloadCodeTypeEnum.fo) {
            dt = loadingElementDuty.fo;
          }

          // arms x and y
          // find a seat either for  pic/fo/crew/pax
          let armX: number = 0;
          let armY: number = 0;
          let seatSel: string = "NONE";
          if (
            allLoading[i].codeType == payloadCodeTypeEnum.pax ||
            allLoading[i].codeType == payloadCodeTypeEnum.crew ||
            allLoading[i].codeType == payloadCodeTypeEnum.pic ||
            allLoading[i].codeType == payloadCodeTypeEnum.fo
          ) {
            // need to find the seats first
            const phone: string = parseCss(allLoading[i].parameters, "phone");
            const position: string = parseCss(allLoading[i].parameters, "position");

            for (let seat = 0; seat < aircraftAvailSeats.length; seat++) {
              const posOnAcft: string = parseCss(aircraftAvailSeats[seat].parameters, "position");
              if (position == posOnAcft) {
                armX = aircraftAvailSeats[seat].loadArmX;
                armY = aircraftAvailSeats[seat].loadArmY;

                seatSel = aircraftAvailSeats[seat].name.toString();
                aircraftAvailSeats.splice(seat, 1);
                break;
              }
            }

            // cfv hack
            aircraftAvailSeats = cfvProvider.removeSeatsOfOpsMissionType(aircraftAvailSeats, opsMissionType);

            // give a seat if not assigned
            if (seatSel == "NONE") {
              if (aircraftAvailSeats.length > 0) {
                const seat = aircraftAvailSeats.length - 1;
                console.log("Seat assigned: " + allLoading[i].name + " --> " + aircraftAvailSeats[seat].name);

                seatSel = aircraftAvailSeats[seat].name.toString();

                armX = aircraftAvailSeats[seat].loadArmX;
                armY = aircraftAvailSeats[seat].loadArmY;

                aircraftAvailSeats.splice(aircraftAvailSeats.length - 1);
              } else {
                classCom.promptMessage(
                  "no seat left for: " +
                    allLoading[i].name +
                    ", ops-mission-type: " +
                    opsMissionTypeEnum[opsMissionType],
                  msgCatStruct.warn
                );
                continue;
              }
            }

            lelm = new parameterStruct();
            lelm.tableSuffix = "loadingElements";
            lelm.parameter = property.txtSeatPosition;
            lelm.value = seatSel;
            loadingElements.push(lelm);

            lelm = new parameterStruct();
            lelm.tableSuffix = "loadingElements";
            lelm.parameter = property.txtPhone;
            lelm.value = phone;
            if (phone != undefined) {
              loadingElements.push(lelm);
            }
          }

          // find the corresponding place for cargo and equipment
          if (
            allLoading[i].codeType == payloadCodeTypeEnum.cargo ||
            allLoading[i].codeType == payloadCodeTypeEnum.crewCargo
          ) {
            const position: string = parseCss(allLoading[i].parameters, "position");

            // find the cargo section on the plane
            let cargoSpaceNotFound: boolean = true;
            let cargoCompUsed: string = "";
            for (let cargoSpace = 0; cargoSpace < aircraftCargoSpace.length; cargoSpace++) {
              const posOnAcft: string = parseCss(aircraftCargoSpace[cargoSpace].parameters, "position");
              if (position == posOnAcft) {
                armX = aircraftCargoSpace[cargoSpace].loadArmX;
                armY = aircraftCargoSpace[cargoSpace].loadArmY;

                cargoSpaceNotFound = false;
                cargoCompUsed = allLoading[i].name;
                break;
              }
            }

            // if not found
            if (cargoSpaceNotFound == true) {
              classCom.promptMessage(
                "cargo-department not found: position:" + position + " (" + allLoading[i].name + ") !",
                msgCatStruct.warn
              );
              continue;
            }

            lelm = new parameterStruct();
            lelm.tableSuffix = "loadingElements";
            lelm.parameter = property.txtCargoComp;
            lelm.value = cargoCompUsed;
            loadingElements.push(lelm);
          }

          // equipment and optional equipment
          if (
            allLoading[i].codeType == payloadCodeTypeEnum.equipment ||
            allLoading[i].codeType == payloadCodeTypeEnum.optionalEquipment
          ) {
            armX = allLoading[i].loadArmX;
            armY = allLoading[i].loadArmY;
          }

          lelm = new parameterStruct();
          lelm.tableSuffix = "loadingElements";
          lelm.parameter = property.codeDescr;
          lelm.value = allLoading[i].name;
          loadingElements.push(lelm);

          lelm = new parameterStruct();
          lelm.tableSuffix = "loadingElements";
          lelm.parameter = property.codeType;
          lelm.value = allLoading[i].codeType.toString();
          loadingElements.push(lelm);

          lelm = new parameterStruct();
          lelm.tableSuffix = "loadingElements";
          lelm.parameter = property.weightValue;
          lelm.value = allLoading[i].weightValue.toString();
          loadingElements.push(lelm);

          lelm = new parameterStruct();
          lelm.tableSuffix = "loadingElements";
          lelm.parameter = property.valLoadArmX;
          lelm.value = armX.toString();
          loadingElements.push(lelm);

          lelm = new parameterStruct();
          lelm.tableSuffix = "loadingElements";
          lelm.parameter = property.valLoadArmY;
          lelm.value = armY.toString();
          loadingElements.push(lelm);

          newTimestamp += 1;
          const uid = loadingElementUid(
            classCom.package_md5,
            flightId.toString(),
            opsMissionType,
            allLoading[i].codeType,
            allLoading[i].name,
            loadingElements,
            elementKeysSeen
          );
          resultElements.push({
            uid,
            payLoadCodeType: allLoading[i].codeType,
            designator: allLoading[i].name,
            values: valuesFromParams(loadingElements),
          });

          loadingElements = [];
        }
      }

      // fuel the aircraft with standard fuel (or if fuelOnBoard (function param) > 0 use that one)
      // -------------------------------------
      const aircraft: aircraftStruct = await aircraftDataRead;

      // handle fuel on board 0 -> to be standard fuel
      if (fuelOnBoard == 0) {
        fuelOnBoard = aircraft.tacticalStandardFuel;
      }

      let fuelTanks: PayLoadStruct[] = await fuelTanksRead;

      let unusableFuelMassSum: number = 0;
      let unusableFuelEquMomxSum: number = 0;
      let unusableFuelEquMomySum: number = 0;

      // calc unusable fuel
      for (let ft = 0; ft < fuelTanks.length; ft++) {
        unusableFuelMassSum += fuelTanks[ft].weightMax - fuelTanks[ft].weightMaxUsable;
      }

      const onlyUnusableFuel = fpp.fuelAircraft(fuelTanks, unusableFuelMassSum);

      for (let ft = 0; ft < onlyUnusableFuel.length; ft++) {
        unusableFuelEquMomxSum +=
          onlyUnusableFuel[ft].loadArmX * (onlyUnusableFuel[ft].weightMax - onlyUnusableFuel[ft].weightMaxUsable);
        unusableFuelEquMomySum +=
          onlyUnusableFuel[ft].loadArmY * (onlyUnusableFuel[ft].weightMax - onlyUnusableFuel[ft].weightMaxUsable);
      }

      fuelTanks = fpp.fuelAircraft(fuelTanks, fuelOnBoard);

      for (let ft = 0; ft < fuelTanks.length; ft++) {
        let lelm = new parameterStruct();
        lelm.tableSuffix = "loadingElements";
        lelm.parameter = property.codeDescr;
        lelm.value = fuelTanks[ft].name;
        loadingElements.push(lelm);

        lelm = new parameterStruct();
        lelm.tableSuffix = "loadingElements";
        lelm.parameter = property.codeType;
        lelm.value = fuelTanks[ft].codeType.toString();
        loadingElements.push(lelm);

        lelm = new parameterStruct();
        lelm.tableSuffix = "loadingElements";
        lelm.parameter = property.weightValue;
        lelm.value = fuelTanks[ft].weightValue.toString();
        loadingElements.push(lelm);

        lelm = new parameterStruct();
        lelm.tableSuffix = "loadingElements";
        lelm.parameter = property.valLoadArmX;
        lelm.value = fuelTanks[ft].loadArmX.toString();
        loadingElements.push(lelm);

        lelm = new parameterStruct();
        lelm.tableSuffix = "loadingElements";
        lelm.parameter = property.valLoadArmY;
        lelm.value = fuelTanks[ft].loadArmY.toString();
        loadingElements.push(lelm);

        newTimestamp += 1;
        const uid = loadingElementUid(
          classCom.package_md5,
          flightId.toString(),
          opsMissionType,
          fuelTanks[ft].codeType,
          fuelTanks[ft].name,
          loadingElements,
          elementKeysSeen
        );
        resultElements.push({
          uid,
          payLoadCodeType: fuelTanks[ft].codeType,
          designator: fuelTanks[ft].name,
          values: valuesFromParams(loadingElements),
        });

        loadingElements = [];
      }

      // all sorts of calculation
      // The elements of this run, by type, from memory.
      const wAndB = new loadAndBalanceReport();
      const [
        installedEquipment,
        optionalEquipment,
        fuelTanksLoaded,
        paxLoaded,
        cargoLoaded,
        crewLoaded,
        picLoaded,
        foLoaded,
        crewCLoaded,
      ] = wAndB.loadingObjectsOf(resultElements, flightId, [
        payloadCodeTypeEnum.equipment,
        payloadCodeTypeEnum.optionalEquipment,
        payloadCodeTypeEnum.fuel,
        payloadCodeTypeEnum.pax,
        payloadCodeTypeEnum.cargo,
        payloadCodeTypeEnum.crew,
        payloadCodeTypeEnum.pic,
        payloadCodeTypeEnum.fo,
        payloadCodeTypeEnum.crewCargo,
      ]);

      let acftEquMassSum: number = 0;
      let acftEquMomxSum: number = 0;
      let acftEquMomySum: number = 0;

      for (let i = 0; i < installedEquipment.length; i++) {
        acftEquMassSum += installedEquipment[i].weightValue;
        acftEquMomxSum += installedEquipment[i].loadArmX * installedEquipment[i].weightValue;
        acftEquMomySum += installedEquipment[i].loadArmY * installedEquipment[i].weightValue;
      }

      let acftOptEquMassSum: number = 0;
      let acftOptEquMomxSum: number = 0;
      let acftOptEquMomySum: number = 0;
      for (let i = 0; i < optionalEquipment.length; i++) {
        acftOptEquMassSum += optionalEquipment[i].weightValue;
        acftOptEquMomxSum += optionalEquipment[i].loadArmX * optionalEquipment[i].weightValue;
        acftOptEquMomySum += optionalEquipment[i].loadArmY * optionalEquipment[i].weightValue;
      }

      let fuelEquMassSum: number = 0;
      let fuelEquMomxSum: number = 0;
      let fuelEquMomySum: number = 0;

      for (let i = 0; i < fuelTanksLoaded.length; i++) {
        fuelEquMassSum += fuelTanksLoaded[i].weightValue;
        fuelEquMomxSum += fuelTanksLoaded[i].loadArmX * fuelTanksLoaded[i].weightValue;
        fuelEquMomySum += fuelTanksLoaded[i].loadArmY * fuelTanksLoaded[i].weightValue;
      }

      let paxMassSum: number = 0;
      let paxMomxSum: number = 0;
      let paxMomySum: number = 0;
      if (paxLoaded.length !== pax.length) {
        throw new Error(
          `Aircraft ${acftRegistration}: only ${paxLoaded.length} of ${pax.length} passengers have a loading position ` +
            `for mission ${opsMissionTypeEnum[opsMissionType]}. Check persons aboard and the mission seat configuration.`
        );
      }
      for (let i = 0; i < paxLoaded.length; i++) {
        paxMassSum += paxLoaded[i].weightValue;
        paxMomxSum += paxLoaded[i].loadArmX * paxLoaded[i].weightValue;
        paxMomySum += paxLoaded[i].loadArmY * paxLoaded[i].weightValue;
      }

      let cargoMassSum: number = 0;
      let cargoMomxSum: number = 0;
      let cargoMomySum: number = 0;

      for (let i = 0; i < cargoLoaded.length; i++) {
        cargoMassSum += cargoLoaded[i].weightValue;
        cargoMomxSum += cargoLoaded[i].loadArmX * cargoLoaded[i].weightValue;
        cargoMomySum += cargoLoaded[i].loadArmY * cargoLoaded[i].weightValue;
      }

      let crewCrewCargoMassSum: number = 0;
      let crewCrewCargoMomxSum: number = 0;
      let crewCrewCargoMomySum: number = 0;

      for (let i = 0; i < picLoaded.length; i++) {
        crewCrewCargoMassSum += picLoaded[i].weightValue;
        crewCrewCargoMomxSum += picLoaded[i].loadArmX * picLoaded[i].weightValue;
        crewCrewCargoMomySum += picLoaded[i].loadArmY * picLoaded[i].weightValue;
      }
      for (let i = 0; i < foLoaded.length; i++) {
        crewCrewCargoMassSum += foLoaded[i].weightValue;
        crewCrewCargoMomxSum += foLoaded[i].loadArmX * foLoaded[i].weightValue;
        crewCrewCargoMomySum += foLoaded[i].loadArmY * foLoaded[i].weightValue;
      }
      for (let i = 0; i < crewLoaded.length; i++) {
        crewCrewCargoMassSum += crewLoaded[i].weightValue;
        crewCrewCargoMomxSum += crewLoaded[i].loadArmX * crewLoaded[i].weightValue;
        crewCrewCargoMomySum += crewLoaded[i].loadArmY * crewLoaded[i].weightValue;
      }
      for (let i = 0; i < crewCLoaded.length; i++) {
        crewCrewCargoMassSum += crewCLoaded[i].weightValue;
        crewCrewCargoMomxSum += crewCLoaded[i].loadArmX * crewCLoaded[i].weightValue;
        crewCrewCargoMomySum += crewCLoaded[i].loadArmY * crewCLoaded[i].weightValue;
      }

      // DRY operating
      // ==================================================================
      const dryOperatingMass: number = acftEmptyWeight + acftOptEquMassSum + crewCrewCargoMassSum + unusableFuelMassSum;
      const dryOperatingMomentX: number =
        acftEmptyMomentX + acftOptEquMomxSum + crewCrewCargoMomxSum + unusableFuelEquMomxSum;
      const dryOperatingMomentY: number =
        acftEmptyMomentY + +acftOptEquMomySum + crewCrewCargoMomySum + unusableFuelEquMomySum;

      figures.set(property.dryOperatingMass, round(dryOperatingMass, 0).toString());
      const dryCgX: number = round(dryOperatingMomentX / dryOperatingMass, 2);
      const dryCgY: number = round(dryOperatingMomentY / dryOperatingMass, 2);
      figures.set(property.dryCgPositionX, round(dryCgX, 2).toString());
      figures.set(property.dryCgPositionY, round(dryCgY, 2).toString());

      figures.set(property.crewMass, round(crewCrewCargoMassSum, 0).toString());
      figures.set(property.paxLoadMass, round(paxMassSum, 0).toString());
      figures.set(property.cargoLoadMass, round(cargoMassSum, 0).toString());

      // ZERO FUEL
      // ==================================================================
      const zeroFuelMass: number =
        acftEmptyWeight +
        cargoMassSum +
        paxMassSum +
        crewCrewCargoMassSum +
        acftOptEquMassSum +
        acftEquMassSum +
        unusableFuelMassSum;
      const zeroFuelMomentX: number =
        acftEmptyMomentX +
        cargoMomxSum +
        paxMomxSum +
        crewCrewCargoMomxSum +
        acftOptEquMomxSum +
        acftEquMomxSum +
        unusableFuelEquMomxSum;
      const zeroFuelMomentY: number =
        acftEmptyMomentY +
        cargoMomySum +
        paxMomySum +
        crewCrewCargoMomySum +
        acftOptEquMomySum +
        acftEquMomySum +
        unusableFuelEquMomxSum;
      const zeroFuelCgX: number = round(zeroFuelMomentX / zeroFuelMass, 2);
      const zeroFuelCgY: number = round(zeroFuelMomentY / zeroFuelMass, 2);

      figures.set(property.zeroFuelMass, round(zeroFuelMass, 0).toString());
      figures.set(property.zeroFuelcenterOfGravityX, round(zeroFuelCgX, 2).toString());
      figures.set(property.zeroFuelcenterOfGravityY, round(zeroFuelCgY, 2).toString());

      // EMPTY EQUIPPED
      // ==================================================================
      const emptyEquippedMass: number = acftEmptyWeight + acftEquMassSum + unusableFuelMassSum;
      const emptyEquippedMomentX: number = acftEmptyMomentX + acftEquMomxSum + unusableFuelEquMomxSum;
      const emptyEquippedMomentY: number = acftEmptyMomentY + acftEquMomySum + unusableFuelEquMomySum;
      const emptyEquippedCgX: number = round(emptyEquippedMomentX / emptyEquippedMass, 2);
      const emptyEquippedCgY: number = round(emptyEquippedMomentY / emptyEquippedMass, 2);

      figures.set(property.emptyEquippedMass, round(emptyEquippedMass, 0).toString());
      figures.set(property.emptyEuippedcenterOfGravityX, round(emptyEquippedCgX, 2).toString());
      figures.set(property.emptyEuippedcenterOfGravityY, round(emptyEquippedCgY, 2).toString());

      // takeoff
      // ===================================================================
      // takeoff fuel mass
      const taxifuel: number = await taxiFuelRead;
      const takeOffFuelMass = fuelEquMassSum - taxifuel;
      figures.set(property.takeOffFuelMass, round(takeOffFuelMass, 0).toString());

      fuelTanks = fpp.getFuelTankData_burnFuel(fuelTanks, taxifuel);

      const takeoffMass: number =
        fuelEquMassSum +
        crewCrewCargoMassSum +
        paxMassSum +
        acftEquMassSum +
        acftOptEquMassSum +
        acftEmptyWeight +
        cargoMassSum -
        taxifuel;
      figures.set(property.takeOffMass, round(takeoffMass, 0).toString());

      let takeOffFuelMassSum: number = 0;
      let takeOffFuelMomxSum: number = 0;
      let takeOffFuelMomySum: number = 0;

      for (let i = 0; i < fuelTanks.length; i++) {
        takeOffFuelMassSum += fuelTanks[i].weightValue;
        takeOffFuelMomxSum += fuelTanks[i].loadArmX * fuelTanks[i].weightValue;
        takeOffFuelMomySum += fuelTanks[i].loadArmY * fuelTanks[i].weightValue;
      }

      figures.set(property.takeOffFuelMass, round(takeOffFuelMassSum, 0).toString());
      const takeoffMomentX: number =
        takeOffFuelMomxSum +
        crewCrewCargoMomxSum +
        paxMomxSum +
        acftEquMomxSum +
        acftOptEquMomxSum +
        acftEmptyMomentX +
        cargoMomxSum;
      const takeoffMomentY: number =
        takeOffFuelMomySum +
        crewCrewCargoMomySum +
        paxMomySum +
        acftEquMomySum +
        acftOptEquMomySum +
        acftEmptyMomentY +
        cargoMomySum;

      const takeoffCgX: number = round(takeoffMomentX / takeoffMass, 2);
      const takeoffCgY: number = round(takeoffMomentY / takeoffMass, 2);
      figures.set(property.takeOffcenterOfGravityX, round(takeoffCgX, 2).toString());
      figures.set(property.takeOffCenterOfGravityY, round(takeoffCgY, 2).toString());

      // Landing
      // ===================================================================
      const tripfuel: number = await fuelP.getTripFuel(classCom, opsMissionType, flightId);
      const landingMass: number = takeoffMass - taxifuel - tripfuel;

      fuelTanks = fpp.getFuelTankData_burnFuel(fuelTanks, tripfuel + taxifuel);

      // let landingFuelMassSum: number = 0;
      let landingFuelMomxSum: number = 0;
      let landingFuelMomySum: number = 0;

      for (let i = 0; i < fuelTanks.length; i++) {
        // landingFuelMassSum += fuelTanks[i].weightValue;
        landingFuelMomxSum += fuelTanks[i].loadArmX * fuelTanks[i].weightValue;
        landingFuelMomySum += fuelTanks[i].loadArmY * fuelTanks[i].weightValue;
      }

      const landingMomentX: number =
        landingFuelMomxSum +
        crewCrewCargoMomxSum +
        paxMomxSum +
        acftEquMomxSum +
        acftOptEquMomxSum +
        acftEmptyMomentX +
        cargoMomxSum;
      const landingMomentY: number =
        landingFuelMomySum +
        crewCrewCargoMomySum +
        paxMomySum +
        acftEquMomySum +
        acftOptEquMomySum +
        acftEmptyMomentY +
        cargoMomySum;

      let landingCgX: number = round(landingMomentX / landingMass, 2);
      let landingCgY: number = round(landingMomentY / landingMass, 2);

      if (Number.isNaN(landingCgX)) {
        landingCgX = 0;
        console.log("WARN: cg X was calculated incorrectly!");
      }
      if (Number.isNaN(landingCgY)) {
        landingCgY = 0;
        console.log("WARN: cg Y was calculated incorrectly!");
      }

      figures.set(property.estLandingMass, round(landingMass, 0).toString());
      figures.set(property.estLandingCenterOfGravityX, round(landingCgX, 2).toString());
      figures.set(property.estLandingCenterOfGravityY, round(landingCgY, 2).toString());

      // create processReport
      const lab: loadAndBalanceReport = new loadAndBalanceReport();
      const loadingParams = figures.rows;
      const processReport = await lab.createLoadAndBalanceMarkdown(
        aircraft,
        flightId,
        opsMissionType,
        classCom,
        loadingParams,
        resultElements
      );

      let annunciators: string = "M & B OK";

      // add the envelope checks
      const processResultState: processResultStateEnum = await lab.checkProcessResult(
        aircraft.model,
        classCom,
        flightId,
        opsMissionType,
        loadingParams
      );

      if (processResultState !== processResultStateEnum.ok) {
        annunciators = "M & B " + opsMissionTypeEnum[opsMissionType];
      }

      // insert the LOADING table — deterministic-rowId upsert-in-place (no
      // mark-obsolete pre-step; ON CONFLICT(rowId) revives/updates the row).
      // It joins the parameter flush; the server applies the queue in order.
      // The calculation result: this run's masses, balance and elements as one
      // document.
      const resultJson = buildCalcResult({
        inputs: { fuelOnBoard, pob: personsAboard, extraWeight },
        // The fuel version this run read its taxi and trip fuel from.
        upstream: (await fuelP.liveFuel(classCom, opsMissionType, flightId))?.rowId,
        values: valuesFromParams(loadingParams),
        elements: resultElements,
      });
      const rowId = rowIdFor([flightId, opsMissionType, newTimestamp]);
      const signatureId = await currentSignatureId(flightId, classCom);
      const inserted = queueCommand({
        name: "loadingInsert",
        params: {
          rowId,
          Timestamp: newTimestamp,
          flightId,
          signatureId,
          resultJson,
          checksum,
          emptyMass: acftEmptyWeight,
          opsMissionType,
          parameters,
          annunciators,
          processResultState,
          processReport,
          updatedAt: Date.now(),
        },
      });
      // The flush can settle a reject before the await below reaches it.
      inserted.catch(() => undefined);
      await execAccuParameters();
      await inserted;
      // Performance checks for this row next. It is the latest live loading
      // row of this mission, so the answer is known without a request.
      seedUserRead("loadingProcessResultStateByFlight", { flightId, opsMissionType }, [{ processResultState }]);
      seedUserRead("loadingResultByFlight", { flightId, opsMissionType }, [
        { rowId, resultJson, signatureId, processResultState },
      ]);

      // The success path fell off the end of the try and resolved `undefined`,
      // which is falsy — so `Promise<boolean>` was a lie and every caller
      // checking the result saw a completed W&B as a failure. focMain's own
      // `initMassAndBalance` dispatch case has been logging
      // "warn: no results returned!" on every SUCCESSFUL run because of it.
      return true;
    } catch (err) {
      // A 409 carrying reason 'lww' is a benign no-op, not a write fault: the
      // app-server already holds an equal-or-newer row for this
      // (flightId, opsMissionType). The loadingInsert wrote nothing, but
      // nothing was lost either — treat it as success and do NOT run the
      // destructive rollback, which would obsolete the already-committed
      // loading row on a benign collision (e.g. a concurrent same-row recalc). The browser DB
      // service throws HttpError with a numeric `status`; native never
      // produces a 409 (it writes local SQLite directly).
      //
      // Discriminate on the body, NOT on the status alone — 'not-found',
      // 'immutable' and a per-op SAVEPOINT bind/constraint failure are all
      // 409s that mean the row was REFUSED. Swallowing them returned `true`
      // from a write that never happened, which defeated the create-flight
      // `wandbOk` gate and let the performance step publish a HOGE margin
      // computed against a mass row the server had rejected. Same shape as
      // `fuelCalcReport.initFuel`'s catch.
      if (isBenignLwwReject(err)) {
        console.log("loadingInsert LWW no-op (409) — server holds equal/newer row " + flightId);
        return true;
      }
      // Rollback on a genuine write fault: soft-obsolete EVERY live version of
      // this flight+mission, not just the row this run wrote.
      //
      // The scope is the point. Before `6c961b06` the append-only writers
      // obsoleted this same (flightId, opsMissionType) set on every write and
      // hard-deleted it on failure — either way nothing was live after a failed
      // calculation, which is the invariant `initPerformance`'s liveness gate
      // below still depends on. `6c961b06` collapsed the table to one row per
      // key, so a single rowId WAS the whole set; restoring `Timestamp` to the
      // key silently narrowed this line back to one version and left the
      // PREVIOUS one live and current.
      //
      // AWAITED, and the performance report goes with it. Fire-and-forget let
      // this method return `false` while the UPDATE was still in flight. And
      // retracting only `loading` left the PREVIOUS pass's perf row live and
      // current — an OFP with an empty W&B section beside a HOGE margin computed
      // from the masses this rollback just voided. Performance is written last
      // and read independently, so nothing else retracts it.
      try {
        await classCom.namedCommand("loadingObsoleteByFlightMission", { flightId, opsMissionType });
      } catch (e: unknown) {
        console.error("namedCommand loadingObsoleteByFlightMission: ", e);
      }
      try {
        await classCom.namedCommand("perfObsoleteByFlightMission", { flightId, opsMissionType });
      } catch (e: unknown) {
        console.error("namedCommand perfObsoleteByFlightMission: ", e);
      }
      console.log("flightlist was rolled back " + flightId + "! " + err);
      // Keep the cause reachable by callers — the console line above is the only
      // other copy, and it is invisible on iOS. See the `lastError` docblock.
      this.lastError = err;

      // Nothing else to sweep: this run wrote no loading element rows and no
      // derived parameters. Its figures were in memory only.
      return false;
    }
  }
  async getLoadingHash(flightId: string, acftRegistration: Promise<string>): Promise<string> {
    const fcc = new fccProvider();
    const fpp = new fppProvider();
    let crewAndPicLoading: PayLoadStruct[] = [];
    // The equipment rows need only the registration, so they start with the duty reads.
    const equipmentRead = acftRegistration.then((reg) =>
      fpp.getLoadingObjectsAircraftModel(reg, payloadCodeTypeEnum.equipment, classCom)
    );
    const optEquipmentRead = acftRegistration.then((reg) =>
      fpp.getLoadingObjectsAircraftModel(reg, payloadCodeTypeEnum.optionalEquipment, classCom)
    );
    equipmentRead.catch(() => undefined);
    optEquipmentRead.catch(() => undefined);
    const flightCrewid: string = await fcc.getDutyIdOfFlight(flightId, classCom);
    const loadingRows = await fcc.readLoading(flightCrewid, classCom);
    const crew: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crew);
    const pic: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pic);
    const fo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.fo);
    const crewCargo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crewCargo);
    const pax: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pax);
    const cargo: PayLoadStruct[] = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.cargo);
    const aircraftEquipment: PayLoadStruct[] = await equipmentRead;
    const aircraft_optEquipment: PayLoadStruct[] = await optEquipmentRead;
    crewAndPicLoading = crewAndPicLoading.concat(aircraftEquipment);
    crewAndPicLoading = crewAndPicLoading.concat(aircraft_optEquipment);
    crewAndPicLoading = crewAndPicLoading.concat(pic);
    crewAndPicLoading = crewAndPicLoading.concat(fo);
    crewAndPicLoading = crewAndPicLoading.concat(crew);
    crewAndPicLoading = crewAndPicLoading.concat(crewCargo);
    crewAndPicLoading = crewAndPicLoading.concat(pax);
    crewAndPicLoading = crewAndPicLoading.concat(cargo);

    return classCom.package_md5(JSON.stringify(crewAndPicLoading));
  }

  /**
   * Estimates the total mass and center of gravity (moment arms) for a flight without persisting any changes.
   *
   * This function simulates a full mass and balance setup for the selected ops mission type and flight.
   * It:
   * - Gathers existing crew, passengers, cargo, fuel, and equipment from aircraft and ops data
   * - Optionally simulates additional passengers and extra cargo weight
   * - Applies fuel calculations (standard or given value)
   * - Computes total mass, moment X, and moment Y (used for CG calculations)
   *
   * This function is non-destructive — it performs no writes or database modifications.
   *
   * @param flightId        Unique identifier of the flight
   * @param opsMissionType  Type of mission (e.g., standard, HEMS, ferry)
   * @param extraWeight     Additional unplanned cargo in kg (simulated only)
   * @param personsAboard   Total number of persons expected on board (crew + pax)
   * @param fuelOnBoard     Fuel in kg; if 0, tactical standard fuel is assumed
   * @returns               Object containing estimated total mass and center-of-gravity moments (X and Y)
   */
  async estimateMassAndBalance(
    flightCrewid: string,
    opsMissionType: opsMissionTypeEnum,
    extraWeight: number,
    classCom: opsCntrolCom,
    personsAboard: number,
    fuelOnBoard: number,
    aircraftRegistration: string
  ): Promise<{ totalMass: number; momentX: number; momentY: number; loadingReport: string }> {
    const cfvProvider = new opsAocRulesProvider();
    const paxDefaultWeight: number = cfvProvider.paxDefaultWeight;

    const extraWeightCargoPos: number = cfvProvider.getExtraWeightPos;

    try {
      const fcc = new fccProvider();
      const fpp = new fppProvider();

      // Aircraft data
      const aircraft = await fpp.getAircraftData(aircraftRegistration, classCom);
      if (fuelOnBoard === 0) fuelOnBoard = aircraft.tacticalStandardFuel;

      const loadingRows = await fcc.readLoading(flightCrewid, classCom);
      const crew = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crew);
      const pic = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pic);
      const fo = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.fo);
      const crewCargo = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.crewCargo);
      let pax = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.pax);
      const cargo = fcc.loadingOf(loadingRows, true, payloadCodeTypeEnum.cargo);

      // These are trusted aircraft model payloads and already have arms
      const aircraftEquipment = await fpp.getLoadingObjectsAircraftModel(
        aircraftRegistration,
        payloadCodeTypeEnum.equipment,
        classCom
      );

      const aircraftOptEquipment = await fpp.getLoadingObjectsAircraftModel(
        aircraftRegistration,
        payloadCodeTypeEnum.optionalEquipment,
        classCom
      );
      const aircraftEmpty = await fpp.getLoadingObjectsAircraftModel(
        aircraftRegistration,
        payloadCodeTypeEnum.emptyWeight,
        classCom
      );

      const aircraftAvailSeats = await fpp.getEmptySeats(aircraftRegistration, classCom);

      const fuelTanks = await fpp.getLoadingObjectsAircraftModel(
        aircraftRegistration,
        payloadCodeTypeEnum.fuel,
        classCom
      );

      let removeablePersons: PayLoadStruct[] = [...crew, ...pax];

      // add last minute PAX, to the existing ones, seat assing lateron.
      if (personsAboard !== undefined) {
        let totalCrew = [...crew, ...pic, ...fo, ...pax];
        const currentCount = totalCrew.length;
        const addPaxNbr = personsAboard - currentCount;

        if (addPaxNbr > 0) {
          for (let i = 0; i < addPaxNbr; i++) {
            const paxItem = new PayLoadStruct();
            paxItem.name = `Passenger ${i + 1}`;

            paxItem.weightValue = paxDefaultWeight;
            paxItem.codeType = payloadCodeTypeEnum.pax;
            paxItem.parameters = "";

            removeablePersons.push(paxItem);
          }
        }

        if (addPaxNbr < 0) {
          for (let i = 0; i < Math.abs(addPaxNbr); i++) {
            removeablePersons.shift(); // remove from list (mark as occupied)
            console.warn(`Removing ${Math.abs(addPaxNbr)} passengers from the list as they are not needed.`);
          }
        }
      }
      removeablePersons = cfvProvider.changePaxLoadingDependingOnOpsMissionType(removeablePersons, opsMissionType);
      // Handle additional last-minute passengers (as seats of the crew are occupied)
      let seatAssignees: PayLoadStruct[] = [...pic, ...fo, ...removeablePersons];

      // Check if a seat is available
      for (const seatAssignee of seatAssignees) {
        if (aircraftAvailSeats.length > 0) {
          seatAssignee.active = true;
          const seat = aircraftAvailSeats.shift(); // remove from list (mark as occupied)

          seatAssignee.loadArmX = seat.loadArmX;
          seatAssignee.loadArmY = seat.loadArmY;
          seatAssignee.description = seat.name;
          seatAssignee.active = true;
        } else {
          console.warn("No available seats for assignee:", seatAssignee.name);
          seatAssignee.active = false; // no seat available
        }
      }

      // Assemble payload
      let allLoading: PayLoadStruct[] = [
        ...pic,
        ...removeablePersons,
        ...fo,
        ...crewCargo,
        ...cargo,
        ...aircraftEquipment,
        ...aircraftOptEquipment,
      ];

      if (extraWeight > 0) {
        const extraWeight_item: PayLoadStruct = new PayLoadStruct();
        extraWeight_item.weightMax = extraWeight;
        extraWeight_item.weightMin = 0;
        extraWeight_item.weightValue = extraWeight;
        extraWeight_item.name = "last min change: extra weight";
        extraWeight_item.unitLoad = payloadUnitEnum.kg;
        extraWeight_item.codeType = payloadCodeTypeEnum.cargo;
        extraWeight_item.parameters = "position:" + extraWeightCargoPos.toString();
        allLoading.push(extraWeight_item);
      }
      // Crew cargo location
      const allPositions = [
        ...(await fpp.getEmptySeats(aircraftRegistration, classCom)), // that must be all seats (as assignment may change with positions, before we checked only if enough.
        ...aircraftEquipment,
        ...aircraftOptEquipment,
        ...(await fpp.getLoadingObjectsAircraftModel(aircraftRegistration, payloadCodeTypeEnum.cargo, classCom)),
      ];

      for (const item of allLoading) {
        try {
          if (item.parameters !== undefined) {
            const posStr = parseCss(item.parameters, "position");
            // No position override: retain the aircraft model's own load arms.
            if (!posStr) continue;
            const ref = allPositions.find((p) => parseCss(p.parameters, "position") === posStr);

            if (ref) {
              item.loadArmX = ref.loadArmX;
              item.loadArmY = ref.loadArmY;
            } else {
              if (item.loadArmX == 0 && item.loadArmY == 0) {
                console.warn("no seat left to assign, used loadarms 0! " + JSON.stringify(item));
                item.loadArmX = 0;
                item.loadArmY = 0;
              }
            }
          }
        } catch (err) {
          console.error("Error assigning position to item:", item, err);
          item.loadArmX = 0;
          item.loadArmY = 0;
        }
      }

      // Fuel payloads
      const fuelPayloads = fpp.fuelAircraft(fuelTanks, fuelOnBoard);
      allLoading.push(...fuelPayloads);

      // Final mass + moment calculation
      let totalMass = 0;
      let momentX = 0;
      let momentY = 0;

      const allLoadingInclEmptyWeight = allLoading.concat(aircraftEmpty);

      for (const item of allLoadingInclEmptyWeight) {
        const opsMissionType_in = parseCss(item.parameters, "opsMissionType");
        const armX = item.loadArmX;
        const armY = item.loadArmY;
        if (item.active) {
          // Blank parameters mean this load applies to every mission (including
          // empty aircraft mass, installed equipment and fuel).
          if (!opsMissionType_in || opsMissionType_in == opsMissionTypeEnum[opsMissionType]) {
            totalMass += item.weightValue;
            momentX += item.weightValue * armX;
            momentY += item.weightValue * armY;

            if (item.loadArmX == null || item.loadArmY == null) {
              console.warn(`⚠️ Missing arm for ${item.name}:`, item);
            }

            const name = item.name.padEnd(20).substring(0, 20);
            const weight = item.weightValue.toFixed(1).padStart(7);
          }
        }
      }
      const mandb = new loadAndBalanceReport();
      const md = mandb.createFormattedLoadingMarkdown(opsMissionType, allLoadingInclEmptyWeight);

      console.log(md);

      return {
        totalMass: Math.round(totalMass),
        momentX: Math.round((momentX / totalMass) * 100) / 100, // Round to 2 decimal places
        momentY: Math.round((momentY / totalMass) * 100) / 100, // Round to 2 decimal places
        loadingReport: md,
      };
    } catch (err) {
      console.error("warn: Estimate failed:", err);
      return { totalMass: 0, momentX: 0, momentY: 0, loadingReport: "error during evaluation" };
    }
  }

  async getHoistRatingLoadOfOpsMissionTypeAndLmc(
    dutyId: string,
    opsMissionType: opsMissionTypeEnum,
    fuelLoading: number,
    extraweight: number,
    personsAboard: number
  ): Promise<{ value: number; md_report: string }> {
    {
      const fpp = new fppProvider();
      const fcc = new fccProvider();
      const reg = await fcc.getAircraftRegOfDuty(dutyId, classCom);

      const acft = await fpp.getAircraftData(reg, classCom);
      // ponytail: unresolvable duty (e.g. peer-synced flight with foreign id scheme) → skip, don't deref undefined
      if (!acft) return { value: 0, md_report: "" };

      const opsMissionTypeName = opsMissionTypeEnum[opsMissionType];
      const result = await this.estimateMassAndBalance(
        dutyId,
        opsMissionType,
        extraweight,
        classCom,
        personsAboard,
        fuelLoading,
        acft.registration
      );

      const perfResult = await fpp.getPerfModelDiagram(
        acft.model,
        perfResultsEnum.maxWinchMassLimit_preloading,
        classCom,
        ["centerOfGravityLon", "grossWeight"],
        [result.momentX, result.totalMass],
        [opsMissionTypeName],
        true,
        acft.perfParameters
      );

      const maxWinchMassLimit_preloading = perfResult[0]?.value ?? 0;

      return { value: maxWinchMassLimit_preloading, md_report: result.loadingReport };
    }
  }

  async getHoistRatingLoadOfAllActiveMissionTypes_forFlight(
    flightId: string,
    extraweight: number,
    personsAboard: number,
    opsMissionTypesSelected: opsMissionTypeEnum[],
    fuelOnBoard?: number
  ): Promise<{
    key: string[];
    value: number[];
    md_report: string;
    svg: string;
    annunciators: string;
  }> {
    const fpp = new fppProvider();
    const fcc = new fccProvider();

    const dutyId = await fcc.getDutyIdOfFlight(flightId, classCom);
    const reg = await fcc.getAircraftRegOfDuty(dutyId, classCom);
    const acft = await fpp.getAircraftData(reg, classCom);
    // ponytail: unresolvable duty (e.g. peer-synced flight with foreign id scheme) → skip, don't deref undefined
    if (!acft) return this.emptyHoistResult();

    const resultsList: Array<{ key: string; value: number }> = [];
    let lastSvg: svgDiagramDataStruct[] = [];
    const svgFeatures: svgPointStruct[] = [];

    let annuString: string = "";
    let landingFuel = fuelOnBoard;
    const fuelProvider = new fuelCalcReport();

    for (const key of Object.keys(opsMissionTypeEnum) as Array<keyof typeof opsMissionTypeEnum>) {
      // Skip numeric keys from enum
      if (!isNaN(Number(key))) continue;

      if (!opsMissionTypesSelected.includes(opsMissionTypeEnum[key])) {
        continue;
      }

      const omt = opsMissionTypeEnum[key];
      const opsMissionTypeName = key.toString();

      // No readable live mass and balance gives no rating for this mission.
      const loading = await liveCalc(classCom, "loading", flightId, omt, getParametersArray);

      if (loading !== null) {
        // Both ratings use the current flight's zero-fuel loading. Only fuel
        // differs: current FOB for PPOS, estimated landing fuel for destination.
        const massValue = loading.values[property.zeroFuelMass];
        const cgValue = loading.values[property.zeroFuelcenterOfGravityX];
        const zeroFuelMass = Number.parseFloat(massValue);
        const zeroFuelCg = Number.parseFloat(cgValue);
        if (!Number.isFinite(zeroFuelMass) || zeroFuelMass <= 0 || !Number.isFinite(zeroFuelCg)) continue;

        let fuel = fuelOnBoard;
        if (fuel === undefined) {
          try {
            fuel = await fuelProvider.getEstLandingFuel(classCom, omt, flightId);
          } catch {
            continue;
          }
        }
        if (!Number.isFinite(fuel) || fuel < 0) continue;
        const tanks = await fpp.getLoadingObjectsAircraftModel(acft.registration, payloadCodeTypeEnum.fuel, classCom);
        if (!tanks.length) continue;
        const loadedTanks = fpp.fuelAircraft(tanks, fuel);
        const fuelMass = loadedTanks.reduce((sum, tank) => sum + tank.weightValue, 0);
        const fuelMoment = loadedTanks.reduce((sum, tank) => sum + tank.weightValue * tank.loadArmX, 0);
        if (Math.abs(fuelMass - fuel) > 0.01 || !Number.isFinite(fuelMoment)) continue;
        const mass = zeroFuelMass + fuelMass;
        const cg = (zeroFuelMass * zeroFuelCg + fuelMoment) / mass;
        landingFuel = fuel;

        const perfResult = await fpp.getPerfModelDiagram(
          acft.model,
          perfResultsEnum.maxWinchMassLimit_preloading,
          classCom,
          ["centerOfGravityLon", "grossWeight"],
          [cg, mass],
          [opsMissionTypeName],
          false,
          acft.perfParameters
        );

        const maxWinchMassLimit = perfResult[0]?.value;

        if (maxWinchMassLimit !== undefined) {
          if (perfResult[0].points?.length) {
            let newF = new svgPointStruct();

            newF = perfResult[0].points[0];
            newF.desig = "(" + omt.toString() + ")";

            svgFeatures.push(newF);
          }

          if (maxWinchMassLimit > 0) {
            annuString += opsMissionTypeName + ":" + maxWinchMassLimit + " KG | ";
          }

          lastSvg = perfResult;

          resultsList.push({
            key: "(" + omt + ") " + opsMissionTypeName,
            value: maxWinchMassLimit,
          });
        }
      }
    }

    // finalize SVG
    annuString = annuString.trim().replace(/\|$/, "").trim();

    if (resultsList.length == 0) {
      annuString = undefined;
    }

    let svgf = "";

    if (lastSvg.length > 0) {
      const svgTemplate = lastSvg[0];

      svgTemplate.points = svgFeatures;
      svgTemplate.lines = [];

      const md = new markDownProcessing();

      svgf = md.createSvgDiagram(svgTemplate);

      if (svgFeatures.length === 0) {
        lastSvg = undefined;
      }

      if (classCom.targetPlatform == targetPlatformEnum.server) {
        const fs = classCom.package_fs;

        fs.writeFile("out.html", svgf, function (err) {
          if (!err) {
            const open = classCom.package_open;
            open("out.html");
          }
        });
      }
    }

    // =====================================================
    // PERSONS ABOARD
    // Read the freshly calculated POB of THIS flight.
    // Do not trust a stale/dummy value passed by the caller.
    // =====================================================

    let landingPersonsAboard = personsAboard;

    try {
      const uid = classCom.package_md5(flightId.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);

      const actualOnBoardStr = await getParameterValue(
        uid,
        "loading",
        property.actNbrpersonsAboard,
        opsMissionTypeEnum.all
      );

      if (actualOnBoardStr !== undefined) {
        const actualOnBoard = parseInt(actualOnBoardStr);

        if (Number.isFinite(actualOnBoard) && actualOnBoard >= 0) {
          landingPersonsAboard = actualOnBoard;
        }
      }
    } catch (err) {
      // Keep caller value as fallback.
    }

    // GENERATE MARKDOWN REPORT
    const mandb = new loadAndBalanceReport();

    const mdReport = mandb.generateMarkdownOFPWinchMassProfile(
      resultsList,
      0,
      landingFuel,
      extraweight,
      landingPersonsAboard,
      acft.model,
      acft.registration,
      new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      new Date().toUTCString().split(" ")[4]
    );

    return {
      key: resultsList.map((item) => item.key),
      value: resultsList.map((item) => item.value),
      md_report: mdReport,
      svg: svgf,
      annunciators: annuString,
    };
  }

  async getHoistRatingLoadOfAllActiveMissionTypes_ofDuty(
    dutyId: string,
    fuelLoading: number,
    extraweight: number,
    personsAboard: number,
    opsMissionTypesSelected: opsMissionTypeEnum[]
  ): Promise<{
    key: string[];
    value: number[];
    md_report: string;
    svg: string;
    annunciators: string;
  }> {
    const fpp = new fppProvider();
    const fcc = new fccProvider();

    const reg = await fcc.getAircraftRegOfDuty(dutyId, classCom);
    const acft = await fpp.getAircraftData(reg, classCom);
    // ponytail: unresolvable duty (e.g. peer-synced flight with foreign id scheme) → skip, don't deref undefined
    if (!acft) return this.emptyHoistResult();

    const resultsList: Array<{ key: string; value: number }> = [];
    let lastSvg: svgDiagramDataStruct[] = [];
    const svgFeatures: svgPointStruct[] = [];

    let annuString: string = "";

    for (const key of Object.keys(opsMissionTypeEnum) as Array<keyof typeof opsMissionTypeEnum>) {
      // Skip numeric keys from enum
      if (!isNaN(Number(key))) continue;

      if (!opsMissionTypesSelected.includes(opsMissionTypeEnum[key])) continue; // Skip if not selected

      const omt = opsMissionTypeEnum[key];
      const opsMissionTypeName = key.toString();

      const result = await this.estimateMassAndBalance(
        dutyId,
        omt,
        extraweight,
        classCom,
        personsAboard,
        fuelLoading,
        acft.registration
      );

      const perfResult = await fpp.getPerfModelDiagram(
        acft.model,
        perfResultsEnum.maxWinchMassLimit_preloading,
        classCom,
        ["centerOfGravityLon", "grossWeight"],
        [result.momentX, result.totalMass],
        [opsMissionTypeName],
        false,
        acft.perfParameters
      );

      if (perfResult.length == 0) {
        continue; // this mission type has no perf diagram — skip it, don't bail the whole method (returned undefined → caller derefs .value → crash)
      }

      const maxWinchMassLimit = perfResult[0]?.value;

      if (maxWinchMassLimit !== undefined) {
        if (perfResult[0].points?.length) {
          let newF = new svgPointStruct();
          newF = perfResult[0].points[0];

          newF.desig = "(" + omt.toString() + ")"; //perfResult[0].value.toString() + " KG | " + opsMissionTypeName;

          // write annunciator (if > 0)
          if (maxWinchMassLimit > 0) {
            annuString += opsMissionTypeName + ":" + maxWinchMassLimit + " KG | ";
          }
          svgFeatures.push(newF); // Assuming the first point is the relevant one
        }

        lastSvg = perfResult; // Placeholder for actual SVG, if applicable

        resultsList.push({ key: "(" + omt + ") " + opsMissionTypeName, value: maxWinchMassLimit });
      }
    }

    // finalize svg
    annuString = annuString.trim().replace(/\|$/, "").trim();

    let svgf = "";
    if (resultsList.length == 0) {
      annuString = undefined;
    }

    if (lastSvg.length > 0) {
      const svgTemplate = lastSvg[0];
      svgTemplate.points = svgFeatures;

      svgTemplate.lines = [];

      const md = new markDownProcessing();
      svgf = md.createSvgDiagram(svgTemplate);

      if (svgFeatures.length > 0) {
      } else {
        lastSvg = undefined; // No SVG data available
      }

      if (classCom.targetPlatform == targetPlatformEnum.server) {
        const fs = classCom.package_fs;
        fs.writeFile("out.html", svgf, function (err) {
          if (!err) {
            const open = classCom.package_open;
            open("out.html");
          }
        });
      }
    }

    // GENERATE MARKDOWN REPORT
    const mandb = new loadAndBalanceReport();
    const mdReport = mandb.generateMarkdownOFPWinchMassProfile(
      resultsList,
      0,
      fuelLoading,
      extraweight,
      personsAboard,
      acft.model,
      acft.registration,
      new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }),
      new Date().toUTCString().split(" ")[4]
    );

    return {
      key: resultsList.map((item) => item.key),
      value: resultsList.map((item) => item.value),
      md_report: mdReport,
      svg: svgf,
      annunciators: annuString,
    };
  }
}

// MASS AND BALANCE AND PERFORMANCE //
// ----------------------------------------------------- //
export class performance {
  /**
   * The error that aborted the last `updatePerformance` run, or `undefined` if
   * it succeeded. Same contract as `mAndBandPerformance.lastError` and
   * `fuelFeatures.lastError`: the catch below is the only place the cause
   * exists, and its `console.log` reaches nobody on iOS (the JS console bridge
   * was removed for perf).
   *
   * NOT a total catch: only `initPerformance` runs inside the `try`.
   */
  lastError: unknown = undefined;

  async updatePerformance(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    classCom: opsCntrolCom,
    checksum: string,
    origin_elevation: number,
    dest_elevation: number,
    origin_oat: number,
    dest_oat: number,
    origin_qnh: number,
    dest_qnh: number
  ): Promise<boolean> {
    this.lastError = undefined;

    try {
      // Propagate, do NOT discard: `initPerformance` returns false without
      // throwing when there is no live mass and balance, so returning a
      // hardcoded `true` here would re-mask exactly what that guard reports.
      // It sets `lastError` itself on that path.
      return await this.initPerformance(
        flightId,
        opsMissionType,
        classCom,
        checksum,
        origin_elevation,
        dest_elevation,
        origin_oat,
        dest_oat,
        origin_qnh,
        dest_qnh
      );
    } catch (err) {
      // Falling off the end here resolved `undefined` from a declared
      // Promise<boolean> — the third instance of the defect this series
      // removed from `initMassAndBalance`, `fuelCalcReport.initFuel` and
      // `fuelFeatures.initFuel`. The two callers differ: ops-control's
      // ahead-flight recycle calls this directly, stops the chain on false and
      // surfaces `lastError` to the operator. `updateOfpCalculations` only
      // PROPAGATES it (`return await`) to ITS caller, which logs and continues
      // — so a failure on that path is not shown to anyone. Do not read the
      // recycle's handling as covering both.
      this.lastError = err;
      console.log("WARN: could not update updatePerformance calc! " + err);
      return false;
    }
  }
  async initPerformance(
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    classCom: opsCntrolCom,
    checksum: string,
    origin_elevation: number,
    dest_elevation: number,
    origin_oat: number,
    dest_oat: number,
    origin_qnh: number,
    dest_qnh: number
  ): Promise<boolean> {
    // Refuse to compute against a mass and balance that is not live.
    //
    // The two mass reads below go through `getParameterNumber`, whose
    // `fallback = 0` turns "the row does not exist" into "the mass is zero" —
    // so an absent, aborted or rolled-back mass and balance grades
    // `maxHogeMass - 0` as **PERF OK** and commits it. Gating the CALLERS does
    // not fix that: create-flight is gated, the ahead-flight recycle
    // (`ops-control.service.ts`) and `updateOfpCalculations` are not, and the
    // next caller added would not be either.
    //
    // The `loading` row is the liveness signal, NOT the presence of the mass
    // parameters. A rolled-back run obsoletes its row but leaves the params it
    // had already written (`initMassAndBalance` commonly aborts at
    // `getTripFuel`, i.e. after `takeOffMass` and before `estLandingMass`), so
    // a parameter-presence check would read a real takeoff mass beside a zero
    // landing mass and pass. `obsolete = 0` on the row cannot be faked that
    // way, and that is also why the rollback deliberately does not sweep the
    // `loading` params: nothing reads them without a live row.
    // No readable result counts as no mass and balance: a retracted version,
    // or a document this build cannot parse.
    const loading = await liveCalc(classCom, "loading", flightId, opsMissionType, getParametersArray);

    if (loading === null) {
      this.lastError = new Error("no live mass and balance for flight " + flightId);
      console.log("initPerformance: no live mass and balance for flight " + flightId);
      return false;
    }

    const perfReport = new performanceReport();
    const fpp = new fppProvider();
    const newTimestamp = new Date().getTime();

    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const takeOffMass = Number(loading.values[property.takeOffMass] ?? 0);
    const landingMass = Number(loading.values[property.estLandingMass] ?? 0);

    const depPA = calcPressureAltitude(origin_elevation, origin_qnh);
    const destPA = calcPressureAltitude(dest_elevation, dest_qnh);

    // Pulled forward from its original spot further below (it depends only on
    // `loadingParams`, already read above) so the winch lookup's gating
    // condition is known here too, alongside every other input the six
    // lookups below need.
    const estLandingCenterOfGravityXVal = loading.values[property.estLandingCenterOfGravityX];
    const estLandingCenterOfGravityX =
      estLandingCenterOfGravityXVal !== undefined ? Number(estLandingCenterOfGravityXVal) : NaN;

    // The six chart lookups below are independent -- their inputs (masses, PA,
    // OATs, acft, the landing CG) are all known at this point. On the web each
    // is its own request, so all are started together instead of one after
    // another, and each is still AWAITED exactly where it was awaited before,
    // so every statement between them (including the two `Promise.all`
    // parameter flushes) keeps its original order. Each gets a no-op `.catch`
    // so a rejection of one lookup is never reported as unhandled while an
    // earlier `await` below is still pending on another; a rejection still
    // surfaces at its own original `await`.
    const aeoHogePromise = evaluateAeoHoge(acft, classCom, [
      { mass: takeOffMass, oat: origin_oat, pa: depPA },
      { mass: landingMass, oat: dest_oat, pa: destPA },
    ]);
    aeoHogePromise.catch(() => {});

    const originHogePromise = fpp.getPerfModelDiagram(
      acft.model,
      perfResultsEnum.hoge,
      classCom,
      ["outsideAirTemp", "pressureAltitude"],
      [origin_oat, depPA],
      [],
      true,
      acft.perfParameters
    );
    originHogePromise.catch(() => {});

    const destHogePromise = fpp.getPerfModelDiagram(
      acft.model,
      perfResultsEnum.hoge,
      classCom,
      ["outsideAirTemp", "pressureAltitude"],
      [dest_oat, destPA],
      [],
      true,
      acft.perfParameters
    );
    destHogePromise.catch(() => {});

    const originCataPromise = fpp.getPerfModelDiagram(
      acft.model,
      perfResultsEnum.cat_a_vtol_maxGrossMass,
      classCom,
      ["outsideAirTemp", "pressureAltitude"],
      [origin_oat, depPA],
      [],
      true,
      acft.perfParameters
    );
    originCataPromise.catch(() => {});

    const destCataPromise = fpp.getPerfModelDiagram(
      acft.model,
      perfResultsEnum.cat_a_vtol_maxGrossMass,
      classCom,
      ["outsideAirTemp", "pressureAltitude"],
      [dest_oat, destPA],
      [],
      false,
      acft.perfParameters
    );
    destCataPromise.catch(() => {});

    // `isPerfModelAvailable` is NOT awaited here (unchanged) -- an unawaited
    // Promise is always truthy, so this gate is really only
    // `estLandingCenterOfGravityXVal !== undefined`. Starting the winch lookup
    // on that condition alone matches the original behaviour exactly, and the
    // `isPerfModelAvailable` call is kept below at its original point, since it
    // issues a read whose timing relative to the surrounding statements must
    // not move.
    let winchPromise: Promise<svgDiagramDataStruct[]> | undefined;
    if (estLandingCenterOfGravityXVal !== undefined) {
      winchPromise = fpp.getPerfModelDiagram(
        acft.model,
        perfResultsEnum.maxWinchMassLimit_preloading,
        classCom,
        ["centerOfGravityLon", "grossWeight"],
        [estLandingCenterOfGravityX, landingMass],
        [],
        true,
        acft.perfParameters
      );
      winchPromise.catch(() => {});
    }

    // The report's segment one lookups depend on the same inputs: start them
    // with the others, the report awaits them where it needs them.
    const segmentOnePromise = perfReport.createCatASegmentOneMarkdown(
      acft,
      classCom,
      takeOffMass,
      landingMass,
      origin_oat,
      dest_oat,
      depPA,
      destPA
    );
    segmentOnePromise.catch(() => {});

    const aeoHoge = await aeoHogePromise;

    const originHoge = await originHogePromise;
    const destHoge = await destHogePromise;

    let highest_origin_hoge: svgDiagramDataStruct = undefined;
    for (let index = 0; index < originHoge.length; index++) {
      if (highest_origin_hoge == undefined) {
        if (!originHoge[index]._violation) highest_origin_hoge = originHoge[index];
      } else {
        if (originHoge[index].value > highest_origin_hoge.value) {
          if (!originHoge[index]._violation) highest_origin_hoge = originHoge[index];
        }
      }
    }

    let highest_dest_hoge: svgDiagramDataStruct = undefined;
    for (let index = 0; index < destHoge.length; index++) {
      if (highest_dest_hoge == undefined) {
        if (!destHoge[index]._violation) highest_dest_hoge = destHoge[index];
      } else {
        if (destHoge[index].value > highest_dest_hoge.value) {
          if (!destHoge[index]._violation) highest_dest_hoge = destHoge[index];
        }
      }
    }

    const maxHogeMassTakeoff = highest_origin_hoge?.value ?? noSolutionAvail;
    const maxHogeMassLanding = highest_dest_hoge?.value ?? noSolutionAvail;
    const maxHogeMassTakeoffLeft = maxHogeMassTakeoff - takeOffMass;
    const maxHogeMassLandingLeft = maxHogeMassLanding - landingMass;

    // -- CAT-A VTOL Calculations --
    const originCata = await originCataPromise;
    const destCata = await destCataPromise;

    let highest_origin_cata: svgDiagramDataStruct = undefined;
    for (let index = 0; index < originCata.length; index++) {
      if (highest_origin_cata == undefined) {
        if (!originCata[index]._violation) highest_origin_cata = originCata[index];
      } else {
        if (originCata[index].value > highest_origin_cata.value) {
          if (!originCata[index]._violation) highest_origin_cata = originCata[index];
        }
      }
    }

    let highest_dest_cata: svgDiagramDataStruct = undefined;
    for (let index = 0; index < destCata.length; index++) {
      if (highest_dest_cata == undefined) {
        if (!destCata[index]._violation) highest_dest_cata = destCata[index];
      } else {
        if (destCata[index].value > highest_dest_cata.value) {
          if (!destCata[index]._violation) highest_dest_cata = destCata[index];
        }
      }
    }

    const maxCataDep = highest_origin_cata?.value ?? noSolutionAvail;
    const maxCataDest = highest_dest_cata?.value ?? noSolutionAvail;
    const maxCataDepLeft = maxCataDep - takeOffMass;
    const maxCataDestLeft = maxCataDest - landingMass;

    let maxWinchMassLimit_preloading: number = noSolutionAvail;
    // Set only when this run finds a hoist mass.
    let hoistMassValue: string | undefined;
    if (
      estLandingCenterOfGravityXVal !== undefined &&
      fpp.isPerfModelAvailable(acft.model, perfResultsEnum.maxWinchMassLimit_preloading, classCom)
    ) {
      const resultArray = await winchPromise!;

      if (resultArray !== undefined) {
      }

      if (resultArray !== undefined) {
        maxWinchMassLimit_preloading = resultArray[0]?.value;

        if (maxWinchMassLimit_preloading == undefined) {
          maxWinchMassLimit_preloading = 0;
        }

        hoistMassValue = maxWinchMassLimit_preloading.toString();
      }
    }

    // This step writes no parameters. Its figures go into the calculation
    // result of the row below.

    // -- Generate Markdown Report --
    const processReport = await perfReport.createPerformanceMarkdown(
      acft,
      flightId,
      opsMissionType,
      classCom,
      takeOffMass,
      landingMass,
      origin_elevation,
      dest_elevation,
      origin_oat,
      dest_oat,
      origin_qnh,
      dest_qnh,
      depPA,
      destPA,
      maxHogeMassTakeoff,
      maxHogeMassLanding,
      maxHogeMassTakeoffLeft,
      maxHogeMassLandingLeft,
      maxCataDep,
      maxCataDest,
      maxCataDepLeft,
      maxCataDestLeft,
      [highest_dest_hoge?._txtCondition, highest_origin_hoge?._txtCondition],
      [highest_dest_cata?._txtCondition, highest_origin_cata?._txtCondition],
      estLandingCenterOfGravityX,
      maxWinchMassLimit_preloading,
      aeoHoge.markdown,
      segmentOnePromise
    );

    // -- Determine Status --
    let annunciators = "PERF FAIL " + opsMissionTypeEnum[opsMissionType];
    let processResultState = performanceStatus(aeoHoge.margins[0], aeoHoge.margins[1], maxCataDepLeft, maxCataDestLeft);

    if (processResultState === processResultStateEnum.ok) {
      annunciators = "PERF OK";
    }

    if (processResultState === processResultStateEnum.warn) {
      annunciators = "PERF NO CAT-A " + opsMissionTypeEnum[opsMissionType];
    }

    if (originCata.length === 0 && destCata.length === 0 && originHoge.length === 0 && destHoge.length === 0) {
      annunciators = "PERF N/A " + opsMissionTypeEnum[opsMissionType];
    }

    if (processResultState === processResultStateEnum.ok && maxWinchMassLimit_preloading == 0) {
      processResultState = processResultStateEnum.warn;
      annunciators = "PERF NO H-RATING " + opsMissionTypeEnum[opsMissionType];
    }

    // -- Save to DB -- deterministic-rowId upsert-in-place
    // It joins the parameter flush; the server applies the queue in order.
    // The calculation result: this run's performance figures as one document.
    const resultJson = buildCalcResult({
      inputs: {
        oatOrigin: origin_oat,
        oatDest: dest_oat,
        qnhOrigin: origin_qnh,
        qnhDest: dest_qnh,
        elevationOrigin: origin_elevation,
        elevationDest: dest_elevation,
        // The masses of the loading version this run used. The report
        // diagrams draw from them.
        takeOffMass,
        landingMass,
        landingCgX: estLandingCenterOfGravityX,
      },
      upstream: loading.rowId,
      values: {
        [property.depHeliHogeMass]: maxHogeMassTakeoff.toString(),
        [property.depHeliHogeMassLeft]: maxHogeMassTakeoffLeft.toString(),
        [property.destHeliHogeMass]: maxHogeMassLanding.toString(),
        [property.destHeliHogeMassLeft]: maxHogeMassLandingLeft.toString(),
        [property.oatOrigin]: origin_oat.toString(),
        [property.oatDest]: dest_oat.toString(),
        [property.qnhOrigin]: origin_qnh.toString(),
        [property.qnhDest]: dest_qnh.toString(),
        [property.depPressureAltitude]: depPA.toString(),
        [property.destPressureAltitude]: destPA.toString(),
        [property.depHeliVtolCatAMassLeft]: maxCataDepLeft.toString(),
        [property.destHeliVtolCatAMass]: maxCataDest.toString(),
        [property.destHeliVtolCatAMassLeft]: maxCataDestLeft.toString(),
        ...(hoistMassValue === undefined ? {} : { [property.desEstimatedHoistMass]: hoistMassValue }),
      },
    });
    const inserted = queueCommand({
      name: "perfInsert",
      params: {
        rowId: rowIdFor([flightId, opsMissionType, newTimestamp]),
        Timestamp: newTimestamp,
        flightId,
        signatureId: await currentSignatureId(flightId, classCom),
        resultJson,
        checksum,
        annunciators,
        processResultState,
        processReport,
        opsMissionType,
        updatedAt: Date.now(),
      },
    });
    // The flush can settle a reject before the await below reaches it.
    inserted.catch(() => undefined);
    await execAccuParameters();
    await inserted;

    return true;
  }
}

// nav functions
// ------------------------------------------------------ //
export class navigationalFeatures {
  async initNav(
    flightId: string,
    classCom: opsCntrolCom,
    terrDataUrl: string,
    initRouteLegs?: navLegStruct[]
  ): Promise<boolean> {
    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const nav = new navLogReport(classCom);
    const success = await nav.initNav(flightId, acft, terrDataUrl, initRouteLegs);
    return success;
  }
  async updateNav(flightId: string, classCom: opsCntrolCom): Promise<boolean> {
    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const nav = new navLogReport(classCom);
    const success = await nav.updateNav(flightId, acft, undefined);
    return success;
  }
  async alterRoute(
    flightId: string,
    allNavlegs: navLegStruct[],
    aircraft: aircraftStruct,
    terrDataUrl: string
  ): Promise<void> {
    const nav = new navLogReport(classCom);

    await nav.alterRoute(flightId, allNavlegs, aircraft, terrDataUrl);
  }

  async getLegs(flightId: string, acft: aircraftStruct): Promise<navLegStruct[]> {
    const nav = new navLogReport(classCom);
    const legs = await nav.getLegs(acft, flightId);

    return legs;
  }
}

// fuel functions
// ------------------------------------------------------ //
// The reads of the fuel step need only the flight: they start with the route
// reads and are awaited in fuelCalcReport.initFuel.
function startFuelReads(flightId: string, classCom: opsCntrolCom): StartedFuelReads {
  const startRead = <T>(read: Promise<T>): Promise<T> => {
    read.catch(() => undefined);
    return read;
  };
  return {
    fuelCount: startRead(classCom.namedQuery("fuelCountByFlightId", { flightId })),
    flightRow: startRead(classCom.namedQuery("flightlistByFlightId", { flightId })),
    routeRow: startRead(classCom.namedQuery("navRouteDataByFlightId", { flightId })),
    flightlistParams: startRead(getParametersArray(flightId, "flightlist", opsMissionTypeEnum.all)),
  };
}

export class fuelFeatures {
  /**
   * The error that aborted the last `initFuel` / `updateFuel` run — see
   * `fuelCalcReport.lastError`. Cleared per run.
   */
  lastError: unknown = undefined;

  async updateFuel(
    flightId: string,
    classCom: opsCntrolCom,
    checksum: string,
    opsMissionType: opsMissionTypeEnum
  ): Promise<boolean> {
    this.lastError = undefined;

    // The route reads, the reads of the fuel step and the stored fuel on board
    // need only the flight, so they start with the registration.
    const nav = new navLogReport(classCom);
    const started = startFuelReads(flightId, classCom);
    const plannedStarted = nav.getPlannedTimesAndDistances(flightId);
    plannedStarted.catch(() => undefined);
    const legRowsStarted = nav.readLegRows(flightId);
    legRowsStarted.catch(() => undefined);
    const uid = classCom.package_md5(flightId.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);
    const fobStarted = getParameter(uid, "fuel", property.actFuelOnBoard, opsMissionTypeEnum.all);
    fobStarted.catch(() => undefined);

    // update fuel uses FOB set, the FOB is not given
    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);
    const [distancesAndTimes, navlog] = await Promise.all([
      plannedStarted,
      nav.getLegs(acft, flightId, legRowsStarted),
    ]);
    const fuel = new fuelCalcReport();

    try {
      const fuelOnBoard = parseInt((await fobStarted)[0].value);

      // Propagate, for the same reason as initFuel below — this wrapper sits
      // over the same newly-honest fuelCalcReport.initFuel.
      const fuelOk = await fuel.initFuel(
        flightId,
        classCom,
        acft,
        distancesAndTimes.routeDistanceFromOriginToDest,
        distancesAndTimes.routeDistanceDestToAlternate,
        fuelOnBoard,
        checksum,
        opsMissionType,
        navlog,
        started
      );

      if (!fuelOk) {
        this.lastError = fuel.lastError;
        return false;
      }

      // update fplEndurance
      const fplEndurance = fuel.getEnduranceHHmm(acft, fuelOnBoard);

      // endurance (is not required)
      if (fplEndurance !== undefined) {
        await addParameter(
          flightId,
          "flightlist",
          property.fplEndurance,
          opsMissionTypeEnum.all,
          fplEndurance,
          "",
          "",
          "",
          "",
          false
        );
      }
    } catch (err) {
      console.log("WARN: could not update fuel calc! " + err);
      this.lastError = err;
      return false;
    }

    return true;
  }

  async initFuel(
    flightId: string,
    classCom: opsCntrolCom,
    checksum: string,
    opsMissionType: opsMissionTypeEnum,
    fuelOnBoard: number
  ): Promise<boolean> {
    this.lastError = undefined;

    // The route reads and the reads of the fuel step need only the flight, so
    // they start with the registration and run beside the aircraft reads.
    const nav = new navLogReport(classCom);
    const started = startFuelReads(flightId, classCom);
    const plannedStarted = nav.getPlannedTimesAndDistances(flightId);
    plannedStarted.catch(() => undefined);
    const legRowsStarted = nav.readLegRows(flightId);
    legRowsStarted.catch(() => undefined);

    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const [distancesAndTimes, navlog] = await Promise.all([
      plannedStarted,
      nav.getLegs(acft, flightId, legRowsStarted),
    ]);

    const fuel = new fuelCalcReport();

    // Propagate the result. Discarding it and returning a hardcoded `true`
    // below made every caller — including the create-flight `fuelOk` gate that
    // exists to stop the dependent mass and balance running without a fuel row
    // — unable to tell a rolled-back calculation from a completed one.
    const fuelOk = await fuel.initFuel(
      flightId,
      classCom,
      acft,
      distancesAndTimes.routeDistanceFromOriginToDest,
      distancesAndTimes.routeDistanceDestToAlternate,
      fuelOnBoard,
      checksum,
      opsMissionType,
      navlog,
      started,
      // the endurance of the flight plan is written with the fuel row
      true
    );

    if (!fuelOk) {
      this.lastError = fuel.lastError;
      return false;
    }

    return true;
  }
}

// notam functions
// ------------------------------------------------------ //
export class notamFeatures {
  async initUpdateNotam(flightId: string, classCom: opsCntrolCom, checksum: string): Promise<boolean> {
    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const nav = new navLogReport(classCom);
    const navlog = await nav.getLegs(acft, flightId);

    const fir_list: string[] = await nav.getFirsOfRoute(navlog);
    let annunciators: string = "";
    for (let index = 0; index < fir_list.length; index++) {
      annunciators += fir_list[index] + " ";
    }
    annunciators += "notams";

    const notam = new notamReport();
    const processReport = await notam.createNotamMarkdown(flightId, classCom, fir_list);

    // add the envelope checks
    let processResultState: processResultStateEnum = processResultStateEnum.ok;

    if (processReport.length < 500) {
      processResultState = processResultStateEnum.fail;
    }

    const newTimestamp = new Date().getTime();

    await classCom.namedCommand("notamInsert", {
      rowId: rowIdFor([flightId, newTimestamp]),
      Timestamp: newTimestamp,
      flightId,
      signatureId: await currentSignatureId(flightId, classCom),
      checksum,
      annunciators,
      processResultState,
      processReport,
      updatedAt: Date.now(),
    });

    return true;
  }
}

// met functions
// ------------------------------------------------------ //
export class metFeatures {
  async initUpdateMet(flightId: string, classCom: opsCntrolCom, checksum: string): Promise<boolean> {
    const fpp: fppProvider = new fppProvider();
    const registration = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    const acft = await fpp.getAircraftData(registration[0].value, classCom);

    const nav = new navLogReport(classCom);
    const navlog = await nav.getLegs(acft, flightId);

    const annunciators = "METAR Reports";

    const met = new metarReport();
    const processReport = await met.createMetMarkdown(flightId, classCom, navlog);

    // add the envelope checks
    const processResultState: processResultStateEnum = processResultStateEnum.ok;

    // insert the LOADING Table

    const newTimestamp = new Date().getTime();

    await classCom.namedCommand("metInsert", {
      rowId: rowIdFor([flightId, newTimestamp]),
      Timestamp: newTimestamp,
      flightId,
      signatureId: await currentSignatureId(flightId, classCom),
      checksum,
      annunciators,
      processResultState,
      processReport,
      updatedAt: Date.now(),
    });

    return true;
  }
}

export class briefingFlowFeatures {
  /** The briefing card data of `allFlights`; see `loadBriefingFlights`. Sorts `allFlights` in place. */
  async getBriefgFlowOfFlight(
    allFlights: flightlistStruct[],
    classCom: opsCntrolCom,
    webcamLiveBaseUrl: string,
    webcamtoolId: number,
    weatherToolid: number,
    geoLocation?: number[]
  ): Promise<briefgFlowFlightStruct[]> {
    try {
      return await loadBriefingFlights(allFlights, classCom, {
        webcamLiveUrl: webcamLiveBaseUrl,
        webcamToolId: webcamtoolId,
        weatherToolId: weatherToolid,
        position: geoLocation,
      });
    } catch (err) {
      console.log("ERR: could not get briefingFlowOfFlight! " + err);
    }
    return undefined;
  }

  /** The flights the card shows, in departure order, without loading the card. Sorts `allFlights` in place. */
  async relevantFlights(allFlights: flightlistStruct[], classCom: opsCntrolCom): Promise<flightlistStruct[]> {
    return (await relevantBriefingFlights(allFlights, classCom)).map((r) => r.flight);
  }
}

// NWY FPL API //
// ----------------------------------------------------- //
export class flightPlanFeatures {
  async getAircraftData(registration: string): Promise<aircraftStruct> {
    const acft = new fppProvider();

    const regList = await acft.getAircraftData(registration, classCom);

    // console.log(JSON.stringify(regList));

    return regList;
  }
  async getAircraftRegOfFlight(flightId: string): Promise<string> {
    const ret = await getParameter(flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all);
    return ret[0].value;
  }
  async setFlightPlanId(flightId: string, fplId: string) {
    await addParameter(flightId, "flightlist", property.fplId, opsMissionTypeEnum.all, fplId, "", "", "", "", false);
  }
  async setFplightPlanState(flightId: string, state: fplState) {
    await addParameter(
      flightId,
      "flightlist",
      property.fplState,
      opsMissionTypeEnum.all,
      fplState[state],
      "",
      "",
      "",
      "",
      false
    );
  }
  async getFlightPlanState(flightId: string): Promise<string> {
    const ret = await getParameter(flightId, "flightlist", property.fplState, opsMissionTypeEnum.all);
    if (ret.length == 1) return ret[0].value;
    return "";
  }
  async getFlightPlanId(flightId: string): Promise<string> {
    const ret = await getParameter(flightId, "flightlist", property.fplId, opsMissionTypeEnum.all);
    if (ret.length == 1) return ret[0].value;
    return "";
  }
  validateAircraftForFpl(acft: aircraftStruct, registration: string): void {
    if (!acft) throw new Error("Aircraft configuration could not be loaded for " + registration + ".");
    const missing: string[] = [];
    if (!acft.typeOfAcft?.trim()) missing.push("aircraftType");
    if (!acft.equipment?.trim()) missing.push("equipment");
    if (typeof wTurbCatEnum[acft.wakeTurbCat] !== "string") missing.push("wakeTurbCat");
    if (typeof transpEnum[acft.transponder] !== "string") missing.push("transponder");
    if (typeof crusingSpeedRefStruct[acft.crusingSpeedRef] !== "string") missing.push("crusingSpeedRef");
    if (!Number.isFinite(acft.crusingSpeed) || acft.crusingSpeed <= 0) missing.push("crusingSpeed");
    if (missing.length) {
      throw new Error(
        "Incomplete ATC aircraft configuration for " +
          registration +
          ": " +
          missing.join(", ") +
          ". Update the aircraft configuration before previewing or filing a flight plan."
      );
    }
  }

  async getFplPlainString(flightId: string): Promise<{ raw: string; formatted: string }> {
    let fplStr =
      "(FPL-{flightnumber}-{flightrules}{typeOfFlight}-{aircraftType}/{wakeTurbCat}-{equipment}/{transponder}-{icaoOrigin}{etd}-{speedRef}{crusingSpeed}{levelRef}{levelVal} {route}-{icaoDest}{totalEet} {icaoAlternate}-{remarks}-{endurance}-P/{personsAboard}{emerEquipment})";
    let fplStrFormatted =
      "(FPL-{flightnumber}-{flightrules}{typeOfFlight}\n-{aircraftType}/{wakeTurbCat}-{equipment}/{transponder}\n-{icaoOrigin}{etd}\n-{speedRef}{crusingSpeed}{levelRef}{levelVal} {route}\n-{icaoDest}{totalEet} {icaoAlternate}\n-{remarks}\n-{endurance}\n-P/{personsAboard}\n{emerEquipment})";

    // flightnumber
    const flightMainList = (await classCom.namedQuery("flightlistByFlightId", { flightId }))[0];

    const flightlistParameters: parameterStruct[] = await getParametersArray(
      flightId,
      "flightlist",
      opsMissionTypeEnum.all
    );

    const registration = getParameterOfArray(flightId, "flightlist", property.acftReg, flightlistParameters)[0]?.value;
    if (registration === undefined) {
      throw new Error("flightlist data not yet computed: acftReg");
    }
    const acft: aircraftStruct = await this.getAircraftData(registration);
    this.validateAircraftForFpl(acft, registration);

    let reg: string = "REG/";
    if (flightMainList.flightNumber == "") {
      flightMainList.flightNumber = acft.registration;
      reg = "";
    } else {
      reg += acft.registration.replace(/[^0-9A-Z +]/g, "") + " ";
    }

    // Flightrules
    const flightrules =
      getParameterOfArray(flightId, "flightlist", property.flightrules, flightlistParameters)[0]?.value ?? "";

    // type of flight
    const typeOfFlight =
      typeOfFlightStruct[
        getParameterOfArray(flightId, "flightlist", property.fplTypeOfFlight, flightlistParameters)[0]?.value ?? ""
      ];
    // aircraft type
    const acftType = acft.typeOfAcft;

    // wake turb
    const wkturb = wTurbCatEnum[acft.wakeTurbCat];

    // equipment
    const equipment = acft.equipment;

    // transponder
    const transponder = transpEnum[acft.transponder];

    // persons aboard (think no better way than to loop all possible ops-mission-types
    // and take the greatest number)

    // greatestNumber
    let personsAboard: number = 0;
    for (const opsMtype in opsMissionTypeEnum) {
      const uid = classCom.package_md5(flightId.toString() + "|" + opsMissionTypeEnum.all).substring(0, 20);

      const pb = await getParameter(uid, "loading", property.actNbrpersonsAboard, opsMissionTypeEnum.all);

      if (pb[0] !== undefined) {
        const paboard = pb[0].value;

        if (parseInt(paboard) > personsAboard || personsAboard == 0) {
          personsAboard = parseInt(paboard);
        }
      }
    }

    // origin
    const origin =
      getParameterOfArray(flightId, "flightlist", property.icaoOrigin, flightlistParameters)[0]?.value ?? "";

    let originName =
      getParameterOfArray(flightId, "flightlist", property.originName, flightlistParameters)[0]?.value ?? "";
    let destName = getParameterOfArray(flightId, "flightlist", property.destName, flightlistParameters)[0]?.value ?? "";

    originName = originName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    destName = destName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // etd
    const estTimeDepRaw = getParameterOfArray(flightId, "flightlist", property.estTimeDep, flightlistParameters)[0]
      ?.value;
    const etd = this.fplFormatTime(new Date(estTimeDepRaw !== undefined ? parseInt(estTimeDepRaw) : 0));

    // speed
    const speed = this.pad(Math.round(acft.crusingSpeed * classNavProvider.mps_to_kts), 4);
    const speedRef = crusingSpeedRefStruct[acft.crusingSpeedRef];

    // level
    let level =
      getParameterOfArray(flightId, "flightlist", property.fplCruisingLevel, flightlistParameters)[0]?.value ?? "";
    const levelRef =
      getParameterOfArray(flightId, "flightlist", property.fplCruisingLevelRef, flightlistParameters)[0]?.value ?? "";

    if (level == "-") {
      level = "";
    }

    // route
    let route = getParameterOfArray(flightId, "flightlist", property.fplRoute, flightlistParameters)[0]?.value ?? "";

    route = this.fixShortWaypointnames(route);
    route = route
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\//g, " ")
      .replace(/\\/g, " ")
      .replace(/\./g, " ")
      .replace(/-/g, " ");

    // icao dest
    const dest = getParameterOfArray(flightId, "flightlist", property.icaoDest, flightlistParameters)[0]?.value ?? "";

    // eet
    const navFeatures: navLogReport = new navLogReport(classCom);
    const navLog_timesAndDistances = await navFeatures.getPlannedTimesAndDistances(flightId);
    const eteSeconds: number = navLog_timesAndDistances.routeTimeFromOriginToDest;
    const ete_HH: number = Math.floor(eteSeconds / 3600);
    const ete_secLeft: number = eteSeconds - ete_HH * 3600;
    const ete_MM: number = Math.ceil(ete_secLeft / 60);

    const ete_fpl = padLeft(Math.round(ete_HH).toString(), "0", 2) + padLeft(Math.round(ete_MM).toString(), "0", 2);

    // alternate
    let alt = getParameterOfArray(flightId, "flightlist", property.icaoAlternate, flightlistParameters)[0]?.value ?? "";

    // rescue equipment
    let estring = "";
    if (acft.emergRadio.elt) estring = "E";

    let ustring = "";
    if (acft.emergRadio.uhf) ustring = "U";

    let vstring = "";
    if (acft.emergRadio.vhf) vstring = "V";

    let emerEqu = "-R/" + estring + ustring + vstring;
    if (acft.emergRadio.vhf == false && acft.emergRadio.uhf == false && acft.emergRadio.vhf == false) {
      emerEqu = "";
    }

    // handle remarks DEP/ und DEST/
    let rmkDepAppendix = "";

    let coords = getParameterOfArray(flightId, "flightlist", property.originCoords, flightlistParameters);

    if (originName.trim() == "ZZZZ") {
      const q = new navLogReport(classCom);
      const origin = await q.nearestAirportHeliport(JSON.parse(coords[0].value), acft, 100);

      if (origin.length > 0) {
        originName = origin[0].txtName;
      } else {
        originName = "MISSION SITE";
      }
    }

    // always append coordinates as api handles that
    rmkDepAppendix =
      "DEP/" +
      originName.toUpperCase().replace(/[^0-9A-Z +]/g, "") +
      " " +
      translateToFplCoordinates(coords[0].value).replace(/[^0-9A-Z +]/g, "") +
      " ";

    let rmkArrAppendix = "";

    coords = getParameterOfArray(flightId, "flightlist", property.destinationCoords, flightlistParameters);

    if (destName.trim() == "ZZZZ") {
      const q = new navLogReport(classCom);
      const dest = await q.nearestAirportHeliport(JSON.parse(coords[0].value), acft, 100);

      if (dest.length > 0) {
        destName = dest[0].txtName;
      } else {
        destName = "MISSION SITE";
      }
    }

    // always append coordinates as api handles that
    rmkArrAppendix =
      "DEST/" +
      destName.toUpperCase().replace(/[^0-9A-Z +]/g, "") +
      " " +
      translateToFplCoordinates(coords[0].value).replace(/[^0-9A-Z +]/g, "") +
      " ";

    // debug
    // rmkArrAppendix = ""

    coords = getParameterOfArray(flightId, "flightlist", property.alternateCoords, flightlistParameters);
    if (coords.length > 0) {
      alt = "";
    }

    // append DOF and REG
    const depTimeRaw = getParameterOfArray(flightId, "flightlist", property.estTimeDep, flightlistParameters)[0]?.value;
    const depTime = new Date(depTimeRaw !== undefined ? parseInt(depTimeRaw) : 0);
    const depDate = new Date(
      new Date(depTime).getUTCFullYear(),
      new Date(depTime).getUTCMonth(),
      new Date(depTime).getUTCDate(),
      new Date(depTime).getUTCHours()
    );

    const dof = "DOF/" + this.fplFormatDate(depDate).replace(/[^0-9A-Z +]/g, "") + " ";

    // remks
    const fplRemarksRaw =
      getParameterOfArray(flightId, "flightlist", property.fplRemarks, flightlistParameters)[0]?.value ?? "";
    const remarks: string = dof + reg + rmkDepAppendix + rmkArrAppendix + fplRemarksRaw.replace(/[^/0-9A-Z +]/g, "");

    // fpl endurance
    let endurance = "";
    try {
      const endur =
        getParameterOfArray(flightId, "flightlist", property.fplEndurance, flightlistParameters)[0]?.value ?? "";
      endurance = "E/" + endur.replace(/[^0-9 +]/g, "");
    } catch (err) {
      /* empty */
    }

    // todo
    fplStr = fplStr.replace("{flightnumber}", flightMainList.flightNumber.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{flightrules}", flightrules.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{typeOfFlight}", typeOfFlight.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{aircraftType}", acftType.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{wakeTurbCat}", wkturb.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{equipment}", equipment.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{transponder}", transponder.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{icaoOrigin}", origin.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{etd}", etd.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{speedRef}", speedRef.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{crusingSpeed}", speed.toString().replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{levelRef}", levelRef.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{levelVal}", level.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{route}", route.replace(/[^0-9A-Z +]/g, ""));
    fplStr = fplStr.replace("{icaoDest}", dest.replace(/[^0-9A-Z +]/g, ""));
    ((fplStr = fplStr.replace("{totalEet}", ete_fpl.replace(/[^0-9A-Z +]/g, ""))),
      (fplStr = fplStr.replace("{icaoAlternate}", alt.replace(/[^0-9A-Z +]/g, ""))));
    fplStr = fplStr.replace("{remarks}", remarks);

    fplStr = fplStr.replace("{endurance}", endurance);
    fplStr = fplStr.replace("{personsAboard}", personsAboard.toString().replace(/[^0-9]/g, ""));
    fplStr = fplStr.replace("{emerEquipment}", emerEqu);

    fplStrFormatted = fplStrFormatted.replace(
      "{flightnumber}",
      flightMainList.flightNumber.replace(/[^0-9A-Z +]/g, "")
    );
    fplStrFormatted = fplStrFormatted.replace("{flightrules}", flightrules.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{typeOfFlight}", typeOfFlight.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{aircraftType}", acftType.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{wakeTurbCat}", wkturb.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{equipment}", equipment.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{transponder}", transponder.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{icaoOrigin}", origin.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{etd}", etd.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{speedRef}", speedRef.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{crusingSpeed}", speed.toString().replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{levelRef}", levelRef.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{levelVal}", level.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{route}", route.replace(/[^0-9A-Z +]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{icaoDest}", dest.replace(/[^0-9A-Z +]/g, ""));
    ((fplStrFormatted = fplStrFormatted.replace("{totalEet}", ete_fpl.replace(/[^0-9A-Z +]/g, ""))),
      (fplStrFormatted = fplStrFormatted.replace("{icaoAlternate}", alt.replace(/[^0-9A-Z +]/g, ""))));
    fplStrFormatted = fplStrFormatted.replace("{remarks}", remarks);

    fplStrFormatted = fplStrFormatted.replace("{endurance}", endurance);
    fplStrFormatted = fplStrFormatted.replace("{personsAboard}", personsAboard.toString().replace(/[^0-9]/g, ""));
    fplStrFormatted = fplStrFormatted.replace("{emerEquipment}", emerEqu);

    return { raw: fplStr, formatted: fplStrFormatted };
  }

  public fixShortWaypointnames(inRoute: string): string {
    const lst: string[] = inRoute.split(" ");
    let resRte: string = "";

    for (let index = 0; index < lst.length; index++) {
      resRte += this.replaceSingleCharNames(lst[index]) + " ";
    }

    return resRte;
  }

  public replaceSingleCharNames(inStr: string): string {
    if (inStr.length == 0) return "";
    if (inStr.length > 2) return inStr;

    const diffLen: number = inStr.length - 1;

    let suffix: number = 0;
    let suffixString: string = "";
    if (diffLen > 0) {
      suffix = parseInt(inStr[1]);

      if (Number.isNaN(suffix)) {
        return ""; // clear that part of the route
      } else {
        suffixString = suffix.toString();
      }
    }

    if (inStr.length < 3) {
      inStr = inStr.toUpperCase();
      if (inStr[0] == "A") return "ALPHA" + suffixString;
      if (inStr[0] == "B") return "BRAVO" + suffixString;
      if (inStr[0] == "C") return "CHARLIE" + suffixString;
      if (inStr[0] == "D") return "DELTA" + suffixString;
      if (inStr[0] == "E") return "ECHO" + suffixString;
      if (inStr[0] == "F") return "FOXTROTT" + suffixString;
      if (inStr[0] == "G") return "GOLF" + suffixString;
      if (inStr[0] == "H") return "HOTEL" + suffixString;
      if (inStr[0] == "I") return "INDIA" + suffixString;
      if (inStr[0] == "J") return "JULIETTE" + suffixString;
      if (inStr[0] == "K") return "KILO" + suffixString;
      if (inStr[0] == "L") return "LIMA" + suffixString;
      if (inStr[0] == "M") return "MIKE" + suffixString;
      if (inStr[0] == "N") return "NOVEMBER" + suffixString;
      if (inStr[0] == "O") return "OSCAR" + suffixString;
      if (inStr[0] == "P") return "PAPA" + suffixString;
      if (inStr[0] == "Q") return "QUEBEK" + suffixString;
      if (inStr[0] == "R") return "ROMEO" + suffixString;
      if (inStr[0] == "S") return "SIERRA" + suffixString;
      if (inStr[0] == "T") return "TANGO" + suffixString;
      if (inStr[0] == "U") return "UNIFORM" + suffixString;
      if (inStr[0] == "V") return "VICTOR" + suffixString;
      if (inStr[0] == "W") return "WHISKEY" + suffixString;
      if (inStr[0] == "X") return "XRAY" + suffixString;
      if (inStr[0] == "Y") return "YANKEE" + suffixString;
      if (inStr[0] == "Z") return "ZULU" + suffixString;
    } else {
      return inStr;
    }

    return "";
  }

  fplFormatTime(date) {
    date = this.convertUTCDateToLocalDate(date);

    return this.pad(date.getHours(), 2) + this.pad(date.getMinutes(), 2);
  }
  fplFormatDate(date) {
    const year = date.getFullYear();
    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return year.toString().substr(-2) + month + day;
  }

  convertUTCDateToLocalDate(datef: Date): Date {
    const n = new Date().getTimezoneOffset();
    const d1 = new Date(datef.getTime());
    const d2 = new Date(d1);
    d2.setMinutes(d1.getMinutes() + n);

    return d2;
  }
  pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }
}
